let book3 = [];
book3[0] = [
  {
    name: "New words",
    children: [
      {
        word: "commencement",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7c2c727069cf7824eb2ea1894a929a3ccf2d186e_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kəˈmensmənt/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) [C, U]  a ceremony at which university, college, or high school students receive their diplomas（大学或高中的）毕业典礼",
                example:
                  " The high school commencement speaker was giving a rather inspiring address.",
              },
              {
                explanation: "2) [U] the beginning of sth. 开始；开端",
                example:
                  "Would passengers please turn off their mobile phones before the commencement of the flight?",
              },
            ],
          },
        ],
      },
      {
        word: "faculty",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6f33d2591d8df6356ec3f133ff25fec19aebdd28_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfæklti/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) [C, U]  all the teachers in a university （大学的）全体教员",
                example:
                  " A drop in enrollment will affect students, faculty, and administrators.",
              },
              {
                explanation:
                  "2) [C] a department or group of related departments within a university 系；部；院",
                example:
                  "These plans were part of a reorganization that divided the university into six faculties.",
              },
            ],
          },
        ],
      },
      {
        word: "confront",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/72d049e726620696e4a41b99ca502af312e812fe_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kənˈfrʌnt/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) deal with a problem or difficult situation 处理，解决（问题或困境）",
                example:
                  " You must confront your fears and doubts and take risks again and again",
              },
              {
                explanation:
                  "2) (of a problem or difficult situation) appear and need to be dealt with by sb. （问题或困境）临到···头上；使面对",
                example:
                  "Here are some problems that have confronted scientists all over the world in the past decade.",
              },
            ],
          },
        ],
      },
      {
        word: "quitter",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1e0e3d4ce5e894c7b5eb8141c0ba6714cadf3ab6_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkwɪtə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C]  sb. who does not have the determination or courage to finish sth. that is difficult 遇到困难就放弃的人；半途而废的人",
                example:
                  "I have asked you to do this tough task because I know you are not a quitter.",
              },
            ],
          },
        ],
      },
      {
        word: "mediocre",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/cec8c92eb3d44773cc00ca1f24c352de4e52ff9f_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌmiːdiˈəʊkə/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "not very good 不太好的",
                example:
                  " Tourists crowd the gift shops along the street to buy mediocre products at high prices.",
              },
            ],
          },
        ],
      },
      {
        word: "slipshod",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/dc5ad7d65698f1b4ea4f274da2e9a440c03ad9c3_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈslɪpˌʃɒd/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "done too quickly and carelessly — used to show disapproval 马虎的，随便的，草率的（含贬义）",
                example:
                  "She complained that the research project was delayed mainly due to slipshod management.",
              },
            ],
          },
        ],
      },
      {
        word: "forgiving",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/372ed24072e744528f41d6627110505542409001_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/fəˈgɪvɪŋ/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "willing to forgive 宽容的；宽大的",
                example:
                  "The public was more forgiving of the president's mistakes than the press and fellow politicians.",
              },
            ],
          },
        ],
      },
      {
        word: "deadline",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3c74ffdc4309933ad8c5c6fba12814648295ab29_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈdedˌlaɪn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a date or time by which you have to do or complete sth. 截止时间；最后期限",
                example:
                  "Without extra help, it's going to be very difficult for us to meet the Friday deadline.",
              },
            ],
          },
        ],
      },
      {
        word: "garrulous",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b9b6fa968605dc8f13ee1ef1a6d032a693f09995_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈgærʊləs/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "talking too much, esp. about unimportant things （尤指对琐事）喋喋不休的，饶舌的",
                example:
                  "I had talked too much about myself and felt like a garrulous old fool.",
              },
            ],
          },
        ],
      },
      {
        word: "toss",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b06ebd006a250eae442f070612d208df8b76a281_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/tɒs/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "throw sth., esp. sth. light, with a quick gentle movement of your hand 扔，掷，抛（尤指轻的东西）",
                example:
                  "She picked up the package and casually tossed it into her handbag.",
              },
            ],
          },
        ],
      },
      {
        word: "dull",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c717ef744522250eec23fc36cefe1032fa269f3b_96k.mp3#duration=1.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dʌl/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "1) slow in understanding; stupid 迟钝的；愚笨的",
                example:
                  "It's such a simple question. If you don't understand then you are duller than I thought.",
              },
              {
                explanation:
                  "2) not interesting or exciting 无趣味的；不刺激的；不生动的",
                example:
                  "The documentary lasts for more than two-and-a-half hours, and there is scarcely a dull minute.",
              },
            ],
          },
        ],
      },
      {
        word: "unimaginative",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/378e5e5d5db738e880d974e0657d2893d8d469e9_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌʌnɪˈmædʒɪnətɪv/【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "not new, original, or clever; not showing any imagination 无创意的；缺乏想象力的",
                example:
                  "He simply couldn't understand why she thought him to be a stiff and unimaginative person.",
              },
            ],
          },
        ],
      },
      {
        word: "fantasy",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4bb164929a872b3340408e40375cdd7159b31a13_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfæntəsɪ/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C, U] an exciting and unusual experience or situation that you imagine happening to you, but which will probably never happen 幻想；想象",
                example:
                  "Young children sometimes cannot distinguish between fantasy and reality.",
              },
            ],
          },
        ],
      },
      {
        word: "pretense",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/41f61568f9873e6d07a21708e172407c966c9091_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/prɪˈtens/【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "a way of behaving which is intended to make people believe sth. that is not true 假装；作假；做作",
                example:
                  "Now that the pretense was over, he could tell them what he really thought.",
              },
            ],
          },
        ],
      },
      {
        word: "conventional",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/015caf926c40713513456481ebcb6072fe1b4691_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kənˈvenʃn(ə)l/【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "following what is traditional or the way sth. has been done for a long time 依照传统的；符合习俗的",
                example:
                  "It's not a hotel, in the conventional sense, but rather a whole village turned into a hotel.",
              },
            ],
          },
        ],
      },
      {
        word: "deprive",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c78864d7d5267cebee3ca5ff047d0e55abd40af6_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪˈpraɪv/【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "prevent sb. from having sth., esp. sth. that they need or should have 剥夺",
                example:
                  "Some people worry that the advances in information technology may deprive citizens of their privacy.",
              },
            ],
          },
        ],
      },
      {
        word: "adequate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/0ff1c7a3b0ac91ca4889782b5a09ca4954e11e49_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈædɪkwət/【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "enough in quantity or of a good enough quality for a particular purpose 足够的；充分的；合乎需要的",
                example:
                  "The lunchtime menu is more than adequate to satisfy the biggest appetite.",
              },
            ],
          },
        ],
      },
      {
        word: "attentive",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a9a6efd4ac1cefe1469edb016644668f7b4c6a21_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈtentɪv/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) helpful; making sure that people have what they need 关心的；肯帮忙的",
                example:
                  "It is an excellent childcare center for small babies as the staff are friendly, relaxed and attentive.",
              },
              {
                explanation:
                  "2) listening or watching carefully and with interest 注意的；留心的；专心的",
                example:
                  " People who watch news tend to be more attentive to what is on the screen.",
              },
            ],
          },
        ],
      },
      {
        word: "co-worker",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/59a96d6a7bff35c3694b0fe5bd134beacfb20814_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkəʊˌwɜːkə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] sb. who works with you and has a similar position 同事；同僚",
                example:
                  "explains what to do if a co-worker is injured and in need of medical attention.",
              },
            ],
          },
        ],
      },
      {
        word: "insult",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/dcf76ca95918852a68644a842938e4f62504e7ca_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈsʌlt/【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "offend sb. by saying or doing sth. they think is rude 侮辱；冒犯",
                example:
                  "In some cultures, you insult your host if you do not accept their offer of food.",
              },
            ],
          },
        ],
      },
      {
        word: "parlous",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2da4e934e5aedfab9642ad5632274c95c02ea698_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈpɑːləs/【a.】",
            explanations_and_examples: [
              {
                explanation:
                  " in a very bad or dangerous condition 状况极坏的；非常危险的",
                example:
                  "Relations between the two countries have been in a parlous state for some time.",
              },
            ],
          },
        ],
      },
      {
        word: "tolerate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4e4f34f06bc2f44ae6781aab9c4ca96eb25dc337_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈtɒləˌreɪt/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) allow people to do, say, or believe sth. without criticizing or punishing them 容忍；宽容",
                example:
                  "According to the spokesperson, the government is not prepared to tolerate the situation any longer.",
              },
              {
                explanation:
                  "2) be able to accept sth. unpleasant or difficult, even though you do not like it 忍受；忍耐",
                example:
                  "For years the workers have had to tolerate low wages and terrible working conditions.",
              },
            ],
          },
        ],
      },
      {
        word: "adolescent",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/dd1fb01ca715fd229f32722d52ae62c6283059e0_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌædəˈlesnt/【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a young person, usu. between the ages of 12 and 18, who is developing into an adult 青少年（常指12至18岁之间的人）",
                example:
                  "We know that adolescents are neither children nor adults and they have specific developmental needs.",
              },
            ],
          },
        ],
      },
      {
        word: "unlearn",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/aa819e9e369d52152567e5dce939beba885395ab_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ʌnˈlɜːn/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "deliberately forget sth. you have learned, in order to change the way you do sth. 设法忘记，抛弃（已学会的东西）",
                example:
                  "You must start by unlearning all the bad habits your previous piano teacher taught you!",
              },
            ],
          },
        ],
      },
      {
        word: "preparatory",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8e4def636c84b9db1058281a44bdb787a86fc45a_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/prɪˈpærətɔːri/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "done in order to get ready for sth. 预备的；准备的",
                example:
                  "Months of preparatory work needs to be done before construction work can really begin.",
              },
            ],
          },
        ],
      },
      {
        word: "formulate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1151633719fdf26e44186804f312dda17de2071c_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfɔːmjʊˌleɪt/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) think carefully about what to say, and say it clearly 仔细思考并明确表达",
                example:
                  "She has lots of good ideas, but she has difficulty formulating them in front of investors.",
              },
              {
                explanation:
                  "2) develop sth. such as a plan or a set of rules, and decide all the details of how it will be done 规划；制定；准备",
                example:
                  "The city government is currently formulating policies on road expansion to solve traffic problems.",
              },
            ],
          },
        ],
      },
      {
        word: "tolerant",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/01e52c06c4e17822af443b6e31193d703a815f63_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈtɒlərənt/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "allowing people to do, say, or believe what they want without criticizing or punishing them 宽容的；容忍的",
                example:
                  "My friends are more tolerant, more willing to accept me for what I am.",
              },
            ],
          },
        ],
      },
      {
        word: "triple",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4bbca59b5536deaa36f415454bea1c5892583e27_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈtrɪpl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  " 1)having three parts or involving three people, groups, events, etc. 有三部分的；涉及三方的",
                example:
                  "In 1882, Germany, Austria-Hungary, and Italy formed the Triple Alliance.",
              },
              {
                explanation:
                  "increase by three times as much, or make sth. do this （使）成为三倍；（使）增加两倍",
                example:
                  "The workforce has nearly tripled in size since the new factory opened last year.",
              },
            ],
          },
        ],
      },
      {
        word: "broaden",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e6e466a13cd905da7394521a1209cba5efa96685_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈbrɔːdn/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "increase sth. such as your knowledge, experience, or range of activities 增长（知识、经验等）；扩大（活动范围等）",
                example:
                  "The course helps school-leavers broaden their knowledge of the world of work.",
              },
            ],
          },
        ],
      },
      {
        word: "supposedly",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/707437ec1e2ca094322eaeb8d1462a78c57d494e_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/səˈpəʊzɪdli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "used when saying what many people say or believe is true, esp. when you disagree with them 据说；据称；一般相信；一般看来",
                example:
                  "He was supposedly delivering some papers to her but I think it was just an excuse to see her.",
              },
            ],
          },
        ],
      },
      {
        word: "erase",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/02ff94f0b7f5a92627dc2e4011c0d56aae0fa6c3_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪˈreɪs/ 【vt.】",
            explanations_and_examples: [
              {
                explanation: "1) remove sth. completely 清除；消除；消灭",
                example:
                  "Mr. Woods wants a convincing victory to erase doubts about his team's ability.",
              },
              {
                explanation:
                  "2) remove information from a computer memory or recorded sounds from a tape 删除（计算机文件）；抹去（磁带录音）",
                example:
                  "It appears the names were accidentally erased from the computer hard drive.",
              },
            ],
          },
        ],
      },
      {
        word: "semester",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/584f6642d2400b645f7507cc7ac4b4a83874bcff_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/səˈmestə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] one of the two periods of time that a year at high schools and universities is divided into, esp. in the US（尤指美国中学和大学的）一学期，半学年",
                example:
                  "I was finishing my last semester in college and trying to look for a job in my hometown.",
              },
            ],
          },
        ],
      },
      {
        word: "midterm",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b9c4dccdc214a71ba44dc67e143a304fc1407ded_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌmidˈtɜːm/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1)a test that students take in the middle of a semester or quarter 期中考试 2) [U] the middle period of an elected government's time in power （政府任期的）中期",
                example:
                  "A commitment to making reforms to the care system will form part of tomorrow's midterm progress report.",
              },
            ],
          },
        ],
      },
      {
        word: "final",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9ace5280007b1750a1cd578bda10282d2a47f469_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfaɪnl/ 【n.[C]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) (AmE) an important test that you take at the end of a particular class in high school or college（高中或大学的）期终考试2) the last and most important game, race, or set of games in a competition 决赛",
                example:
                  "He's through to the men's tennis final for the first time in his career.",
              },
            ],
          },
        ],
      },
      {
        word: "due",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f011f9a2ba64a779f77b61090b56e14c3930f13c_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/djuː/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "expected to happen or arrive at a particular time 预定的；预期发生（到达）的",
                example:
                  " They suddenly give up the deal the day before they were due to sign the contract.",
              },
            ],
          },
        ],
      },
      {
        word: "wicker",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b5da7bac678781776ebc3d5a7b2c2748a42e5588_96k.mp3#duration=1.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈwɪkə/ 【n.】",
            explanations_and_examples: [
              {
                explanation: " [C] 干枝条；干柳条；芦苇杆",
              },
            ],
          },
        ],
      },
      {
        word: "grumpy",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/eb038ed8e8bea99c1cc920e67d6bfd0ab4554b01_96k.mp3#duration=1.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈgrʌmpi/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  " bad-tempered and easily annoyed 脾气坏的；易怒的",
                example:
                  " I have not had enough sleep lately and is feeling kind of grumpy.",
              },
            ],
          },
        ],
      },
      {
        word: "visualize",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/0250e8afc833e097d0da003bd37bc4f5245fe7bb_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈvɪʒʊəˌlaɪz/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  " form a picture of sb. / sth. in your mind 设想；想象",
                example:
                  " An architect can look at a drawing and visualize a three-dimensional shape.",
              },
            ],
          },
        ],
      },
      {
        word: "assignment",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e841d9fb4c44a4d8d9f57f677438ad1ff3379364_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈsaɪnmənt/ 【 n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) [C] a piece of work that a student is asked to do （学生的）作业",
                example:
                  "Students will need to complete three written assignments this semester.",
              },
              {
                explanation:
                  "2) [C, U] a piece of work that is given to sb. as part of their job （分配的）任务",
                example:
                  "She told me that she will be in Greece next week on assignment for one of the national newspapers.",
              },
            ],
          },
        ],
      },
      {
        word: "jeer",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1f35794acce3aafbeadc3be8c9fe0c8073f0d7cd_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dʒɪə/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "laugh at sb. or shout rude remarks at them to show that you do not respect them 嘲笑；嘲弄",
                example:
                  " After the match, the disappointed fans were all jeering at the football team.",
              },
            ],
          },
        ],
      },
      {
        word: "stun",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f5574f513c2f1c57d9acfb9940d705075214fdbe_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/stʌn/ 【 vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "surprise or upset sb. so much that they do not react immediately 使（某人）震惊",
                example:
                  "Sasha was too stunned by what had happened in the office to say a word.",
              },
            ],
          },
        ],
      },
      {
        word: "proceed",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d214c66db6055fb92340a119fe6a782a4cbeff8f_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/prəˈsiːd/ 【 vi.】",
            explanations_and_examples: [
              {
                explanation:
                  " continue doing sth. that has already been started; continue being done 继续进行；继续做",
                example:
                  "The discussions between the two firms are proceeding slowly but satisfactorily.",
              },
            ],
          },
        ],
      },
      {
        word: "arch",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/38d12a7457ebb4ad5d76c9de1aeec09fddb99a5d_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɑːtʃ/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "form or make sth. form a curved shape（使）拱起；（使）成拱形",
                example: "His eyebrows arched as if he were angry.",
              },
            ],
          },
        ],
      },
      {
        word: "eyebrow",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/5bf0e61b10285efd369245bfa9947273922de88f_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈaɪbraʊ/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] 眉（毛）",
              },
            ],
          },
        ],
      },
      {
        word: "shrug",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2da0a30a74b17e4efc18f42db0922b855b32a3b6_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ʃrʌg/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "raise one's shoulders slightly to express doubt, indifference, ignorance, etc. 耸（肩）（以示怀疑、 与己无关、不知道等）",
                example:
                  "He shrugged his shoulders as if to say that there was nothing he could do about it.",
              },
            ],
          },
        ],
      },
      {
        word: "slum",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3a18df1ac96563675902e76d6b94120016a598d2_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dʌl/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a house or an area of a city that is in very bad condition, where very poor people live （城市中的）贫民窟，贫民区",
                example:
                  "My friend Bobby lives with his three sisters in a slum near the city center, but he doesn't lose faith in life.",
              },
            ],
          },
        ],
      },
      {
        word: "marketable",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/700404fabd9c8ed6a8d40178c2bf2c4fabbde6d3_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmɑːkɪtəbl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "marketable goods, skills, etc. can be sold easily because people want them （商品、技能等）有市场的，有销路的，畅销的",
                example:
                  "The program is designed to provide students with real, marketable skills.",
              },
            ],
          },
        ],
      },
      {
        word: "smug",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6f329905202c361088c1bbf30e57ad7241ad9b06_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/smʌg/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "showing too much satisfaction with your own cleverness or success — used to show disapproval 自满的，自鸣得意的，沾沾自喜的（含贬义）",
                example:
                  "Peter was wearing an unbearably smug expression and waving the tickets in front of me.",
              },
            ],
          },
        ],
      },
      {
        word: "leer",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/01e2ed981d3ce23089fb60faafdda946dc37fa3f_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/lɪə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] an unpleasant look suggesting lust or ill will 挑逗性的或不怀好意的目光",
                example: "He has a most unpleasant leer.",
              },
            ],
          },
        ],
      },
      {
        word: "dimension",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c03f1badfcdc25dd5157e5d5bca0d182211c0141_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/daɪˈmenʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "the length, height, width, depth or diameter of sth. 大小；尺寸",
                example:
                  "It is important to measure the exact dimensions of the room before buying furniture.",
              },
              {
                explanation:
                  "2) a part of a situation or a quality involved in it （形势或品质的）方面，层面",
                example:
                  "You can have a spiritual dimension to your life without being religious.",
              },
            ],
          },
        ],
      },
      {
        word: "contemplate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/79bdcd8c386c564d60a681266eb0e6e38790862b_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkɒntəmˌpleɪt/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "think about sth. seriously for a period of time 深思；细想",
                example:
                  "As he lay in his hospital bed that night, he cried as he contemplated his future.",
              },
              {
                explanation:
                  "think about sth. that you might do in the future 打算；想；考虑",
                example:
                  "Many years ago he had contemplated writing a book about his childhood.",
              },
            ],
          },
        ],
      },
      {
        word: "warehouse",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b44dbd08c9019484aa429849053a72479d348854_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈweəˌhaʊs/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "a large building for storing large quantities of goods 仓库；货栈",
                example:
                  "Police are investigating a fire at a furniture warehouse.",
              },
            ],
          },
        ],
      },
      {
        word: "grain",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/98708b4821f0a9b22fdc312a0f3ee9b26cfec78d_96k.mp3#duration=1.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/greɪn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "1) [C] a single seed of corn, wheat, etc. 谷粒",
                example:
                  "Mum must have left in a hurry, since there were quite a few grains of corn left on the floor.",
              },
              {
                explanation:
                  "2) [U] the seeds of crops such as corn, wheat or rice that are gathered for use as food, or these crops themselves 谷物；粮食",
                example:
                  " The government intends to import only five percent of the country's grain.",
              },
            ],
          },
        ],
      },
      {
        word: "industrial",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/cfb5e80f69499cc13508bc62ecdaeb39795090a6_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈdʌstriəl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "relating to industry or the people working in it 工业的；产业工人的",
                example:
                  "Reports showed industrial production rose 1.3 percent in November from the month before.",
              },
            ],
          },
        ],
      },
      {
        word: "revenue",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6242880e8bf63654389a0b6ec96b11ac17faaf2e_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈrevəˌnjuː/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "money that a business or organization receives over a period of time, esp. from selling goods or services （公司、机构的）收益，收入",
                example:
                  "These companies are sure to encounter financial trouble if they only rely on advertising revenue for their funds.",
              },
            ],
          },
        ],
      },
      {
        word: "exterminator",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1a85015c17e5d81b5d6202ce5a25c0bca139772b_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪkˈstɜːmɪˌneɪtə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "  a person whose job is to kill animals such as rats or mice, because they are annoying or dangerous 职业的消灭害虫者",
                example:
                  "Can you believe that nearly one hundred million rats are killed each year by pest exterminators?",
              },
            ],
          },
        ],
      },
      {
        word: "feasible",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d73233b305cd348b05fc753efa8a05b2f8699a7c_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfiːzəbl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "a plan, idea, or method that is feasible is possible and is likely to work （计划、想法或方法）可行的，可实行的，行得通的",
                example:
                  "It was no longer financially feasible to keep the community center open.",
              },
            ],
          },
        ],
      },
      {
        word: "glare",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/41bcf090939491efcd5211b904ac5ec409bfa86c_96k.mp3#duration=1.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/gleə/ 【vi.】",
            explanations_and_examples: [
              {
                explanation: "look angrily at sb. for a long time 怒目而视",
                example:
                  "Noah was furious at what I just said but he didn't shout and just glared at me silently.",
              },
            ],
          },
        ],
      },
      {
        word: "pointedly",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8c8d25b4ed329a2bd22ec00635a14009d9eba83d_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈpɔɪntɪdli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "in a way that is deliberately meant to show that you are annoyed, bored, or disapprove of sth. 明确地；尖锐地；直言不讳地",
                example:
                  "Miss Phillips looked at the clock pointedly and I realized that it was time for me to leave.",
              },
            ],
          },
        ],
      },
      {
        word: "groan",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a40fd963b83ded72cc242b7c3336ab573dc8322e_96k.mp3#duration=0.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "/grəʊn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: " 1)a complaint 抱怨",
                example:
                  "They've got the usual moans and groans like everybody else.",
              },
              {
                explanation:
                  "2)a long deep sound that you make when you are in pain or do not want to do sth. （疼痛时的）呻吟；（不愿做某事时的）哼哼声",
                example:
                  "The rescuers could hear the groans of someone trapped in the ruins.",
              },
            ],
          },
        ],
      },
      {
        word: "audible",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/231ed8756dd597031a65c6ebdca77a12026d4f1a_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɔːdəbl/ 【 a.】",
            explanations_and_examples: [
              {
                explanation: "loud enough for you to hear it 听得见的",
                example:
                  " His voice was barely audible above the noise of the crowd.",
              },
            ],
          },
        ],
      },
      {
        word: "interrupt",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/690d3de8aca1b25cc638de4718bebcb116c83b53_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌɪntəˈrʌpt/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "stop sb. from continuing what they are saying or doing by suddenly speaking to them, making a noise, etc. 打断某人的讲话；中断某人的行动；打扰",
                example:
                  " I'm sorry to interrupt your meeting, but may I speak to Michael for a moment?",
              },
            ],
          },
        ],
      },
      {
        word: "slam dunk",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/55f0c73aea2f5d243f858adbd2a92b18b896b531_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈslæm ˌdʌŋk/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " 1) sth. that is certain to be successful 稳操胜券的事",
                example:
                  "His new movie is predicted by many critics to be this season's slam dunk hit.",
              },
              {
                explanation:
                  "2) (in basketball) the act of jumping up and putting the ball through the net with a lot of force 强力灌篮；扣篮",
                example:
                  "He marked his first appearance with a slam dunk for his first points.",
              },
            ],
          },
        ],
      },
      {
        word: "verbatim",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/71f95e8f914d9e89fc316a832b167a9fa54ee54c_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/vɜːˈbeɪtɪm/ 【a. & ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "repeating the actual words that were spoken or written 逐字的（地）；一字不差的（地）",
                example:
                  "The president's speeches are regularly reproduced verbatim in the state-run newspapers.",
              },
            ],
          },
        ],
      },
      {
        word: "rustle",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ae4d467f680123fd78d2c3d20d8fdbd1eee9a44b_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈrʌsl/ 【 v.】",
            explanations_and_examples: [
              {
                explanation:
                  "if leaves, papers, clothes, etc. rustle, or if you rustle them, they move about and make a soft, dry sound （使）（树叶、纸、衣物等）沙沙作响",
                example:
                  "A gentle breeze blew through the windows, lightly rustling the curtains.",
              },
            ],
          },
        ],
      },
      {
        word: "frantic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b16cf3b6f843edfa41f4d98ff386b6391683cad1_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfræntɪk/ 【 a.】",
            explanations_and_examples: [
              {
                explanation:
                  "done quickly and with a lot of activity, but in a way that is not very well organized 紧张忙乱的；手忙脚乱的",
                example:
                  "People were frantic, trying to call relatives after the earthquake.",
              },
            ],
          },
        ],
      },
      {
        word: "frantically",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f81fd9670049620ea8d07cbf7e0984385838e6fc_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfræntɪkli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "done in a hurried way and in a state of excitement or confusion 手忙脚乱地",
                example:
                  "I've been working frantically all week to get the term paper finished before the deadline.",
              },
            ],
          },
        ],
      },
      {
        word: "index",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7e2eb2e5f4f3cfdddd493febfe8d93283f060018_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɪndeks/ 【 n.】",
            explanations_and_examples: [
              {
                explanation:
                  "an alphabetical list of names, subjects, etc. at the back of a book, with the numbers of the pages where they can be found （书后的）索引",
                example:
                  "Look under B in the index to see if biology is covered in the book.",
              },
            ],
          },
        ],
      },
      {
        word: "oddly",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/43f9bd7e3119584e6bb258a0444722aeeec7380d_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɒdli/【 ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) (also  ~ enough ) used to say that sth. seems strange or surprising 奇怪的是；真奇怪",
                example:
                  "Oddly enough, someone asked me the same question yesterday.",
              },
              {
                explanation:
                  "2) in a strange or unusual way 奇怪地；古怪地；异常地",
                example:
                  "Didn't you think she was behaving very oddly at Susan's birthday party yesterday?",
              },
            ],
          },
        ],
      },
      {
        word: "vice versa",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/efc2d3beaf10ab30addeb47f81729cb6766bc6df_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌvaɪs ˈvɜːsə/ 【 ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "used to say the opposite of a situation you have just described is also true 反之亦然",
                example:
                  "  He refuses to believe anything they say and vice versa.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Phrases and expressions",
    children: [
      {
        word: "drop out",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/44abeff063ae5191ff5b6f6f13e81f73c573dbf7_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "leave a school or university before your course has finished 退学；辍学",
                example:
                  "To everyone's surprise, Bill dropped out of college after his first year and joined a rock and roll band.",
              },
            ],
          },
        ],
      },
      {
        word: "look back",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2b3ffd3d992da8228a30ccdd3fb079129713bfc9_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "think about sth. that happened in the past 回忆起；回顾",
                example:
                  "When you look back on this experience in a year or two, it won't seem so bad.",
              },
            ],
          },
        ],
      },
      {
        word: "the easy way out",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/dcf75a0ca32e38f80b4dbe590baaf5fc5c5b4c53_96k.mp3#duration=2.2&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "what is easiest in a difficult situation 省事的做法",
                example:
                  "It is the easy way out to blame others for our failure though it doesn't make any sense.",
              },
            ],
          },
        ],
      },
      {
        word: "act out",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/71aa093f4e0474392733a9bbdb066a1a75f46548_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "express your feelings about sth. through your behavior or actions, esp. when you have been feeling angry or nervous 用行动来表现（情绪，尤指愤怒或紧张）",
                example:
                  "These teenagers are likely to act out their feelings of insecurity by being moody and aggressive.",
              },
            ],
          },
        ],
      },
      {
        word: "be rid of",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2e9943a92dc64cac9361ee0cdae33495056c0b04_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "have taken action so that sb. / sth. is no longer there to worry or annoy you 摆脱某人 / 某事物",
                example:
                  "He found his job tedious and time-consuming and he was glad to be rid of it.",
              },
            ],
          },
        ],
      },
      {
        word: "pop into one's mind ",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/46f702b337e4df3e65f5618ffe0139ae5e86475f_96k.mp3#duration=5.7&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "suddenly think of sth. 突然冒出（想到）",
                example:
                  "List the product's strengths as well as weaknesses at random as they pop into your mind.",
              },
            ],
          },
        ],
      },
      {
        word: "get away with",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/30e5615ff3272ef2f72f2b2f925b5f7905ee209d_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  " not to be caught or punished when you have done sth. wrong （做错事）不被发现，不受惩罚",
                example:
                  "It's time they put a stop to his bad behavior. He's been getting away with it for too long.",
              },
            ],
          },
        ],
      },
      {
        word: "get down to",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7b041eca312fc83ecfd55e8b1f034a1c835dc8ba_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "start to direct your efforts and attention to sth., esp. work 开始认真对待；开始努力做",
                example:
                  "That's a tourism hotspot. I must get down to booking the hotel as soon as possible.",
              },
            ],
          },
        ],
      },
      {
        word: "by no means",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8bd9a2a530b94f84768b3a1d3d2c87f399089890_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "not at all 绝不；一点都不",
                example:
                  "It is by no means clear where the money is going to come from to fund this project.",
              },
            ],
          },
        ],
      },
      {
        word: "cut one's losses",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/29a599ec98f21d154a64e0b575903d53d27e6cd7_96k.mp3#duration=2.0&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "stop doing sth. that is failing, so that one does not waste any more money, time, or effort 及早脱手以减少损失",
                example:
                  "Cut your losses with projects that are not going to work and do things that make you feel comfortable.",
              },
            ],
          },
        ],
      },
      {
        word: "pack up",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f53da713c3be44650664e3ab005d3978c9309137_96k.mp3#duration=1.0&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "put your possessions into a bag, etc. before leaving a place （在离开前）收好物品",
                example:
                  "put your possessions into a bag, etc. before leaving a place （在离开前）收好物品",
              },
            ],
          },
        ],
      },
      {
        word: "smile broadly",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f91c2c17aa2f1d9e48012dfd7024853f9bf6b0ca_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "have a big smile on your face that clearly shows you are happy or amused 咧着嘴笑",
                example:
                  "He tiptoed closer, smiling broadly, waiting for Suzanne to spot him.",
              },
            ],
          },
        ],
      },
      {
        word: "cut into",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9b99db1dbddc252171569cb691f9473771d36ac5_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "make sth. less or smaller 削减",
                example:
                  "Some business owners are cutting into their profits to help raise money for the foundation.",
              },
            ],
          },
        ],
      },
      {
        word: "better stil",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/afbd94de02587c080633cb9b4ab0c6a2dac80db1_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "used to say that a particular choice would be more satisfactory 更好的选择是",
                example:
                  "I started to hunt for a cheap restaurant nearby or, better still, a snack shop.",
              },
            ],
          },
        ],
      },
      {
        word: "hand out ",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ec337b3d0118b8431e1b8ec5f9c917f89caaf6f4_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "give sth. to each person in a group 分发；散发",
                example:
                  "He was busy handing out leaflets on the musical to the audience.",
              },
            ],
          },
        ],
      },
      {
        word: "reason out",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c12c04e7d714201fac147f0e0393e73ffeca7a50_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "find an explanation or solution to a problem, by thinking all the possibilities （通过推理）解释，解决",
                example:
                  "I spent the entire night reasoning out the solution to the puzzle.",
              },
            ],
          },
        ],
      },
      {
        word: "think through",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d1c507376014cd28acc88c4b36d870132882bb98_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "think carefully about the possible results of sth. 认真地考虑（某事可能产生的结果）",
                example:
                  "People need time to think through what the changes in taxation will mean for them.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Proper names",
    children: [
      {
        word: "Brown",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3ac5c27751f3c504a937defb3839821e13529135_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "(Brown University) 布朗大学（美国大学，位于罗得岛州）",
              },
            ],
          },
        ],
      },
      {
        word: "Carter A. Daniel",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b0494a4edb2369395c400565b45de7fdb8043ea3_96k.mp3#duration=2.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈdænjəl/",
            explanations_and_examples: [
              {
                explanation: "卡特.A. 丹尼尔（人名）",
              },
            ],
          },
        ],
      },
      {
        word: "Rutgers University",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1e6a4a89a439f6d84e53a91bc7e125e1528ad860_96k.mp3#duration=2.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈrʌtgəz/",
            explanations_and_examples: [
              {
                explanation: "罗格斯大学（美国大学，位于新泽西州）",
              },
            ],
          },
        ],
      },
      {
        word: "Jack Wickert",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/eacd68b9137237898d630e8302d4d800f28d73e1_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈwɪkə(r)t/",
            explanations_and_examples: [
              {
                explanation: "杰克 维克特（人名）",
              },
            ],
          },
        ],
      },
    ],
  },
];

book3[1] = [
  {
    name: "New words",
    children: [
      {
        word: "casual",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2bc76b3a205a648d407eff009cebc6b5874f7a4f_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/'kæʒuəl/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "clothes or shoes suitable for everyday wear rather than formal occasions 便服；便装；便鞋",
                example:
                  "While the trend toward business casual is characterized by more comfort, for some, it means more confusion.",
              },
            ],
          },
        ],
      },
      {
        word: "headphones",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d3382d985e6218817fa73dc8aa9ede1952f41967_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/'hedˌfəʊnz/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "（头戴式）耳机",
                example: "",
              },
            ],
          },
        ],
      },
      {
        word: "corporate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9e78f657081bac60ac7fc360d0ca9b3abbd9f61c_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkɔːp(ə)rət/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  " belonging to or relating to a corporation 公司的",
                example:
                  "Owing to the shift of its strategic focus, the company is moving its corporate headquarters from New York to Houston.",
              },
            ],
          },
        ],
      },
      {
        word: "mortgage",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e50d3a6f7cbc2f98a2fd7ed295a5261abf818c2a_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/'mɔːgɪdʒ/【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " a legal arrangement by which you borrow money from a bank or similar organization in order to buy a house, etc. and pay back the money over a period of years 抵押贷款",
                example:
                  "Since she was having trouble meeting her mortgage payments, she was considering selling her apartment.",
              },
            ],
          },
        ],
      },
      {
        word: "time off",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/719230eae03bcd08ee1738114d63f62a6ef9df0d_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " time for rest or recreation away from the usual work or studies 休息（或休假）时间",
                example:
                  "You won't get paid for time off unless you have a doctor's note.",
              },
            ],
          },
        ],
      },
      {
        word: "headquarters",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/80ae81d25c15b87b8119961630a9fab80d901a1b_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌhedˈkwɔːtəz/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " the main building or offices used by a large company or organization 总部；总公司；总办事处",
                example:
                  "There are now 400 staff at headquarters, servicing our regional and overseas work.",
              },
            ],
          },
        ],
      },
      {
        word: "perk",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/40f3b6badc9b13778342fd5b789b30aa1dcc9fca_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/pɜːk/【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " sth. that you get legally from your work in addition to your wages, such as goods, meals, or a car （工资以外的）额外收入（待遇）；津贴",
                example:
                  "I eat all three meals per day, five days a week, in the company because they are free — one of the perks of the job.",
              },
            ],
          },
        ],
      },
      {
        word: "administrative",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a5aa7d401633be6f35e19c78b37e08a6a9341679_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ədˈmɪnɪstrətɪv/ 【a. 】",
            explanations_and_examples: [
              {
                explanation:
                  "relating to the work of managing a company ororganization 行政的；管理的",
                example:
                  "Even administrative regulations must be accompanied by persuasion and education.",
              },
            ],
          },
        ],
      },
      {
        word: "distributor",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a0e72e81ef10bf5d5680f6264fdef5e129ce018a_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪˈstrɪbjʊtə/ 【n. 】",
            explanations_and_examples: [
              {
                explanation:
                  " a company or person that supplies shops and companies with goods 分销商；经销商；批发商",
                example:
                  "Some US states require that foreign wines be shipped to an importer or distributor.",
              },
            ],
          },
        ],
      },
      {
        word: "liberal",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8d2cff10082d57a713c02c880eafa3a96809b1f7_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈlɪb(ə)rəl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) supporting or allowing gradual political and social changes （思想）开放的",
                example:
                  "The company has adopted a more liberal policy on the health care benefits of its employees.",
              },
              {
                explanation:
                  "2) willing to understand and respect other people's ideas, opinions, and feelings 思想开明的；开通的",
                example:
                  "People tend to be more liberal when they are young and more conservative as they grow older.",
              },
            ],
          },
        ],
      },
      {
        word: "blurred",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/57b941c286b7a51135ae659ea598b8c828009d49_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/blɜːd/【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "difficult to distinguish, so that differences are not clear 难以区分的；模棱两可的",
                example:
                  "The boundaries between history and storytelling are sometimes blurred.",
              },
            ],
          },
        ],
      },
      {
        word: "cubicle",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a5bcc43fc07fd567c657b12f21fbab507819da2e_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkjuːbɪkl/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "a small part of a room that is separated from the rest of the room 小隔间",
                example:
                  "The rules of cubicle etiquette exist in order to make the workplace a harmonious place.",
              },
            ],
          },
        ],
      },
      {
        word: "reinvent",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/78d5d20039ea7864c67547d7e0da9feec4a726be_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌriːɪnˈvent/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "change sth. so much that it appears to be entirely new 彻底改造；重新创造",
                example:
                  "It's wonderful, because this fresh start gives us a chance to reinvent our lives and ourselves.",
              },
            ],
          },
        ],
      },
      {
        word: "rat race",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/32c4931ca7196b15b9a9d23d3af8e67a3b18baa4_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[sing.] a way of life in which people compete aggressively to be successful 你死我活的竞争",
                example:
                  "I have to get out of the rat race and take a look at what I really want in the first place.",
              },
            ],
          },
        ],
      },
      {
        word: "hierarchy",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/43b16dfd3201fcb24978bad6db11fedf958ecc6b_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈhaɪəˌrɑːki/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " system of organization in which people or things are divided into levels of importance 等级制度",
                example:
                  "She worked her way up through the corporate hierarchy to become a member of the top management.",
              },
            ],
          },
        ],
      },
      {
        word: "flatten",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/23ec2cd88ae0250605bb1fc030c46b4a669fe3b3_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈflætn/ 【v. 】",
            explanations_and_examples: [
              {
                explanation:
                  " become or make sth. flat or flatter （使）变平；（使）变得更平",
                example:
                  "Martin flattened out a napkin and started to perform a magic which immediately engaged the kids.",
              },
            ],
          },
        ],
      },
      {
        word: "wizard",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/155107c129002209aad9a13fdb618926f5239fdb_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈwɪzəd/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "a man who is supposed to have magic powers; witch 男巫；术士",
              },
            ],
          },
        ],
      },
      {
        word: "ninja",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/de78e5ff1be1958c5d6f62aad260d22a17afc95f_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈnɪndʒə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "in the past, a Japanese fighter with special skills （旧时的）忍者，日本武士",
              },
            ],
          },
        ],
      },
      {
        word: "integration",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f70d1c3f8aeeb7d6681c682f4be8bb2173e3197c_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌɪntɪˈgreɪʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " the combining of two or more things so that they work together effectively 结合；整合",
                example:
                  "His music is an integration of tradition and new technology.",
              },
            ],
          },
        ],
      },
      {
        word: "acupuncture",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/10e5b15bd1a453d9116239099420d231ed224e4f_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈækjʊˌpʌŋktʃə/【n.】",
            explanations_and_examples: [
              {
                explanation: "针刺疗法",
              },
            ],
          },
        ],
      },
      {
        word: "nap",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d5eb7ecdbaf5456ae45e69af994407f117e2256b_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/næp/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " a short sleep, esp. during the day （尤指白天的）小睡，打盹",
                example:
                  "A midday nap may be a better way to cope with the mid-afternoon sleepiness than more nighttime sleep.",
              },
            ],
          },
        ],
      },
      {
        word: "pod",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a8b9241d1525edbb21131479f6720773ca2b5a0a_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/pɒd/ 【n. 】",
            explanations_and_examples: [
              {
                explanation: "（飞机的）吊舱，发射架",
              },
            ],
          },
        ],
      },
      {
        word: "nap pod",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/02628b256460ebd8f294d33e36bfc3c2917e4aad_96k.mp3#duration=2.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈnæpˌpɒd/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "小憩舱；打盹舱",
              },
            ],
          },
        ],
      },
      {
        word: "popularize",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/009eab6def24e0edc612f4f541948a16cf7b77f1_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈpɒpjʊləˌraɪz/【vt.】",
            explanations_and_examples: [
              {
                explanation: " make sth. well known or liked 宣传；推广",
                example:
                  "The musician collected and popularized many songs written by other groups.",
              },
            ],
          },
        ],
      },
      {
        word: "workforce",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2b6faf33030768c39d9e632f46034317a212fe26_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈwɜːkˌfɔːs/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "the total number of people who are employed by a particular company, industry, etc. 雇员总数",
                example:
                  "The factory's workforce has shrunk from over 4,000 to a few hundred.",
              },
            ],
          },
        ],
      },
      {
        word: "investigation",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/682dbcf36611b71c7c52eb068a44918284bb980a_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˌvestɪˈgeɪʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: " a formal inquiry or systematic study 调查",
                example:
                  "An investigation has been launched into the potential impact of the oil spill on marine life around the island.",
              },
            ],
          },
        ],
      },
      {
        word: "vocal",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b0940dd8551f4c2314f3d66c0bf1683929129f00_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈvəʊkl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "expressing strong opinions publicly, esp. about things that you disagree with 激烈地表达意见的；直言不讳的",
                example:
                  "Foley has been particularly vocal in his criticism of the social injustice he has witnessed in his country.",
              },
            ],
          },
        ],
      },
      {
        word: "opponent",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2d3c50b639e7f06f0a7410119a4a0be341d697fb_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈpəʊnənt/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " sb. who disagrees with or resists a proposal or practice 反对者",
                example:
                  "Leading opponents of the proposed increase in defense spending will meet later today.",
              },
            ],
          },
        ],
      },
      {
        word: "newsroom",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/0ced644846f9cbd33147e6bb112394aba7eedadc_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈnjuːzˌruːm/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " the area in a newspaper or broadcasting office where news is processed （报社、电台或电视台的）新闻编辑室",
                example:
                  "The best hours of Walter's life were not spent in a newsroom, but in pursuit of a worthy story.",
              },
            ],
          },
        ],
      },
      {
        word: "start-up",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/523854d31c6b1196ef5d912a18b66295f4f8154c_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈstɑːt ʌp/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " a new small company or business, esp. one whose work involves computers or the Internet （尤指从事计算机或因特网的小型的）新兴公司，新创办企业",
                example:
                  "For now the only bright spots in the labor market are small businesses and high-tech start-ups.",
              },
            ],
          },
        ],
      },
      {
        word: "parody",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c6c71ed5415b2a52f8f05915e4b9f8ce5581577b_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈpærədi/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " a piece of writing, music, etc. or an action that copies sb. / sth. in an amusing way （文章、音乐等的）滑稽模仿作品",
                example:
                  "Some stories from the TV series released by the local newspaper yesterday read like a parody.",
              },
            ],
          },
        ],
      },
      {
        word: "portrait",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2a4dadafd149a30d8a7e7c866dbe7fcbfa36d761_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/pɔːtreɪt/ 【n.[C]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) a description or representation of sth. （对某事物的）描绘，描述，表现",
                example:
                  "Her latest novel paints a very vivid portrait of the aristocracy in the 1920s, which has been a mystery to most readers.",
              },
              {
                explanation:
                  "2) a painting, drawing, or photograph of a person 人物画像；人物照片；肖像",
                example:
                  "Today, she is still considered one of the greatest portrait painters of her time.",
              },
            ],
          },
        ],
      },
      {
        word: "misdirection",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/60de1ec962b586724df2c2317505270747cff219_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌmɪsdɪˈrekʃn/【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "the action of making people pay attention to the wrong thing, usu. intentionally so that they will not notice sth. else 误导",
                example:
                  "The global debate on bank capital has been characterized by rumor and misdirection",
              },
            ],
          },
        ],
      },
      {
        word: "rotten",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/dbf9e9e3a2b4cdfaf7dfe03f3cf939b46ccea690_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈrɑːtn/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "1) (infml.) very bad 极糟的；恶劣的",
                example:
                  "I personally think it's a rotten idea to go camping on such a rainy day.",
              },
              {
                explanation:
                  "2) badly decayed and no longer good to use 腐烂的；变质的",
                example:
                  "Check stored fruit every week and throw out any that has started to go rotten.",
              },
            ],
          },
        ],
      },
      {
        word: "capitalism",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/cc6a8bcc9b0778d6e63ede1c6d935bab43b54cfd_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkæpɪtəˌlɪz(ə)m/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "an economic and political system in which a country's trade and industry are controlled by private owners for profit, rather than by the state 资本主义",
              },
            ],
          },
        ],
      },
      {
        word: "recast",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/714030950abec007252bab29decccf3c60e2d9d7_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/riːˈkɑːst/ 【vt.】",
            explanations_and_examples: [
              {
                explanation: "change the form of sth. 重塑；重组",
                example:
                  "She recast her novel as a musical comedy, which turned out to be a greater hit than the original work.",
              },
            ],
          },
        ],
      },
      {
        word: "workaholism",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7e23509f1439c08c62450bf71468c07e834755bf_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌwɜː(r)kəˈhɒlɪzəm/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "a condition that makes sb. work a lot of the time and find it difficult not to work 醉心工作；迷恋工作",
                example:
                  "She's witnessed a rise in workaholism in all job categories.",
              },
            ],
          },
        ],
      },
      {
        word: "unwind",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6c839fa928516174ed10242adeebaa5b9cff12f0_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ʌnˈwaɪnd/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "undo or be undone after winding or being wound （卷绕物）解绕 , 展开",
                example:
                  "She unwound her scarf after entering the house, and hung it on the rack in the corner.",
              },
            ],
          },
        ],
      },
      {
        word: "absurdity",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/0b4ac013e5ff6f368e1dc9b5432c40a28b756839_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əbˈsɜːdəti/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "the quality or state of being ridiculous or wildly unreasonable 荒谬；荒唐",
                example:
                  "Duncan shook his head and laughed at the absurdity of the situation.",
              },
            ],
          },
        ],
      },
      {
        word: "norm",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/193d0caedb8ef978b1431c64e01035910a22f67c_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/nɔːm/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " the usual or normal situation, way of doing sth., etc. 常态；规范；标准",
                example:
                  "Short-term contracts are now the norm with some big companies.",
              },
            ],
          },
        ],
      },
      {
        word: "suitcase",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3baacb1dd660a759c9faf47d9bced09cb401c145_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈsuːtˌkeɪs/  【n.】",
            explanations_and_examples: [
              {
                explanation: "手提箱；衣箱",
              },
            ],
          },
        ],
      },
      {
        word: "abusive",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b287e1de8bbe9c9a7c02fb2c363115e9e38ff1e1_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈbjuːsɪv/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "using cruel words or physical violence 谩骂的；虐待的",
                example:
                  "The goalkeeper was sent off for using abusive language against a linesman ",
              },
            ],
          },
        ],
      },
      {
        word: "tweet",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8077710d4de6a73fe4136f776d40983d05e99340_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/twiːt/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "send a short message using the social networking service Twitter （使用推特社交网络）发送（信息）",
                example:
                  "Today you can tweet your messages out to the world with a mere click of the mouse.",
              },
            ],
          },
        ],
      },
      {
        word: "allegation",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6b6a2eb4bd00aafefc87ba5f9df9e5ffda3d4034_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌæləˈgeɪʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "a claim or assertion that sb. has done sth. illegal or wrong, typically one without proof （尤指无证据的）宣称，指控",
                example:
                  "He made allegations of corruption against the administration.",
              },
            ],
          },
        ],
      },
      {
        word: "trade-off",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/44523bf254e7ba8ad1a83437ca6ffaee895bdaed_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈtreɪd ˌɒf/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " a balance between two opposing things, that you are willing to accept in order to achieve sth. （两种对立事物之间的）平衡，妥协，协调",
                example:
                  "There has to be a trade-off between quality and quantity if we want to keep prices low.",
              },
            ],
          },
        ],
      },
      {
        word: "depressing",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/45bc981ace94bd1bd2155da29162385dce09e73f_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪˈpresɪŋ/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "making you feel very sad 令人沮丧的；让人忧愁的",
                example:
                  "This year's unemployment figures are as depressing as those of last year.",
              },
            ],
          },
        ],
      },
      {
        word: "wallpaper",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/18d63b3b77501bfaf5df7f75a440d140690477ea_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈwɑːlˌpeɪpə/ 【vt.】 ",
            explanations_and_examples: [
              {
                explanation:
                  "put wallpaper onto the walls of a room 给（房间）糊墙纸",
                example:
                  "Never mind the stains on the walls in the bedroom. We will wallpaper the rooms this weekend anyway.",
              },
            ],
          },
        ],
      },
      {
        word: "amplify",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f02523d44771f511268f335865ac5a8e85d56004_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈæmplɪˌfaɪ/ 【vt.】",
            explanations_and_examples: [
              {
                explanation: " increase the effects or strength of sth. 增强",
                example:
                  "You might practice gratitude, which is necessary to empower your mind and amplify your power of attraction.",
              },
            ],
          },
        ],
      },
      {
        word: "dive",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/5a522c9a5ae602ce50c17764b177ae14f51f9cf5_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/daɪv/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "jump into deep water with your head and arms going in first 跳水",
                example:
                  "It was so hot that the children took off their clothes and dived into the swimming pool.",
              },
            ],
          },
        ],
      },
      {
        word: "albeit",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4ff4cf091fea119e719e77fb270cd92a87d06582_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɔːlˈbiːɪt/ 【conj.】",
            explanations_and_examples: [
              {
                explanation: "  although 虽然；尽管",
                example:
                  "Charles' letters were published against all odds, albeit in a somewhat abbreviated ",
              },
            ],
          },
        ],
      },
      {
        word: "reputable",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1a2fd4506856a315164749d52028114f8dacc4ab_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈrepjʊtəbl/ 【a.】",

            explanations_and_examples: [
              {
                explanation:
                  "  respected for being honest or for doing good work 有声望的；信誉佳的",
                example:
                  "If you have a fire alarm fitted, make sure it is done by a reputable company.",
              },
            ],
          },
        ],
      },
      {
        word: "plastic surgery",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9bae64458d71de92007a329535fe0a15d3657c04_96k.mp3#duration=2.0&t=.mp3",
        pee: [
          {
            partOfSpeech: " /ˈsɜː(r)dʒərɪ/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "the medical practice of changing the appearance of people's faces or bodies, either to improve their appearance or to repair injuries 整形手术；整形外科",
              },
            ],
          },
        ],
      },
      {
        word: "specialty",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/771654ba09512d8a9dc9bcb053f974a6f07d35e0_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈspeʃltɪ/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " 1) a branch of medicine or surgery 医学专科；专外科",
                example:
                  "Emergency medicine is one of the most important specialties.",
              },
              {
                explanation:
                  "2) a subject or job that you know a lot about or have a lot of experience of 专业；专长",
                example:
                  "No matter what our specialties are, communication is at the heart of what doctors do.",
              },
            ],
          },
        ],
      },
      {
        word: "surgeon",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ac24b00566cd1e92009f3922a71e6322c1b2dbb4_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈsɜːdʒ(ə)n/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "a doctor specially trained to perform surgery 外科医生",
                example:
                  "His finger was cut off when he caught it in a machine, but the surgeon was able to sew it back on.",
              },
            ],
          },
        ],
      },
      {
        word: "intern",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ab8735d7710c824a55d6e7f03ebc03c0870cdcb0_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɪntɜːn/",
            explanations_and_examples: [
              {
                explanation: "【vi.】(mainly AmE)  1)serve as an intern 做实习医生（或实习生）",
                example:
                  "I interned at a clinic during the first summer vacation after I graduated from high school.",
              },
              {
                explanation:
                  "【n. [C]】2)sb. who has nearly finished training as a doctor and is working in a hospital 实习医生",
                example:
                  "She refused to be treated by an intern and demanded to see a qualified doctor.",
              },
              {
                explanation:
                  "【n. [C]】 3)sb., esp. a student, who works for a short time in a particular job in order to gain experience 实习生",
                example:
                  "John once worked as an intern for a private detective to satisfy his curiosity.",
              },
            ],
          },
        ],
      },
      {
        word: "operating room",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/35eef183923d367a690cb5fa644165374e665855_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "【n.】",
            explanations_and_examples: [
              {
                explanation: "手术室",
              },
            ],
          },
        ],
      },
      {
        word: "cosmetic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b02ede5f70e35887b2d59eb0f6d1ce44ff5a93d6_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kɒzˈmetɪk/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "involving or relating to treatment intended to restore or improve a person's appearance 整容的",
                example:
                  "The movie star ignored the rumors that she had had cosmetic surgery on nine parts of her body.",
              },
            ],
          },
        ],
      },
      {
        word: "merit",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b25fa7d1943c8b7a8b78a7b9cebf9daf4e5cb004_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmerɪt/ 【n. [C]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) a mark that a school student gets as a reward for good work or behavior （学校对学业或表现优异学生的评分）优，优秀",
                example:
                  "Artistic merit scholarships require that applicants excel in a given artistic area.",
              },
              {
                explanation:
                  "2) an advantage or good feature of sth. 长处；优点",
                example:
                  "Tonight's meeting will weigh up the relative merits of the two candidates.",
              },
            ],
          },
        ],
      },
      {
        word: "neurobiology",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/509dd81a60bc3412e5b671ffc2661d5d9d00b5d7_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌnjʊərəʊbaɪˈɒlədʒɪ/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "神经生物学",
              },
            ],
          },
        ],
      },
      {
        word: "physiology",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e25ca3b7d7dcf59da012e0e42a4a28de8a6c0405_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌfɪzɪˈɒlədʒɪ/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "生理学",
              },
            ],
          },
        ],
      },
      {
        word: "dreaded",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d9aaf10f6e2ddb8a6385c712bfe24909b3459001_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈdredɪd/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  " making you feel afraid or anxious — often used humorously 可怕的，令人忧虑的（常为幽默用法）",
                example:
                  "For decades in American households the most dreaded morning sound was that of an alarm clock.",
              },
            ],
          },
        ],
      },
      {
        word: "internship",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/cf197bbff2be604377dd991a3561ee9314853945_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɪntɜːnˌʃɪp/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " ) a period of training spent in a hospital by a young doctor in order to finish their medical qualification 医生实习期",
                example:
                  "he diligent young man will be a genuine asset to any hospital that offers him an internship position.",
              },
            ],
          },
        ],
      },
      {
        word: "surgical",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/25e4623da9793e0ec201b7e5ddbd065c4bb13e46_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈsɜːdʒɪkl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "of, relating to, or used in surgery 外科的；外科手术（用）的",
                example:
                  "Most people who ultimately turn to a surgical solution have tried everything else.",
              },
            ],
          },
        ],
      },
      {
        word: "scrub",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a412e134459dd2dd759bd4810f8acbd4bc98b5c0_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/skrʌb/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "手术服",
              },
            ],
          },
        ],
      },
      {
        word: "mask",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6a198d41743b0dcc08d6d36b39c485329391dcee_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/mɑːsk/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a covering for all or part of the face, worn to hide or protect it 面具；面罩",
                example:
                  "We had to wear a protective mask when handling goods in the awfully dusty environment.",
              },
            ],
          },
        ],
      },
      {
        word: "cafeteria",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/cbbc9e1412a2d840eed776279bb146756fe631fb_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌkæfəˈtɪərɪə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a restaurant where customers serve themselves from a counter and pay before eating 自助餐馆；自助食堂",
                example:
                  " Even if you do not buy your food in the cafeteria, you can use the tables to have meetings or to study.",
              },
            ],
          },
        ],
      },
      {
        word: "enthusiasm",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/af77a0bec9dfc5fc1425fccb32bd65daad048f48_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈθjuːzɪˌæzəm/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " intense and eager enjoyment, interest, or approval 热心；热情",
                example:
                  "One of the good things about teaching young children is their enthusiasm never lets you down.",
              },
            ],
          },
        ],
      },
      {
        word: "application",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4666fc5118297b482d0ec9da88e292fd020e14b3_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: " /ˌæplɪˈkeɪʃn/ 【n.[C, U]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) the action of putting sth. into operation 应用",
                example:
                  "Students learned the practical application of the theory they had learned in the classroom.",
              },
              {
                explanation:
                  "2) a formal request to an authority for sth. 申请",
                example:
                  "We regret to inform you that your application has not been accepted because it has gone beyond the deadline.",
              },
            ],
          },
        ],
      },
      {
        word: "outfit",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/faaceecdb1deaf0974d5ff1a01d8a0f0e2a9c083_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈaʊtfɪt/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " a set of clothes worn together, esp. for a particular occasion or purpose 全套服装",
                example:
                  " When you're wearing a loud (花哨的) polka-dot clothes, you need to keep the rest of your outfit quiet.",
              },
            ],
          },
        ],
      },
      {
        word: "wardrobe",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4c84f677917b505cfc3a8ad7f9d395c503dab039_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈwɔːdrəʊb/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " a piece of furniture like a large cupboard that you hang clothes in 衣柜；衣橱",
                example: "",
              },
            ],
          },
        ],
      },
      {
        word: "gear",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2205522a050d09a932a347b176f7735727620283_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/gɪə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "the machinery in a vehicle that turns engine power into movement forward or backward 排挡",
                example: "",
              },
            ],
          },
        ],
      },
      {
        word: "drastically",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/af009d3a5ff713a412b4670b21efa80f6edadca5_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈdræstɪkli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "  in a way that is severe and sudden or has very noticeable effects 激烈地；大幅度地",
                example:
                  "Our communication has changed drastically in the past decade owing to the information technology.",
              },
            ],
          },
        ],
      },
      {
        word: "swirl",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1d20ec96a1f580dfa9a4af946c1059750ee98ee9_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/swɜːl/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "(make sth.) move in a twisting or spiraling pattern （使）打旋；（使）旋动",
                example:
                  "He sank into deep thought in a corner at the news, the cigarette smoke swirling around him.",
              },
            ],
          },
        ],
      },
      {
        word: "spill",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ba8800e80e8865fb1e9bf1dfe8e9446491c99976_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/spɪl/",
            explanations_and_examples: [
              {
                explanation: "[vt.] reveal (confidential information) to sb. 透露",
                example:
                  " The police officer refused to spill the witness' private information to the reporters to protect her security.",
              },
              {
                explanation:
                  "[v.](cause to) flow over the edge of a container, esp. unintentionally （使）溢出；泼出",
                example:
                  "Let's see if we could pour the juice through the narrow opening of the bottle without spilling it.",
              },
            ],
          },
        ],
      },
      {
        word: "legitimate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/44127e1b6d7ba1f70e7a2e303f1eb318612576b9_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/lɪˈdʒɪtəmət/ 【a.】",
            explanations_and_examples: [
              {
                explanation: " 1) reasonable or justified 合理的；正当的",
                example:
                  "He claimed that the restaurant bill was a legitimate business expense and should be covered by the company.",
              },
              {
                explanation: "2) allowed by law 合法的",
                example:
                  "The international community urged the army of the country to give power back to the legitimate government.",
              },
            ],
          },
        ],
      },
      {
        word: "manual",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a276f5377364fb7da840b98626827b25672f9ce9_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmænjʊəl/",
            explanations_and_examples: [
              {
                explanation:
                  "[n.][C] a book of instructions, esp. for operating a machine or learning a subject; a handbook 说明书；手册",
                example:
                  "The computer comes with a 600-page instruction manual that is not at all user-friendly.",
              },
              {
                explanation: "[a.] of or done with the hands 手工的；用手的",
                example:
                  "The floors of all campus buildings are equipped with manual fire alarm systems.",
              },
            ],
          },
        ],
      },
      {
        word: "supermodel",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8650d1b9717b9777d5a90547763fccd6df3c3fd9_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: " /ˈsuːpəˌmɒdl/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C]  a very famous model 超级名模",
                example:
                  "She became a supermodel and went to the top soon after she was discovered by a talent scout",
              },
            ],
          },
        ],
      },
      {
        word: "flip",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/44316300f65bdead448b18e1f183b55dbfa57d5e_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/flɪp/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "(cause to) turn over with a sudden sharp movement （使）快速翻转",
                example:
                  "I lost my place in my book when the pages flipped over in the wind.",
              },
            ],
          },
        ],
      },
      {
        word: "crystal clear",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/bcfe9d8179533a8f26d4e58c31604c1324fa157d_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌkrɪstl ˈklɪə/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "very clearly stated and easy to understand 明白的；无疑问的",
                example:
                  "I want to make one thing crystal clear — I do not agree with these proposals.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Phrases and expressions",
    children: [
      {
        word: "pop up",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/05215089acdb0ace42ff1dff1fe59f00e189ac83_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "appear in a place or situation unexpectedly 突然出现",
                example:
                  "She was startled when Lisa popped up at the door all smiles.",
              },
            ],
          },
        ],
      },
      {
        word: "tune out",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/db858ddc6c943960aa2e5b883367cc5011067614_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "stop listening or paying attention to what is being said 不听；不注意；不理会",
                example:
                  "The pressure from information overload can make some people tune out messages altogether.",
              },
            ],
          },
        ],
      },
      {
        word: "hang out",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d3b85769c8ed8aba1dfe18b3d6fb841d5a02e299_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "spend a lot of time in a place or area for no particular reason 闲逛",
                example:
                  " I used to hang out with my friends in the park with a fountain, which is now beyond recognition.",
              },
            ],
          },
        ],
      },
      {
        word: "let alone",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7df33ba8331adff216756b306c14d202e45df13b_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  " used after a negative statement to say that the next thing you mention is even more unlikely 更不用说，更谈不上（用于否定句之后）",
                example:
                  "Because of the knee injuries, he cannot walk any more, let alone play golf.",
              },
            ],
          },
        ],
      },
      {
        word: "come along",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a52cb7504f29afe18bf3db706c97a08821721424_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "occur or arrive by chance 不期而至",
                example:
                  "I waited a long time until a film script came along that I thought was genuinely funny.",
              },
            ],
          },
        ],
      },
      {
        word: "on tap ",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d88ebae2b873ca0604729fe43bd1fa6830812de5_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "(of liquids) available by turning a tap （液体）打开阀门即可获得的",
                example:
                  " A lot of local pubs feature a wide selection of imported wines as well as beers on tap.",
              },
            ],
          },
        ],
      },
      {
        word: "at the expense of",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/53fd674509322f77e8059a5793af7f66e9c4951d_96k.mp3#duration=2.4&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "at the cost of 为代价",
                example:
                  "Prolonging life at the expense of its quality can rob elderly people of meaningful years.",
              },
            ],
          },
        ],
      },
      {
        word: "dive into ",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/aaffef65f2a2800146746bcfbcfb14dbcd0fecb8_96k.mp3#duration=3.2&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "start doing sth. eagerly 热切地开始",
                example:
                  "George dived into his application for an overseas postgraduate program as soon as he finished his third year at college.",
              },
            ],
          },
        ],
      },
      {
        word: "put up with",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/43dd473cff7faac1dc9b0791cdff31dc8ecc87dd_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "tolerate or accept sth., even though it is unpleasant or unsatisfactory 容忍",
                example:
                  "They had put up with behavior from their son which they would not have tolerated from anyone else.",
              },
            ],
          },
        ],
      },
      {
        word: "go off",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c81ac81d8f21a8081020b6b606726189453754a1_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "start to ring loudly or make a loud noise 发出响声",
                example:
                  "I overslept and missed my early morning class because my alarm clock did not go off as usual today.",
              },
            ],
          },
        ],
      },
      {
        word: "come around",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/243dc9281a6d18baf351999ee3e2829c01851eb1_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "happen as a regular or predictable event 如期而至",
                example:
                  " I hope to be qualified to compete when the World Championship comes around next year.",
              },
            ],
          },
        ],
      },
      {
        word: "give up on sb",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e390e23c5e1c540f31a343c95dae205d99bff88b_96k.mp3#duration=4.4&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "give up 放弃",
                example:
                  "If your weight-loss goals are beyond reach, you're likely to feel frustrated and give up on your dieting plans.",
              },
            ],
          },
        ],
      },
      {
        word: "shift gears",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/49e2d6b4961b46958b8fcd06f4ce6a0dba9a025d_96k.mp3#duration=3.3&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: " suddenly change what you are doing 突然改变方式",
                example:
                  " The first half of the movie made the audience fall out of their chairs laughing, but then it shifted gears.",
              },
            ],
          },
        ],
      },
      {
        word: "test the water(s)",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/85bf6a14ac568b661815dc52da683437424e29ef_96k.mp3#duration=4.2&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "try sth. in order to see if you like it or if it's suitable 试探",
                example:
                  "Many international companies want to find more investment opportunities in China, and Chinese companies want to test the water overseas. ",
              },
            ],
          },
        ],
      },
      {
        word: "shut / close the door on sth",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b45aae6b1e06b983c4288e8a7087d13245d64a53_96k.mp3#duration=5.8&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "make it impossible for sth. to happen, esp. a plan or a solution to a problem 拒之门外",
                example:
                  "There are fears that this latest move might have shut the door on a peaceful solution. ",
              },
            ],
          },
        ],
      },
      {
        word: "break the news to sb.",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/02247ce2d0182e1ce3c6e6f028a127f0c28ad9e8_96k.mp3#duration=2.7&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "tell sb. about sth. unpleasant that will affect or upset them 把坏消息告诉某人",
                example:
                  "We must break the news to all of you that the event is cancelled because of lack of funds.",
              },
            ],
          },
        ],
      },
      {
        word: "spill the beans",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ad7d3fdf0adfad1564bb8940f7e6f514e5d2e26b_96k.mp3#duration=2.4&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "tell people secret information 泄露秘密",
                example:
                  "We'll all be there at 6 for the surprise party — now don't spill the beans unless you want to spoil the fun.",
              },
            ],
          },
        ],
      },
      {
        word: "flip through",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c0c112a43e6ee0eb99324d2084064c50378f09f3_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "look quickly at the pages of a magazine, book, etc. 浏览",
                example:
                  "I had quickly flipped through the survey report while I was waiting for the conference to kick off.",
              },
            ],
          },
        ],
      },
      {
        word: "(right) under one's nose",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9e2f4dfb722c675025e1a401d4737ad661d8afbb_96k.mp3#duration=5.9&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "if sth. is right under sb.'s nose, they cannot see it even though it is very close to them （就）在某人眼皮底下（却看不见）",
                example:
                  " I've been looking for my keys for ages and they were right under my nose all the time.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Proper names",
    children: [
      {
        word: "Silicon Valley",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/bffb06fd52feb2b02e64890d1afad4442b78bb94_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈsɪlɪkən/",
            explanations_and_examples: [
              {
                explanation:
                  "硅谷（位于美国加利福尼亚州，因计算机和电子工业闻名；文中也是电视连续剧剧名）",
              },
            ],
          },
        ],
      },
      {
        word: "Michigan",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6bd66288150366f86eb8d7e0117f7da64c7bfcdb_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmɪʃɪgən",
            explanations_and_examples: [
              {
                explanation: "密歇根州（位于美国北部",
              },
            ],
          },
        ],
      },
      {
        word: "Ohio",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/bd0dbcebcf8d9b1146121d3ff69428683fc0d676_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əʊˈhaɪəʊ/",
            explanations_and_examples: [
              {
                explanation: "俄亥俄州（位于美国东北部）",
              },
            ],
          },
        ],
      },
      {
        word: "Gale.King",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7c4330859b5241311b01f47072c783ac401638ae_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/geɪl/",
            explanations_and_examples: [
              {
                explanation: "盖尔金（人名)",
              },
            ],
          },
        ],
      },
      {
        word: "Mike Robbins",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6dcd23ffa5f0a14c6be7a1fda9ee8eeaa2957429_96k.mp3#duration=2.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈrɒbɪnz/",
            explanations_and_examples: [
              {
                explanation:
                  "迈克.罗宾斯（美国团队合作、领导力、情商等领域的专家）",
              },
            ],
          },
        ],
      },
      {
        word: "Ohio",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/bd0dbcebcf8d9b1146121d3ff69428683fc0d676_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈlaɪənz",
            explanations_and_examples: [
              {
                explanation:
                  "丹.莱昂斯（美国《新闻周刊》前专栏作家，《硅谷》第二季编剧））",
              },
            ],
          },
        ],
      },
      {
        word: "Elon Musk",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a3bdf3f24292d08c67d0a62df2851375f5dd950b_96k.mp3#duration=2.0&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  " 埃隆.马斯克（美国电动车及能源公司特斯拉〔Tesla〕和太空探索技术公司〔SpaceX〕的首席执行官",
              },
            ],
          },
        ],
      },
      {
        word: "the Verge",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1e714142accb1513416ad8c5b02af458e12b7355_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/vɜːdʒ/",
            explanations_and_examples: [
              {
                explanation: "前沿网（美国科技媒体网站",
              },
            ],
          },
        ],
      },
      {
        word: "Austen Allred",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/bd0dbcebcf8d9b1146121d3ff69428683fc0d676_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɔːlred/",
            explanations_and_examples: [
              {
                explanation: "奥斯汀.奥尔雷德（人名",
              },
            ],
          },
        ],
      },
      {
        word: "Ron Friedman",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/34f17aa1c1aafcc231eba74ded8002c4571e4729_96k.mp3#duration=2.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfri:dmən/",
            explanations_and_examples: [
              {
                explanation: "罗恩.弗里德曼（美国心理学家)",
              },
            ],
          },
        ],
      },
    ],
  },
];

book3[2] = [
  {
    name: "New words",
    children: [
      {
        word: "insightful",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/701f9427f556569c72c8dd2f0abd0b3de6021060_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɪnsaɪtfl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "able to understand, or showing that you understand, what a situation or person is really like 领悟力强的；富有洞察力的",
                example:
                  " We are always looking for more interesting and insightful ideas to share with our readers.",
              },
            ],
          },
        ],
      },
      {
        word: "equilibrium",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/cf27aaa73ab3a7d4f8bb249179025cf5ba33b900_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌiːkwɪˈlɪbrɪəm/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "a balance between different people, groups, or forces that compete with each other, so that none is stronger than the others and the situation is not likely to change suddenly 平衡；均衡；均势",
                example:
                  "The point at which the solid and the liquid are in equilibrium is called the freezing point.",
              },
            ],
          },
        ],
      },
      {
        word: "purely",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/0e0079e5db2b57142ea4d717177a6a4509917e87_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈpjʊəli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation: "completely and only 完全地；纯粹地；仅仅",
                example:
                  " The management committee decided to close the museum purely because it cost too much to run",
              },
            ],
          },
        ],
      },
      {
        word: "dilemma",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/76b2692a567fb70ebad1727f9c9bc1636d96f88b_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪˈlemə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "a situation in which it is very difficult to decide what to do, because all the choices seem equally good or equally bad 进退两难的境地；困境",
                example:
                  "The dilemma over human cloning lies at the heart of the ethical choices facing society.",
              },
            ],
          },
        ],
      },
      {
        word: "memorable",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9d9fadb56216059b5523700dc9aa0482bfcc0fe9_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmem(ə)rəbl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "very good, enjoyable, or unusual, and worth remembering 难忘的；值得纪念的",
                example:
                  "If you want to catch and save this memorable event in your life, bring your camera with you.",
              },
            ],
          },
        ],
      },
      {
        word: "classical",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/851e7105e669b7a74436df4f9eea9d4e48542cc2_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈklæsɪkl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "widely accepted and used for a long time; traditional in style or idea 经典的；古典的；传统的",
                example:
                  "Adam Smith is considered one of the founders of classical economics.",
              },
            ],
          },
        ],
      },
      {
        word: "maximise",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/626882995e9b5bf4c6157d2bc303937502771b5a_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmæksɪˌmaɪz/  【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "increase sth. such as profit or income as much as possible 使增加到最大限度；使最大化(请使用ise结尾)",
                example:
                  "Some airlines have canceled less popular routes in an effort to maximise profit.",
              },
            ],
          },
        ],
      },
      {
        word: "collective",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3560bb8839e7e98f066cbabca45aa98dcca909d0_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kəˈlektɪv/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  " shared or made by every member of a group or society 集体的；共同的；共有的",
                example:
                  "I think it's our collective responsibility to create an environment for future generations to be even more successful.",
              },
            ],
          },
        ],
      },
      {
        word: "welfare",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7287240bf548652e4c526b7b3a816510fe85ac17_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈwelfeə/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "health and happiness 幸福；健康；福祉",
                example:
                  "Biological scientists have to consider the balance between human health and animal welfare as they push forward the frontiers of research.",
              },
            ],
          },
        ],
      },
      {
        word: "allegory",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b6c9463bd385fdc2a3c4a4ee3b8a20d3c597c55b_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈæləg(ə)rɪ/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " a story, painting, etc. in which the events and characters represent ideas or teach a moral lesson 寓言；讽刺",
                example:
                  "The book is a kind of allegory of Latin American history.",
              },
            ],
          },
        ],
      },
      {
        word: "invisible",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f11b94966dd51836bdd4c80796fbdf347ac6cd67_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈvɪzəbl/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "impossible to see 看不见的；不可见的",
                example:
                  "This sophisticated technology allows scientists to find things that are invisible to the naked eye.",
              },
            ],
          },
        ],
      },
      {
        word: "disastrous",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/5df3447311d0c857013b83d0f069fe0681bb883c_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪˈzɑːstrəs/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "very bad, or ending in failure 灾难性的；以失败告终的",
                example:
                  "In some cases, lowering interest rates could have disastrous consequences for the economy.",
              },
            ],
          },
        ],
      },
      {
        word: "burglar",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/62f2a071081ee09515218b62051e31010baabcf3_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈbɜːglə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "sb. who goes into houses, shops, etc. to steal things 入室窃贼",
                example:
                  "A number of burglars broke into the gallery and stole dozens of priceless paintings.",
              },
            ],
          },
        ],
      },
      {
        word: "accuse",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9ece1e1f1730d2eac3c7474f103fdadee0e529bd_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈkjuːz/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "say that you believe sb. is guilty of a crime or of doing sth. bad 控告；指控；指责",
                example:
                  "No one could ever accuse this government of not caring about the poor.",
              },
            ],
          },
        ],
      },
      {
        word: "robbery",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e8ed50ddc8f411d4f83780d9c9f7e450ea47beaf_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈrɒbərɪ/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "the crime of stealing money or things from a bank, shop, etc., esp. using violence 抢劫",
                example:
                  "The gang (犯罪团伙) admitted they had committed four recent bank robberies.",
              },
            ],
          },
        ],
      },
      {
        word: "confess",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7324b7446699a0e6f21cf1a1ea82fb91cd10978c_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kənˈfes/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "admit, esp. to the police, that you have done sth. wrong or illegal （尤指向警方）坦白，招认，招供",
                example:
                  'Gabriele confessed to leaking copies of the documents to the press because he wanted to expose the "evil and corruption" in the company.',
              },
            ],
          },
        ],
      },
      {
        word: "optimal",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1489ddc0782a66e1926ca32e009d589238253523_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɒptɪml/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "the best or most suitable 最佳的；最适宜的",
                example:
                  "They insist their business idea is optimal and will be wildly acceptable to customers.",
              },
            ],
          },
        ],
      },
      {
        word: "better off",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e0264f5040943ec0e21ce3c1148dffc66d3dbf9b_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌbetə ˈɒf/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "being in a better situation, if or after sth. happens 更好的",
                example:
                  "You'd be better off living on your own than quarreling all the time with your dad.",
              },
            ],
          },
        ],
      },
      {
        word: "equivalent",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/23d91a355124f004c8e1cb6ece4cbd3694b94161_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪˈkwɪvələnt/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "sth. that has the same value, purpose, job, etc. as sth. else 同等物；等价物；对应物",
                example:
                  'Is there a French word that is the exact equivalent of the English word "home"?',
              },
            ],
          },
        ],
      },
      {
        word: "comparative",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e007c1153f2c91c636538dcf9d467903b97b2514_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kəmˈpærətɪv/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "measured or judged by how similar or different it is to sth. else; relative 比较而言的；相对的",
                example:
                  "After living in poverty for most of his lifetime, he spent his last few years in comparative comfort.",
              },
            ],
          },
        ],
      },
      {
        word: "emit",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/962453f9e88d6c707c0900cbf6275d3c4dd37e2c_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪˈmɪt/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  " send out gas, heat, light, sound, etc. 散发，发出（气、热、光、声音等）",
                example:
                  "The machine will emit a noisy sound when you press the red button.",
              },
            ],
          },
        ],
      },
      {
        word: "inaction",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/5865b8324400f81e7fafe22e6a232844d1df06d0_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈækʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "the fact that sb. is not doing anything （人）无行动，没反应",
                example:
                  "The city council was accused of inaction on the parking problem of the city.",
              },
            ],
          },
        ],
      },
      {
        word: "CV",
        pee: [
            {
                partOfSpeech: "/ˌsiːˈviː/ 【n.】",
                explanations_and_examples: [
                    {
                        explanation: "[C] (curriculum vitae) a short written document that lists your education and previous jobs, which you send to employers when you are looking for a job 简历；履历",
                        example: "Applicants interested in applying for the position should submit their CVs no later than February 15. "
                    }
                ]
            }
        ],
        "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f6461644ba9b3f430b7c4c4036e8cd4a960603c7_96k.mp3#duration=1.5&t=.mp3"
    },
      {
        word: "entail",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a8e82e112cb8cb0ba1e6ba4cb56afd6e49dcd6f6_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈteɪl/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "involve sth. as a necessary part or result 使必要；需要",
                example:
                  "The job of a dance teacher entails teaching students the technique and performance of dance movements.",
              },
            ],
          },
        ],
      },
      {
        word: "inefficiency",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8cdf51528bb0ee0e50e65bc6d8b790aefa8b6da6_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌɪnɪˈfɪʃnsi/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "the fact of not using time, money, energy, etc. in the best way 低效率",
                example:
                  "The conflict between management and workers makes for inefficiency in the workplace.",
              },
            ],
          },
        ],
      },
      {
        word: "intervene",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1389619f9c5fa8a097f8b0b1eafc4bb96ffaff17_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌɪntəˈviːn/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "become involved in an argument, fight, or other difficult situation in order to change what happens 干预；介入；插手",
                example:
                  "I don't usually like to intervene in disputes between husbands and wives.",
              },
            ],
          },
        ],
      },
      {
        word: "intervention",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8e0b89fa9d442a05482b629b246649cd4c596af9_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌɪntəˈvenʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "the act of becoming involved in an argument, fight, or other difficult situation in order to change what happens 干涉；干预；介入",
                example:
                  "Repeated interventions on the currency markets have failed to prevent the value of the currency falling.",
              },
            ],
          },
        ],
      },
      {
        word: "binding",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/cfff338575d6e0819e97e835a42a824717c3c4c8_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈbaɪndɪŋ/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "that must be obeyed because it is accepted in law 有法律约束力的；必须遵守的",
                example:
                  "Participants in the world trade talks have agreed to negotiate specific binding commitments.",
              },
            ],
          },
        ],
      },
      {
        word: "incentive",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4513af683968124fb4ba80e216fc988cd9b5adbc_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈsentɪv/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "  sth. that encourages you to work harder, start a new activity, etc. 刺激；动力；鼓励",
                example:
                  "There is little incentive for people to leave their cars at home when public transport remains so expensive.",
              },
            ],
          },
        ],
      },
      {
        word: "entrepreneurship",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/906847acd9d51851fd18ece3a511a420a24ed614_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌɒntrəprəˈnɜːrʃɪp/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "the state of being an entrepreneur, or the activities or spirit associated with being an entrepreneur 企业家身份；企业家行为或精神",
                example:
                  " Individuals not only need to examine their personal finances but also the considerable lifestyle changes entrepreneurship can bring.",
              },
            ],
          },
        ],
      },
      {
        word: "venture",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a0e353f8a2e238fc80ea29438817b0634d32f66c_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈventʃə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " a new business activity that involves taking risks 风险项目；风险投资；冒险事业",
                example:
                  "  Another idea that has attracted venture capitalists' interest is online learning.",
              },
            ],
          },
        ],
      },
      {
        word: "outlook",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/015fe72dd59c85b3440687a4d9f08e3a9b8753ba_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈaʊtˌlʊk/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] general attitude to life and the world （对生活和世界的）看法，观点，态度）",
                example:
                  "You will become more matured as your outlook on life is influenced by the books that you read.",
              },
            ],
          },
        ],
      },
      {
        word: "curiosity",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1b462c8921196a34faf00df1e95fd79d2f3eb63a_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌkjʊəriˈɒsəti/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[U, sing.] the desire to know about sth. 好奇心",
                example:
                  "In my view, intellectual curiosity is a sufficient reason for this new scientific endeavor. ",
              },
            ],
          },
        ],
      },
      {
        word: "cultivate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/0c1ac7e8c021047efd697be3e960c16c4cecf397_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkʌltɪˌveɪt/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) work hard to develop a particular skill, attitude, or quality 培养，养成（技能、态度或素质）",
                example:
                  " Cultivating a positive mental attitude toward yourself can reap tremendous benefits.",
              },
              {
                explanation:
                  "2) prepare and use land for growing crops and plants 耕；耕作",
                example:
                  "Near the coast, huge areas of land are given over to cultivating tomatoes.",
              },
            ],
          },
        ],
      },
      {
        word: "holistic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b7d252bfeca4e9bb2b4c1e011cdc1a6f2ae35da6_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/həʊˈlɪstɪk/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "considering a person or thing as a whole, rather than as separate parts 整体（论）的；全面的",
                example:
                  "Policymakers need to take a long-term, holistic approach to housing finance reform.",
              },
            ],
          },
        ],
      },
      {
        word: "effectiveness",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1ce28cccbb30fbf0ada6164dcfd0135e881bc520_96k.mp3#duration=2.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪˈfektɪvnɪs/ 【n. 】",
            explanations_and_examples: [
              {
                explanation:
                  "the quality of being successful and working in the way that was intended 有效性",
                example:
                  "There are doubts about the effectiveness of the new drug treating the disease.",
              },
            ],
          },
        ],
      },
      {
        word: "solely",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/17690233558e1c84e27a0651311130c1fac838fd_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈsəʊlli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "not involving anything or anyone else 唯一地；仅仅；独一无二地",
                example:
                  "Too often we make buying decisions based solely upon what we see in the advertisements.",
              },
            ],
          },
        ],
      },
      {
        word: "profitability",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7378109cec525d5e3eb7fad9d584e264b95a4d1e_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌprɒfɪtəˈbɪləti/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "when a business or an activity makes a profit, or the amount of profit it makes 获利；盈利；利润",
                example:
                  "Competition between firms will continue to force those prices down, which will undermine the profitability of the industry. ",
              },
            ],
          },
        ],
      },
      {
        word: "capitalistic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ce1a7edf6822d488a7e3821bacfb0ce04695b9e9_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌkæpɪtəˈlɪstɪk/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "supporting or based on the principles of capitalism 资本主义的",
                example:
                  "In a capitalistic society, individuals with wealth and privilege have much of the power.",
              },
            ],
          },
        ],
      },
      {
        word: "pioneering",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/5470ceb6618a6f3788c521ee5c138b8c6195d941_96k.mp3#duration=0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌpaɪəˈnɪərɪŋ/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  " introducing new and better methods or ideas for the first time 开创性的；先驱的；探索性的",
                example:
                  "Cowley's pioneering development of modern emergency medicine helped save countless lives.",
              },
            ],
          },
        ],
      },
      {
        word: "optimize",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/cff3acddaa89be68d5594a613dcb085f3777b366_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɒptɪˌmaɪz/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  " improve the way that sth. is done or used so that it is as effective as possible 使最优化；使尽可能完善；使尽量有效",
                example:
                  "Doctors are concentrating on understanding the disease better, and on optimizing the treatment.",
              },
            ],
          },
        ],
      },
      {
        word: "enterprise",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d7bacd76beffd5a280a54e9d8b1cfce000fab84a_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈentəˌpraɪz/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "a company, organization, or business 公司；组织；企业",
                example:
                  "To a great many individuals setting up a new business enterprise, the last thing they usually bother about is accounting and tax.",
              },
            ],
          },
        ],
      },
      {
        word: "gratifying",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/41f61568f9873e6d07a21708e172407c966c9091_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈgrætɪˌfaɪɪŋ/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "pleasing and satisfying 令人高兴的；令人满意的",
                example:
                  "It must be very gratifying to see all your children grown-up and happy.",
              },
            ],
          },
        ],
      },
      {
        word: "sustainability",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/239de1395da33874868c87916feca9b6f8351139_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/səˌsteɪnəˈbɪləti/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "the quality of being able to continue for a long time 可持续性",
                example:
                  "Do you want environmental sustainability or do you want economic advantage?",
              },
            ],
          },
        ],
      },
      {
        word: "propel",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/cfccae2723bca3bb6905c8a7e3a549adea219775_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/prəˈpel/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "move, drive, or push sth. forward 推动；推进；驱动",
                example:
                  "The rocket is attached to the spacecraft and is designed to propel it toward Mars.",
              },
            ],
          },
        ],
      },
      {
        word: "revolutionary",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8f7b5d362cbf7dfcb6c2786c82d1cf3918ce6da9_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌrevəˈluːʃn(ə)ri/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "completely new and different, esp. in a way that leads to great improvements 革命性的；突破性的；创新的",
                example:
                  "The 20th century brought about revolutionary changes in our lifestyles.",
              },
            ],
          },
        ],
      },
      {
        word: "significance",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/0d4ba8b59ac64b871b3415f44c8d2c78abaf32be_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "/sɪgˈnɪfɪkəns/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " the importance of an event, action, etc., esp. because of the effect or influence it will have in the future 重要性，意义（尤指对将来的影响)",
                example:
                  "The discovery of the new drug is of great significance for people suffering from heart problems.",
              },
            ],
          },
        ],
      },
      {
        word: "marketplace",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/be4a7bbc6e69f373b07382460bbfd9b85d6b18bf_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmɑːkɪtˌpleɪs/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "the part of business activity that is concerned with buying and selling goods in competition with other companies 市场（指涉及营销的种种活动）",
                example:
                  "Some retailers worry that new regulations will hurt their ability to compete in the marketplace.",
              },
            ],
          },
        ],
      },
      {
        word: "imprint",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7203c115f6650758bd9ba0d751e26592997a0502_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɪmprɪnt/ 【n. [C]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) a strong permanent influence on sb. / sth. 强大而持久的影响",
                example:
                  "Gandhi was a tremendously brave man whose unique form of courage left a lasting imprint on India's history.",
              },
              {
                explanation:
                  "2) the mark left by an object being pressed into or onto sth. 印记；压痕",
                example:
                  "She could clearly see the imprint of her fingers on his pale wrist.",
              },
            ],
          },
        ],
      },
      {
        word: "compassionate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/74faf7bae4b60a9bec6d5515f4e640dba85716d8_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kəmˈpæʃnət/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  " feeling sympathy for people who are suffering 充满同情心的；怜悯的",
                example:
                  "The public's response to the crisis was generous and compassionate.",
              },
            ],
          },
        ],
      },
      {
        word: "legacy",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/716eef92a63467759da1253087e5171656fe70f3_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈlegəsi/ 【n. [C]】",
            explanations_and_examples: [
              {
                explanation:
                  "sth. that sb. has achieved that continues to exist after they stop working or die （某人不再工作或去世后）留下的成果",
                example:
                  "Perhaps her most important legacy was her program of educational reform.",
              },
            ],
          },
        ],
      },
      {
        word: "prudence",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f329e59d0886671c79521885c1c119802af7bc19_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈpruːdns/ 【n. [U]】",
            explanations_and_examples: [
              {
                explanation:
                  "a sensible and careful attitude that makes you avoid unnecessary risks 明智谨慎；慎重；审慎",
                example:
                  "Businessmen are showing remarkable prudence in investing in the region.",
              },
            ],
          },
        ],
      },
      {
        word: "ultimately",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b6d8fad3f7bfdd7256c868b131ea040f99f9dc0b_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈʌltɪmətli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "finally, after everything else has been done or considered 最后；最终",
                example:
                  "Everything will ultimately depend on what is said at the meeting with the directors next week.",
              },
            ],
          },
        ],
      },
      {
        word: "spectrum",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f56eb3b931a537c2370a34c320c8c3c57abfd5f6_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈspektrəm/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a complete range of opinions, people, situations, etc., going from one extreme to its opposite （观点、人、情况等的）范围，幅度",
                example:
                  "The course covers a wide spectrum of musical activity from opera to rock.",
              },
            ],
          },
        ],
      },
      {
        word: "imply",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/83a5a062ee91e7a422e929df60b3aca86ef008f3_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪmˈplaɪ/【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "if a fact, event, etc. implies sth., it shows that it is likely to be true 意味着（某事可能是真的）",
                example:
                  "These findings do not imply that urbanization makes little or no difference to the small towns.",
              },
            ],
          },
        ],
      },
      {
        word: "socioeconomic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/5edf4811024574c88d9ec373f754a3c9fba8e415_96k.mp3#duration=2.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌsəʊʃiəʊˌekəˈnɒmɪk/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "involving a combination of social and economic factors 社会经济的",
                example:
                  "The age, education, and socioeconomic status of these young mothers led to less satisfactory childcare.",
              },
            ],
          },
        ],
      },
      {
        word: "comprehend",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4529066f9e65e9c750e4a7b8774da650c202ebc4_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌkɒmprɪˈhend/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  " understand sth. that is complicated or difficult 理解，领悟（复杂或困难的事物）",
                example:
                  "In an effort to comprehend the principles of investment of any sort, you have to know the way to determine return on investment.",
              },
            ],
          },
        ],
      },
      {
        word: "immense",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b39eb040f4e5d42f765c69d2e23f9ef1cdb4cc91_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪˈmens/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "extremely large 巨大的；极大的",
                example:
                  "Regular visits from a social worker can be of immense value to old people living alone.",
              },
            ],
          },
        ],
      },
      {
        word: "implore",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/993c1ae15369d090fa626632e781f599012fc221_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪmˈplɔː/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml.) ask for sth. in an emotional way 恳求；乞求；哀求",
                example:
                  "If you feel depressed for more than three weeks, I implore you to seek professional help. ",
              },
            ],
          },
        ],
      },
      {
        word: "revolutionize",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/bc881f31dc80efc93fbc7743d623a30d8fd6fe68_96k.mp3#duration=2.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌrevəˈluːʃəˌnaɪz/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "completely change the way people do sth. or think about sth. 使彻底变革；",
                example:
                  "Swatch revolutionized the market for watches with its inexpensive watches aimed at the youth market.",
              },
            ],
          },
        ],
      },
      {
        word: "latter",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b9a36fb5b70458305a6667aa68055035201cc2d7_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈlætə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "the second of two people or things just mentioned （刚提及的两个人或物中的）后者",
                example:
                  "Where unemployment and crime are high, it can be assumed that the latter is due to the former.",
              },
            ],
          },
        ],
      },
      {
        word: "flourishing",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/134379b42124475def1522f2ce9c48ea9e58bc18_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈflʌrɪʃɪŋ/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "developing well and being successful 繁荣的；兴旺的；成功的",
                example:
                  "A stable and flourishing economy is essential for political stability and national security, and vice versa.",
              },
            ],
          },
        ],
      },
      {
        word: "rigid",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d0de7f2f2fa926fe289e8bf9de8508a48d721a73_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈrɪdʒɪd/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "unwilling to change ideas or behavior 顽固的；僵化的",
                example:
                  "We were disappointed that they insisted on such a rigid interpretation of the rules.",
              },
            ],
          },
        ],
      },
      {
        word: "painstaking",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ec85f095a91495fc0f1cbccbcee6188ac964449a_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈpeɪnzˌteɪkɪŋ/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  " very careful and thorough 小心的；费尽心思的；精心的",
                example:
                  " It is the kind of painstaking work that only someone who knows every inch of the ship could perform.",
              },
            ],
          },
        ],
      },
      {
        word: "mediocrity",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c0b20efa76dcaaa9492c38be2afc819c32e599f8_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌmiːdiˈɒkrəti/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " quality, ability, or achievement that is average or below average 普通；平庸；平常",
                example:
                  " We will not accept mediocrity; the job they do is of critical importance.",
              },
            ],
          },
        ],
      },
      {
        word: "alien",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/94105255521e1e59d3e9f2e9a5eac54c01db25b3_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈeɪliən/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) ( ~ to sb. / sth. ) strange and frightening; different from what you are used to 陌生的；不熟悉的",
                example:
                  " In a world that had suddenly become alien and dangerous, Michael was her only security.",
              },
              {
                explanation:
                  "2) connected with creatures from another world 外星的",
                example:
                  "In short, he concluded that the canals were artificial constructs of technologically advanced alien beings.",
              },
            ],
          },
        ],
      },
      {
        word: "uncover",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b5a66c286976d73fc8dd55696d4f0b5354b7b7f4_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ʌnˈkʌvə/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "find out about sth. that has been kept secret 发现；揭露",
                example:
                  " The investigation uncovered evidence of a large-scale illegal trade in wild birds.",
              },
            ],
          },
        ],
      },
      {
        word: "momentous",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/0d4f1e8b876566ed2aff8fa1aa384d76717533d9_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/məʊˈmentəs/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "very important or serious, esp. because there may be important results 关键的；重大的；重要的",
                example:
                  "Whether or not to move overseas is a momentous decision for the family.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Phrases and expressions",
    children: [
      {
        word: "take sth. as a given",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f4c18853796364f31e5103bad027d38134544fde_96k.mp3#duration=2.4&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "accept that sth. is true or exists, esp. when you are developing an idea or argument 认为某事理所当然如此；认为某事是想当然（尤用于得出观点）",
                example:
                  "The fact that people find change difficult is taken as a given.",
              },
            ],
          },
        ],
      },
      {
        word: "come in",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c4163a4870eb5559e215682ab938d448dc3e0a9d_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "be involved in a plan, deal, etc. 卷入；参与",
                example:
                  "We need some financial advice — that's where Kate comes in.",
              },
            ],
          },
        ],
      },
      {
        word: "spring from",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d551901fa6f55401f9326a955a81188560ac50dc_96k.mp3#duration=2.0&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "be caused by sth. or start from sth.由...引起",
                example:
                  "His grief sprang from the loss of the most important love he had ever known in his life.",
              },
            ],
          },
        ],
      },
      {
        word: "speak of",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/76d4824fb7a4f23b3a5d4225ef1c974603732cb0_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "show clearly that sth. happened or exists 表明；说明",
                example: "Her skin spoke of warm summer days spent in the sun.",
              },
            ],
          },
        ],
      },
      {
        word: "break new ground",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b95ee2dceef83f700f929854027d4dd87e99382b_96k.mp3#duration=2.1&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "do or discover sth. new 开辟新天地；创新",
                example:
                  "Inventing such a camera wouldn't be easy, but Cameron said he was ready to break new ground.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Proper names",
    children: [
      {
        word: "John Nash",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e46692345e8e0fecde3e19af2abf02a8c114e08d_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "约翰.纳什（美国数学家）",
              },
            ],
          },
        ],
      },
      {
        word: "Russell Crowe",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/daae9af0c9891eece7ef2f37114e6ff978e307c9_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌrʌsl ˈkrəʊ",
            explanations_and_examples: [
              {
                explanation: "罗素.克劳（澳大利亚演员）",
              },
            ],
          },
        ],
      },
      {
        word: "Adam Smith",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/65f5b06b14f799b827ae46798119f63b0c52468a_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "亚当.斯密（苏格兰经济学家）",
              },
            ],
          },
        ],
      },

      {
        word: "John Cage",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/39630b33eb78bc355ffb85a32b644e942e68ca0d_96k.mp3#duration=2.0&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "约翰 . 凯奇（美国音乐家)",
              },
            ],
          },
        ],
      },
      {
        word: "Run Run Shaw",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/56c87dcc43f1a54c0feda289fb38ba76ba5b7f42_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "邵逸夫（中国香港企业家、慈善家）",
              },
            ],
          },
        ],
      },
    ],
  },
];

book3[3] = [
  {
    name: "New words",
    children: [
      {
        word: "freediving",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a0190a36c69561aaf9dc94f2de998015c95abbb9_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfriːˌdaɪvɪŋ/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "the sport or activity of diving without the aid of breathing equipment （不使用呼吸装备的) 自由潜水",
                example:
                  " They noticed she was very good at breath-holding and suggested she try freediving.",
              },
            ],
          },
        ],
      },
      {
        word: "championship",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6cbc1fafc3390e78043bfa042039d44f07443453_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈtʃæmpiənʃɪp/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " a competition to find which player, team, etc. is the best in a particular sport 锦标赛；冠军赛",
                example:
                  "The sixth game of the World Chess Championship will be broadcast tonight on Channel 6.",
              },
            ],
          },
        ],
      },
      {
        word: "nonetheless",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/89db9b81888b5a414d7ec56566f0d0db829ca026_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌnʌnðəˈles/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  " in spite of the fact that has just been mentioned 然而；但是；尽管如此；虽然如此",
                example:
                  " The region was extremely beautiful. Nonetheless Gerard could not imagine spending the rest of his life there.",
              },
            ],
          },
        ],
      },
      {
        word: "spectator",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/84d6721f74b140e35b3e2d7e9503406f81a1a0b7_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/spekˈteɪtə/ 【n.】",                                                     
            explanations_and_examples: [
              {
                explanation:
                  "sb. who is watching an event or a game （活动或体育比赛的）观看者，观众",
                example:
                  "The final baseball game which was held last Thursday attracted a crowd of over 50,000 spectators.",
              },
            ],
          },
        ],
      },
      {
        word: "diver",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a797846f0328b880cb3cde527d826d23ea390104_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈdaɪvə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "sb. who swims or works under water, usu. with special equipment to help them breathe （通常使用特种呼吸辅助装备的）潜水员",
                example:
                  " Twenty minutes later, a diver surfaced and handed a metal box to the elderly gentleman.",
              },
            ],
          },
        ],
      },
      {
        word: "dangle",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/76e9f53fe89c8f24e5e5f6c38adff555e65a0036_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈdæŋgl/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "hang or swing loosely, or make sth. do this （使）悬垂；（使）吊着；（使）悬荡",
                example:
                  "where the apples were ripe and dangled just inches above our heads.",
              },
            ],
          },
        ],
      },
      {
        word: "terrify",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6afcff77d8c3888ace5eed1ce95fba2c12477d9e_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈterəfaɪ/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "make sb. feel extremely frightened 使恐惧；使十分害怕；使惊吓",
                example:
                  "He had imagined that going down in the caves at late night would terrify her, but instead she felt surprisingly calm.",
              },
            ],
          },
        ],
      },
      {
        word: "bare",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/32843ad56f689fe480be1e40d02ea60d2d59bbee_96k.mp3#duration=1.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/beə/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "not covered by any clothes 裸体的；裸露的",
                example:
                  "While she was walking around her house in bare feet, her mom just didn't seem to notice.",
              },
            ],
          },
        ],
      },
      {
        word: "stroke",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f0a2a780cd2220d60b2aadbbe68dd90381a3e411_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/strəʊk/ 【n. [C]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) one of a set of movements in swimming or rowing in which you move your arms or the oar forward and then back （游泳或划船的）一次划水",
                example:
                  "She walked into the water and began to swim with strong strokes to the middle of the lake.",
              },
              {
                explanation:
                  "2) a sudden serious illness when a blood vessel in the brain bursts or is blocked, which can cause death or the loss of the ability to move or to speak clearly 脑卒中；中风",
                example:
                  "It is reported that air pollution could also restrict blood flow, causing strokes and heart attacks.",
              },
            ],
          },
        ],
      },
      {
        word: "loosen",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2cc3f9ccc30658ed007b1f72b8c53cd1b53107b6_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈluːsn/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "make sth. less tight or firmly fixed; become less tight or firmly fixed （使）放松；变松",
                example:
                  "He took a screwdriver (螺丝刀) from his pocket and began to loosen the screws on the bike.",
              },
            ],
          },
        ],
      },
      {
        word: "skydiver",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6c6316c3b548172f410c016cd7d0df6b0c272270_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈskaɪˌdaɪvə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C]sb. who jumps from a plane and falls for as long as they can before opening the parachute （延缓张伞的）特技跳伞运动员",
                example:
                  "As a skydiver falls, he accelerates downward, gaining speed with each second.",
              },
            ],
          },
        ],
      },
      {
        word: "pose",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f1875fcb048f180f71f41c95951bc5a9c3ad62a4_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/pəʊz/",
            explanations_and_examples: [
              {
                explanation:
                  "[n.][C]a particular position in which sb. stands, sits, etc., esp. in order to be painted, drawn or photographed （为画像、拍照等摆的）姿势",
                example:
                  "Please ask the model to stay in that pose anywhere from 30 seconds to 1 minute.",
              },
              {
                explanation:
                  "[vt.]create a threat, problem, etc. that has to be dealt with 造成（威胁、问题等）；引起；产生",
                example:
                  "Concerns about the danger posed by fireworks could lead to restrictions on their sale and use.",
              },
            ],
          },
        ],
      },
      {
        word: "vanish",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/68b3287ab5032a11fa88df2d58e75b86babbaf6c_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈvænɪʃ/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "disappear suddenly and / or in a way that you cannot explain （莫名奇妙地）突然消失",
                example:
                  "Three boats vanished without a trace one day and have never been found.",
              },
            ],
          },
        ],
      },
      {
        word: "sonar",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a3a4b197a1f374fb7f821564433b20be0a1a64e1_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈsəʊnɑː/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] 声呐（船上或潜艇上利用声波探测水下目标位置的仪器)",
                example: "",
              },
            ],
          },
        ],
      },
      {
        word: "descent",
        audio:
          "	http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/75e57b6112098217b33326e385d2502af5e4c608_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪˈsent/ 【n.】",
            explanations_and_examples: [
              {
                explanation: " [C, U] (fml.) the process of going down 下降；降落",
                example:
                  "The night turned cold and heavy rain began to fall during our descent from the mountain peak.",
              },
            ],
          },
        ],
      },
      {
        word: "tick",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2193684376fe03d91b9d10a6b120455625ba8d01_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/tɪk/",
            explanations_and_examples: [
              {
                explanation:
                  "[vt.] mark a test, list of questions, etc. with a tick, in order to show that sth. is correct, to choose sth., etc. 给（试卷、问题等）打钩号",
                example:
                  "She is used to ticking off all of the things that she has done before the end of the day.",
              },
              {
                explanation:
                  "[vi.]if a clock or watch ticks, it makes a short repeated sound （钟表）发出嘀嗒声",
                example:
                  "The clock on the wall ticked away, its sound echoing through the otherwise silent room.",
              },
            ],
          },
        ],
      },
      {
        word: "agonizing",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/74a5dc2d70ab887d0718b85608a137c87c8e0789_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈægəˌnaɪzɪŋ/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "(BrE agonising) 1) very unpleasant to experience, esp. because of involving a difficult choice or a long wait （尤因难以抉择或等待过久而）折磨人的",
                example:
                  "For two agonizing minutes the plane dived, shook, and finally landed safely on the airport.",
              },
              {
                explanaion: "2) extremely painful 十分痛苦的",
                example:
                  "It was said that a few months ago Mr. Lin died after suffering years of agonizing pain.",
              },
            ],
          },
        ],
      },
      {
        word: "headlight",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9754611f1da6b11e8fdac31c8052de2fe570eb2e_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈhedˌlaɪt/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C](also headlamp)(车辆的）前灯；车头灯（的光束）",
                example: "",
              },
            ],
          },
        ],
      },
      {
        word: "fog",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/00f3b4e8bb5f5df7d59916ac94245d613b238322_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/fɒg/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C, U] 雾",
              },
            ],
          },
        ],
      },
      {
        word: "exhale",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/567d587bb483e555a39b678ef88ddc1cb6c3e2c8_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/eksˈheɪl/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml.) breathe out the air or smoke, etc. in our lungs 呼出，吐出（肺中的空气、烟等）；呼气",
                example:
                  "I changed my breathing pattern, inhaling and exhaling heavily after each set of exercise.",
              },
            ],
          },
        ],
      },
      {
        word: "scuba",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6faa76afecede9b5d47e59efad1b185150b690a4_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈskuːbə/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C]水肺；自携式水下呼吸器",
              },
            ],
          },
        ],
      },
      {
        word: "fin",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a3ebe85a988ad2f09357d5dfd013349197d050d4_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/fin/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C, usu. pl.] （潜水、游泳时用的）手蹼，脚蹼",
              },
            ],
          },
        ],
      },
      {
        word: "assist",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e68dd6be5604312b06c41df707fc6ea740f7db64_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈsɪst/ 【v.】",
            explanations_and_examples: [
              {
                explanation: "help sb. to do sth. 协助；帮助",
                example:
                  "Families assisted teachers with the achievement of educational goals.",
              },
            ],
          },
        ],
      },
      {
        word: "resurface",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d51d77b1525235a7490975880d097d15c2cb3180_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌriːˈsɜːfis/  【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) come back up to the surface of the water 重新露出水面",
                example:
                  "When the divers did not resurface after an hour, three crew members dived down to look for them.",
              },
              {
                explanation:
                  "2) appear again after being lost or missing （遗失或失踪后）再次出现",
                example:
                  "She resurfaced briefly about eight years later, to compete with Noriko again for $5 million.",
              },
            ],
          },
        ],
      },
      {
        word: "cardiac ",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a2638bb9dad1680ae2ed137bd669ff2dad67258f_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkɑːdiˌæk/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "relating to the heart 心脏的",
                example:
                  "It is generally believed that patients with cardiac problems should avoid foods that are high in salt.",
              },
            ],
          },
        ],
      },
      {
        word: "cardiac arrest",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8ec2a96b3b5e55d0428562b23737b9e5fec81511_96k.mp3#duration=2.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌkɑːdiæk əˈrest/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "心脏停搏；心搏停止",
                example: "",
              },
            ],
          },
        ],
      },
      {
        word: "underwater",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/31f747544e8537554c45fd33eab0a74f2eeec731_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌʌndəˈwɔːtə/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "(only before noun)  below the surface of an area of water, or able to be used there 水下的；水下（使）用的",
                example:
                  "Each guide also includes full-color underwater photographs illustrating the marine life you could expect to see.",
              },
            ],
          },
        ],
      },
      {
        word: "keenly",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f4a04cdfa8424f2f6240e538f36c88a869e6c036_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkiːnli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  " 1) if you look at sb. / sth. keenly or watch them keenly, you look closely at them and notice everything about them （观察）敏锐地",
                example:
                  "I looked at him keenly; he did not blink or even seem embarrassed by what he had just said.",
              },
              {
                explanation: "2) very strongly 强烈地",
                example:
                  "Scientists are keenly interested in learning which substances make fruits and vegetables so healthful.",
              },
            ],
          },
        ],
      },
      {
        word: "envelop",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/dd6f668a1a5c8a0a2b55e6deb5ef64dbe8df93a3_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈveləp/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml.) cover or wrap sb. / sth. up completely 包住；覆盖",
                example:
                  "The mist and rain enveloped the forest so that we could only see the nearest trees.",
              },
            ],
          },
        ],
      },
      {
        word: "wilderness",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c68a288951dc5952b2d8416cbeffa13fcfd06c46_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈwɪldənəs/【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C, usu. sing.] a large area of land that has never been developed or farmed 未开发的地区；荒野；荒凉之处",
                example:
                  "As we could see from the film, this place used to be a vast wilderness of mountains, lakes, and forests.",
              },
            ],
          },
        ],
      },
      {
        word: "frontier",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/28d244c23548b63c2bc9743540b1d10996ffa4b6_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/frʌnˈtɪə/ 【n. [C]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) the limit of what is known about sth. 未完全开拓的领域；新领域",
                example:
                  "The study of the brain is often described by scientists as the next intellectual frontier.",
              },
              {
                explanation: "2) the border of a country 国界；边境",
                example:
                  "Many of the cars crossing the frontier were stopped and searched for illegal goods.",
              },
            ],
          },
        ],
      },
      {
        word: "penalty",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c482b2d1c444bfc9debe5deae410c0c1294e6072_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈpenlti/【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C]  a punishment for breaking a law, rule, or legal agreement （因违反法律、规则或合约而受到的）惩罚，处罚",
                example:
                  "The contract includes heavy penalties for those people who fail to complete the work on time.",
              },
            ],
          },
        ],
      },
      {
        word: "marine",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/512593cd568f610fdaec66ab628cdec7c51f1d49_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/məˈriːn/【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "(only before noun) relating to the sea and the creatures that live there 海洋的；海洋生物的",
                example:
                  "We are all quite familiar with news items concerning marine pollution due to oil spills.",
              },
            ],
          },
        ],
      },
      {
        word: "fraction",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/512593cd568f610fdaec66ab628cdec7c51f1d49_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfrækʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] a very small amount of sth. 一点；少量",
                example:
                  "Employees' salaries are just a fraction of the total cost of the project.",
              },
            ],
          },
        ],
      },
      {
        word: "exploration",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d8e6f6577644cbe0fc048d19e68d9b81a867d880_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌekspləˈreɪʃn/ 【n. [C, U]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) the act of traveling through a place in order to find out about it or look for sth. in it 勘探；勘查；探索",
                example:
                  " You can use this hut as a base for explorations into the mountains and forests around.",
              },
              {
                explanation:
                  "2) an examination of sth. in order to find out about it 探究；研究；探测",
                example:
                  "This chapter begins with a detailed exploration of the issue of gender discrimination among all age groups.",
              },
            ],
          },
        ],
      },
      {
        word: "mysterious",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/483a48b56badf6e5554fafa339736881dfa828d4_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/mɪˈstɪəriəs/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) (esp. of people) strange and interesting because you do not know much about them 神秘的；陌生的",
                example:
                  "I decided to find out more about my mysterious new neighbor who lived on the top floor.",
              },
              {
                explanation:
                  "2) difficult to understand or explain; strange 神秘的；奇怪的；不易理解的",
                example:
                  "The police are investigating the mysterious disappearance of a new-born baby at the hospital.",
              },
            ],
          },
        ],
      },
      {
        word: "handful",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/60befcc2b7dbeb2eec7546fab7ee57308d691616_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈhændfʊl/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) [sing.] (~  of ) a small number of people or things 少数人或物",
                example:
                  "The new book is by a man who's already written a handful of best-sellers, most of them about space exploration.",
              },
              {
                explanation:
                  "2) [C] the amount that you can hold in your hand 一把（的量)",
                example:
                  "The boy picked up a handful of stones and started throwing them at us, which made us annoyed.",
              },
            ],
          },
        ],
      },
      {
        word: "sailor",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1d746f9d19a17b492cedfd4bc7223d0eda8edee6_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈseɪlə/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "水手；海员",
              },
            ],
          },
        ],
      },
      {
        word: "menace",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/90e1cd68dc4c589ad88b33891ce04bd658d97a71_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmenəs/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "sb. / sth. that is dangerous 危险的人或事物",
                example:
                  "Drivers like that are a menace. They shouldn't be allowed on the road.",
              },
            ],
          },
        ],
      },
      {
        word: "ape",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ffa7fabf9d4055938cd5279e963064828d1df1b7_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/eɪp/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "猿",
              },
            ],
          },
        ],
      },
      {
        word: "galaxy",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/531e338d0b5dd27ce03070cea1aec08671758dcd_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈgæləksi/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " any of the large systems of stars, etc. in outer space 星系",
                example:
                  " Observations of distant galaxies indicate that they are moving away from us: The universe is expanding.",
              },
            ],
          },
        ],
      },
      {
        word: "terrestrial",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7b697749d80cc86f4197d160537d42cba2b87259_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/təˈrestriəl/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "connected with the planet Earth 地球的；地球上的",
                example:
                  "Technology gives us immense power over nature, and our decisions will affect all terrestrial life.",
              },
            ],
          },
        ],
      },
      {
        word: "necessitate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/395f5651bbd0e565cf53efb12854ccf7f45edaca_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/nəˈsesɪˌteɪt/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "make it necessary for you to do sth. 使成为必需；需要",
                example:
                  " Sales have dropped dramatically, necessitating big cuts in production and employment.",
              },
            ],
          },
        ],
      },
      {
        word: "observational",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/52d2fe3cf69cb68586f4e97fd06951d4357751df_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌɒbzəˈveɪʃnəl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "relating to the watching of sb. / sth. in order to learn new things 观察的；观测的",
                example:
                  "We film in an observational style, following events over a period of months to see how things turn out.",
              },
            ],
          },
        ],
      },
      {
        word: "ingredient",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e03ab385bef2224913bcde59eadd0f396dc3267c_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈgriːdiənt/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "one of the things from which sth. is made, esp. one of the foods that are used together to make a particular dish 成分；（尤指烹饪）原料",
                example:
                  "Meals are prepared by the chef on board using fresh ingredients which are bought daily.",
              },
            ],
          },
        ],
      },
      {
        word: "orbit",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/59005eb72efedc2f7c8229704763f3151d49fe7b_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɔːbɪt/",
            explanations_and_examples: [
              {
                explanation:
                  "【v.】travel in a curved path around a much larger object such as the Earth, the Sun, etc. 沿轨道运行；环绕",
                example:
                  "The Earth is one of several planets that orbit the Sun, and the Moon orbits around the Earth.",
              },
              {
                "explanation": "[n.][C] the curved path traveled by an object which is moving around another much larger object such as the Earth, the Sun, etc. （环绕地球、太阳等运行的）轨道】",
                "example": "These planets have circular (环形的) orbits similar to the orbits of planets in our solar system."
            }
            ],
          },
        ],
      },
      {
        word: "flare",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3d2cdb813c6c021ce1dbb46da63d06b09fb361de_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/fleə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C, usu. sing.]  a bright but unsteady light or flame that does not last long （短暂的）旺火；（摇曳的）光；（闪耀的）火光",
                example:
                  "A sudden flare of light caused her to raise her right arm protectively across her face.",
              },
            ],
          },
        ],
      },
      {
        word: "strip",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8e907b5b1fcccab86c55c13d172944a3929aab0f_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/strɪp/",
            explanations_and_examples: [
              {
                explanation:
                  "[vt.] remove sth. that is covering the surface of sth. else 剥去，除去（表面的东西）",
                example:
                  "I think we should strip the old painting off and see what the wood is like underneath.",
              },
              {
                explanation:
                  "[n.] a long narrow area of land, sea, etc. （陆地、海域等）狭长地带；带状水域",
                example:
                  "The islands are separated by a narrow strip of water.",
              },
            ],
          },
        ],
      },
      {
        word: "axis",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2dd3b38f42994778ebcebf339a1b97e6d899820c_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈæksɪs/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] the imaginary line around which a large round object, such as the Earth, turns （旋转）轴；轴线",
                example:
                  "The Earth and many other planets in the solar system rotate on their axes and revolved around the Sun.",
              },
            ],
          },
        ],
      },
      {
        word: "stabilize",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/56250261a4ab708e644fdd90c3c6a8a0b96fca8f_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈsteɪbəˌlaɪz/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] (BrE stabilise)become or make sth. become firm, steady and unlikely to change （使）稳定，稳固",
                example:
                  "He suffered a second heart attack two days ago but his condition has now stabilized.",
              },
            ],
          },
        ],
      },
      {
        word: "axial",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3e4f1032c2a339d65dae9758aa2417cb61dc9c4e_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈæksiəl/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "of or related to an axis 轴的；轴线的",
                example:
                  "The Moon's presence also slows the axial rotation of the Earth, which is why we could have 24-hour days.",
              },
            ],
          },
        ],
      },
      {
        word: "tilt",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/281d26b5e6aea20285f7746124ef2d309f3992ba_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/tɪlt/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C,U] a position in which one end or side of sth. is higher than the other; an act of tilting sth. to one side 倾斜；倾侧",
                example:
                  "Since childhood, we have learned the languages of the eyes, the hands and those subtle tilts of the head.",
              },
            ],
          },
        ],
      },
      {
        word: "shield",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/91645e3b63df74f5b09fc537c9065df86f04de41_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ʃiːld/",
            explanations_and_examples: [
              {
                explanation:
                  "[vt.] protect sb. / sth. from being harmed or damaged 保护；保卫",
                example:
                  "He wrapped himself in his heavy coat and sat in the corner where the bamboo leaves shielded him from the wind.",
              },
              {
                explanation: "[n.] [C] 盾；盾牌",
                example: "",
              },
            ],
          },
        ],
      },
      {
        word: "catastrophic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/93e12c5d59dfbcfcb0d9d7e7828b905cf13c8773_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌkætəˈstrɒfik/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "causing a lot of destruction, suffering, or death 灾难性的；毁灭性的",
                example:
                  "The movie shows heroes risking their lives to save the Earth from a catastrophic collision with a comet",
              },
            ],
          },
        ],
      },
      {
        word: "proverbial",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/5e33b12ebf2ad07e528479fdf9e3946b372f212b_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/prəˈvɜːbiəl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "(the ~ sth.) used when you describe sth. using part of a well-known expression 俗话说的；常言道",
                example:
                  'There are some observers who make predictions all the time about economic recessions, the collapse of civil society, and the proverbial "end of the world.',
              },
            ],
          },
        ],
      },
      {
        word: "exo-planet",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/38f8b90ae2aafd61440db743c70f0b90b2cd4107_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈeksəʊˌplænɪt/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a planet that is not in the solar system 系外行星",
                example:
                  "Astronomers say that this unique observing technique opens a new phase in the exploration of exo-planets.",
              },
            ],
          },
        ],
      },
      {
        word: "astrobiology",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/56f4d0f83a208bcea806f41a07eb3ee23015f00c_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌæstrəʊbaɪˈɒlədʒi/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] the branch of biology that investigates the possibility of life elsewhere in the universe 天体生物学",
                example: "",
              },
            ],
          },
        ],
      },
      {
        word: "preconception",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b184f78817fa8694712d390398242c2e061cad32_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌpriːkənˈsepʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a belief or opinion that you have already formed before you know the actual facts, and that may be wrong 事先形成的看法（想法）；先入之见；成见",
                example:
                  "Try to go into the meeting without too many preconceptions about what the other group wants.",
              },
            ],
          },
        ],
      },
      {
        word: "hydrothermal",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d8bf6182b94d4a41f374d2244cff38945ef8598e_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌhaɪdrəʊˈθɜːml/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "of or relating to the action of water under conditions of high temperature, esp. in forming rocks and minerals 热液的",
                example: "",
                },
            ],
          },
        ],
      },
      {
        word: "vent",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/91fbdfe1b18e2dffa79671483f797ad04d87d79a_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/vent/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "an opening that allows air, gas or liquid to pass out of or into a room, building, container, etc. （空气、气体、液体的）出口，进口，漏孔",
                example:
                  "Make sure that jars have tight lids and are kept away from sunlight and heating vents.",
              },
            ],
          },
        ],
      },
      {
        word: "absence",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/86c7bc078e277fb4db7422c5eef998e85a8be677_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈæbs(ə)ns/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) [U] the fact of sb. / sth. not existing or not being available; a lack of sth. 不存在；缺乏",
                example:
                  "The case was dismissed in the absence of any definite proof.",
              },
              {
                explanation:
                  "2) [C, U] when you are not in the place where people expect you to be, or the time that you are away 不在；缺席",
                example:
                  "The smell of cigarette smoke confirmed what he had suspected: There had been a party in his absence.",
              },
            ],
          },
        ],
      },
      {
        word: "arsenic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d6210affd4742d8daa64e44d2486f5ae8f965db5_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɑːsnɪk/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "砷",
                example: "",
              },
            ],
          },
        ],
      },
      {
        word: "plausible",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/0eb15376fa00ed07672abd4630d76ee0ed645565_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈplɔːzəbl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "reasonable and likely to be true or successful 貌似有理的；似乎是真的",
                example:
                  "A more plausible explanation would seem to be that people are fed up with the routine life.",
              },
            ],
          },
        ],
      },
      {
        word: "conducive",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7119498c61edf6a21ee3d8b6e7290ab782a53a22_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kənˈdjuːsɪv/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "making it easy, possible or likely for sth. to happen有助于...的发生 ",
                example:
                  "Our ultimate goal is to create a culture that is conducive to continual progress and learning.",
              },
            ],
          },
        ],
      },
      {
        word: "requirement",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3ae50128138919cefb1dd9ebd35df85958dcc2b4_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/rɪˈkwaɪəmənt/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C, usu. pl.] 1) sth. that you must have in order to do sth. else 必要条件；必备的条件",
                example:
                  "Success in the examination did not secure by itself a postgraduate position abroad, but it was the minimum requirement.",
              },
              {
                explanation:
                  "2) sth. that you need or want 所需的（或所要的）东西",
                example:
                  "The average daily food requirement is about 2,000 calories for women and 2,500 for men.",
              },
            ],
          },
        ],
      },
      {
        word: "membrane",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e71d2b2583fc8b8586c6bc860ce8793f09049f01_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmemˌbreɪn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C, U] a very thin piece of skin that covers or connects parts of your body （覆盖或连接身体某些部分的）膜；薄膜",
                example:
                  "Exposure to loud noise from fireworks can damage the delicate membrane in the ear.",
              },
            ],
          },
        ],
      },
      {
        word: "aqueous",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d97934f6b60333c4f4734df43021228585b1e36f_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈækwiəs/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "containing water or similar to water 含水的；似水的",
                example:
                  "In chemistry, an aqueous solution or cream has water as its base.",
              },
            ],
          },
        ],
      },
      {
        word: "radioisotope",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4995cd9e9c1f9a5e4b575e3ce0932d3bdc51c808_96k.mp3#duration=2.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌreɪdiəʊˈaɪsətəʊp/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C]放射性同位素",
              },
            ],
          },
        ],
      },
      {
        word: "decay",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/dadf373cee6d91d23ddd2cdf2be2b30b61c45eee_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪˈkeɪ/ 【n. [U]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) the process by which a radioactive substance changes to a different form, producing radiation （放射性物质的）衰变",
                example:"",  
              },
              {
                explanation:
                  "2) the natural chemical change that causes the slow destruction of sth. 腐烂；朽烂",
                example:
                  "The study did not find an association between secondhand smoke exposure and decay in permanent teeth.",
              },
            ],
          },
        ],
      },
      {
        word: "geothermal",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/dd61b6fc7761397fdf19cdcf4faa9a10c787ea53_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌdʒiːəʊˈθɜːml/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "relating to or coming from the heat inside the Earth 地热的；地温的",
                example:
                  "The ice sheet acts like a huge blanket that locks in the geothermal heat that comes naturally from the Earth.",
              },
            ],
          },
        ],
      },
      {
        word: "rogue",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/903adf5f3e23a9271a23d4c3d8879559aeaeb63e_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/rəʊg/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  " (only before noun)(of an animal) living apart from the main group, and possibly dangerous 离群的",
                example:
                  "It's reported that rogue elephants have killed at least 31 people in that area this year.",
              },
            ],
          },
        ],
      },
      {
        word: "habitable",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/903adf5f3e23a9271a23d4c3d8879559aeaeb63e_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈhæbɪtəbl/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "suitable for people to live in 适合居住的",
                example:
                  "This move is one step in Shanghai's blueprint for becoming a world-class city which is more habitable for its residents.",
              },
            ],
          },
        ],
      },
      {
        word: "inquire",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c4c5d65f839bb32418df9838da6994d4c0fe8703_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈkwaɪə/ 【v.】",
            explanations_and_examples: [
              {
                explanation: "(esp. AmE) (also enquire esp. BrE)ask sb. for some information 询问；打听",
                example:
                  "The committee will inquire of Miller about his involvement with the bank.",
              },
            ],
          },
        ],
      },
      {
        word: "inquiry",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a4f1255e706f5d820ca581d78edbd1b06d95d558_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈkwaɪri/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "(esp. AmE) (also enquiry esp. BrE) 1)he act of asking questions or collecting information about sb. / sth. 查询；探究；探索",
                example:
                  "On further inquiry, it emerged that Malcolm had not been involved in the incident.",
              },
              {
                explanation: "2) [C] an official process to find out the cause of sth. or to find out information about sth. 调查；查究；查问",
                example: "An inquiry will be held to discover why the local school's educational record is so bad."
             }
            ],
          },
        ],
      },
      {
        word: "planetary",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/647ebb65ffe6d9dbce4863da2cdef04b816cca5d_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈplænəteri/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "(only before noun)relating to a planet or planets 行星的",
                example:
                  "This means a huge step forward in understanding how planetary systems form and evolve.",
              },
            ],
          },
        ],
      },
      {
        word: "spectroscopy",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ecbfb336e92b452e9bf2c059886a9e36d0f3aee9_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/spekˈtrɒskəpi/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[U] 光谱学",
                example: "",
              },
            ],
          },
        ],
      },
      {
        word: "probe",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/67b6312a8a0837ba9223cab2ff9ed31a9a8bade9_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/prəʊb/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "ask questions in order to find out secret or hidden information about sb. / sth. 盘问；追问；探究",
                example:
                  "We have been probing the reasons why the government has been so slow to react to the problem of climate change..",
              },
            ],
          },
        ],
      },
      {
        word: "seasonal",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4b65212486de7f63641216f89d4e26f4aa10e68c_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈsiːz(ə)nəl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "(usu. before noun) happening, expected, or needed during a particular season 季节性的；时令的；当令的",
                example:
                  "One major factor in causing seasonal variations in food supplies was the difficulty of storage.",
              },
            ],
          },
        ],
      },
      {
        word: "periodic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/0ec73d8c3b151fd6f5eac922b36d53d280349a8f_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌpɪəriˈɒdɪk/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "happening a number of times, usu. at regular times 周期（性）的；定期的",
                example:
                  "Do a periodic review of your lecture notes and the relevant chapters in your textbooks.",
              },
            ],
          },
        ],
      },
      {
        word: "neutrino",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/efc67dd610296a080e2894264ead2c71ea522483_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/njuːˈtriːnəʊ/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C]中微子",
              },
            ],
          },
        ],
      },
      {
        word: "inhabitant",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/608a5552657651719f82edfcd82ae46a1ae6d0ae_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈhæbɪtənt/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a person or animal that lives in a particular place 居民；栖居的动物",
                example:
                  "According to the report, the city's first inhabitants arrived in the 16th century.",
              },
            ],
          },
        ],
      },
      {
        word: "detection",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/54a564f901078aad6af6fada7c0fe38f32d2ada1_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪˈtekʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] the fact or process of noticing or discovering sth. 觉察；发现；侦察；探测",
                example:
                  "There should be a more effective treatment for patients identified through early detection.",
              },
            ],
          },
        ],
      },
      {
        word: "property",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7143f5c67164ff130324f6e3da829da26b2771ff_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈprɒpəti/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) [C, usu. pl.] a quality or power that a substance, plant, etc. has 特性；性质；属性",
                example:
                  "For practical purposes the solar spectrum (光谱) is divided into regions with characteristic properties.",
              },
              {
                explanation:
                  "2) [U] the thing or things that sb. owns 所有物；资产；财产",
                example:
                  "Please take care of your own belongings. The hotel is not responsible for any loss or damage to guests' personal property.",
              },
            ],
          },
        ],
      },
      {
        word: "restrict",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/633fa69389466f1c42ba36f9bbc0cc387e1b83ff_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/rɪˈstrɪkt/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  " 1) ( ~ yourself / sb. to sth. / to doing sth. ) allow yourself or sb. to have only a limited amount of sth. or to do only a particular kind of activity 约束；限制",
                example:
                  "The senator said he would voluntarily restrict himself to $2.2 million in campaign spending",
              },
              {
                explanation:
                  "2) limit the size, amount or range of sth. 限制，限定 （大小、数量、范围等）",
                example:
                  "Because of space, the number of people who can attend the ceremony is restricted to 35.",
              },
            ],
          },
        ],
      },
      {
        word: "solar",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a41793222298d3bbe752035525fdffbb8b64f0ea_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈsəʊlə/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "(only before noun)  of or connected with the Sun 太阳的",
                example:
                  "An increase in the number of dark spots on the Sun marks a period of high solar activity.",
              },
            ],
          },
        ],
      },
      {
        word: "doom",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/29b930e79fc32fe3c635fed45b73e6bbec489d82_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/duːm/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "(usu. passive)  make sb. / sth. certain to fail, die, be destroyed, etc. 使注定（失败、死亡、毁灭等)",
                example:
                  "A rare star system has been found in our Milky Way galaxy, but it is doomed to end in a massive explosion.",
              },
            ],
          },
        ],
      },
      {
        word: "extraterrestrial",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/096b1cac84baeb41d945ff060a143d3a4354bb4a_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌekstrətəˈrestriəl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  " relating to things that exist outside the Earth 地球外的；宇宙的；外星的",
                example:
                  "Over the years, we've been conditioned to accept the possibility of extraterrestrial life through movies and reports about alien encounters.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Phrases and expressions",
    children: [
      {
        word: "on occasion",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2cf196d3d2ded18be6775a71290dda1c851bd096_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "sometimes but not often 偶尔；偶然；有时",
                example:
                  "We no longer keep up a close friendship, though we still visit each other on occasion.",
              },
            ],
          },
        ],
      },
      {
        word: "on sb.'s (own) terms",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/908a14d5dbe14acf0a88a4edb681b83f25fe41e0_96k.mp3#duration=5.5&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "according to the conditions that sb. wants 按照...的条件；根据...的主张hink about sth. that happened in the past 回忆起；回顾",
                example:
                  "Don't just accept this job because it would make your parents happy — you need to act on your own terms for once.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Proper names",
    children: [
      {
        word: "William Trubridge",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a2bd8e09f2e8319d71654257c52a5811898baf9f_96k.mp3#duration=2.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈtruːˌbrɪdʒ/",
            explanations_and_examples: [
              {
                explanation: "威廉.特鲁布里奇（新西兰自由潜水运动员",
              },
            ],
          },
        ],
      },
      {
        word: "PBS (Public Broadcasting Service)",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/af968a629170d677ed530bbacd10cf4cc6f72154_96k.mp3#duration=4.2&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "（美国）公共广播公司",
              },
            ],
          },
        ],
      },
      {
        word: "Jupiter",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a96ad7f7a900580b4c5d4e56a26d2d8a6ac1a7cd_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈdʒuːpɪtə/",
            explanations_and_examples: [
              {
                explanation: "木星（太阳系中最大的行星）",
              },
            ],
          },
        ],
      },
    ],
  },
];

book3[4] = [
  {
    name: "New words",
    children: [
      {
        word: "epic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3de2933a9969826b41751c11b0ba6799f86eafa7_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈepɪk/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) happening over a long period and involving a lot of difficulties 漫长而艰难的",
                example:
                  " Three generations of fishermen conduct an epic struggle against nature, fate, and society in this moving tale.",
              },
              {
                explanation:
                  "2) telling a long story about brave actions and exciting events 英雄的；英勇的；史诗般的",
                example:
                  "This island is a place of great adventures and epic tales, inhabited by five tribes.",
              },
            ],
          },
        ],
      },
      {
        word: "amid",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/5ecc3829faf35768349c9bd41eb3fc2f2cb9efe1_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈmɪd/ 【prep.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) among or surrounded by 在...之中；被....所环绕",
                example:
                  " We camped that night in a shallow valley amid low hills covered with green pine trees.",
              },
              {
                explanation:
                  "2) while noisy, busy, or confused events are happening — used in writing or news reports 在（嘈杂、纷乱的时间）中（用于书面语或新闻报道中）",
                example:
                  "The dollar has fallen in value amid rumors of weakness in the US economy.",
              },
            ],
          },
        ],
      },
      {
        word: "jagged",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/998e1e6c10db62410d4352017768da2de66f203c_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈdʒægɪd/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "having a rough or pointed edge or surface 凹凸不平的；锯齿状的",
                example:
                  "For centuries, the Rocky Mountains have captivated visitors with their jagged peaks, magnificent waterfalls, and blue lakes.",
              },
            ],
          },
        ],
      },
      {
        word: "haze",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3c9c4699321b63f0c93bc1bfad42b2454a1e0d2e_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/heɪz/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U, sing.] smoke, dust, or mist in the air which is difficult to see through 烟雾；霾",
                example:
                  "Just as the Sun began to break through an early-morning haze, I spotted three horses on a hill.",
              },
            ],
          },
        ],
      },
      {
        word: "tinge",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9e1a65187673780d1c9d9c0a163cc1a257647527_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/tɪndʒ/  【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "give sth. a small amount of a particular color, emotion, or quality 着淡色于；使带有一点（情绪、特质等）",
                example:
                  "The light of the setting Sun tinges the buildings with delicate colors.",
              },
            ],
          },
        ],
      },
      {
        word: "shade",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/29d725fa92f0050972ae46f0f2f332c767a26baa_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ʃeɪd/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) [C] a particular type of red, green, blue, etc. （色彩的）浓淡，深浅，色度",
                example:
                  "The bright yellow shade is meant to evoke the optimistic promise of a sunshine-filled day.",
              },
              {
                explanation:
                  "2) [U] slight darkness or shelter from the direct light of the Sun made by sth. blocking it 背阴处；阴凉处",
                example:
                  "I spent most of the day walking on the shore or reading a novel in the shade of a large beach umbrella.",
              },
            ],
          },
        ],
      },
      {
        word: "abiding",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/20fdb1efbe32ab4fa76fa22d2d37171a34c22c21_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈbaɪdɪŋ/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "(of a feeling, belief, etc.) lasting for a long time and not changing （感情或信念等）长久的，持久的",
                example:
                  "My abiding memory is of him watering his plants in the garden on sunny afternoons.",
              },
            ],
          },
        ],
      },
      {
        word: "scholar",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/bae726f026fe0e118debd4de4c41eb9955e75d18_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈskɒlə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] sb. who knows a lot about a particular subject, esp. one that is not a science subject （尤指精于一门文科学问的）学者",
                example:
                  "He is internationally recognized as a distinguished scholar in the field of Chinese studies.",
              },
            ],
          },
        ],
      },
      {
        word: "conqueror",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ee31a81f83ab49f85bd5e5df9bc17e474d013f41_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkɒŋkərə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] sb. who takes complete control of a country or its people 征服者",
                example:
                  "Local people have to obey their conquerors because they want to go on living.",
              },
            ],
          },
        ],
      },
      {
        word: "swerve",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/96bc211575c43003217fd5613508ac86a6332be0_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/swɜːv/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "make a sudden sideways movement while moving forward, usu. in order to avoid hitting sth. （通常为了避免碰撞）突然转向一边",
                example:
                  "The vehicle swerved off the road, hit a lamppost and rolled several times before catching fire.",
              },
            ],
          },
        ],
      },
      {
        word: "shimmy",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9f6f559a6967797c252c6cbcd6d6e5abf126f8e6_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈʃɪmi/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "move forward or backward while also quickly moving slightly from side to side  一摇一摆地走（移动）",
                example:
                  "The performer shook, jumped and shimmied in perfect motion, spurring the crowd to rise in an emotional applause.",
              },
            ],
          },
        ],
      },
      {
        word: "trundle",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c3db5f716dc75e8f831e7caf3664e86b01a7321a_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈtrʌndl/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "move slowly along on wheels, or make sth. do this by pushing or pulling it （使）缓慢移动（滚动）",
                example:
                  "Hundreds of trucks full of fruit and vegetables trundle across the border each day.",
              },
            ],
          },
        ],
      },
      {
        word: "caravan",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/de0cea274c3f1f8be4155e3255db2257a498cb47_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkærəˌvæn/",
            explanations_and_examples: [
              {
                explanation:
                  "1) （尤指穿越沙漠地带的）旅行队，商队 \n 2)（带有食宿设备的）旅行拖车",
                example: "",
              },
            ],
          },
        ],
      },
      {
        word: "spice",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/de0cea274c3f1f8be4155e3255db2257a498cb47_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/spaɪs/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C,U] 香料",
              },
            ],
          },
        ],
      },
      {
        word: "fell",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a5b2b190648a607b656bf17fd67a3629fd65eba6_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/fel/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) (written) knock sb. down with great force （用力）击倒（某人）",
                example:
                  " A 25-year-old man was felled by that boxer with a single punch.",
              },
              {
                explanation: "2) cut down a tree 砍伐（树木)",
                example:
                  "Fifteen million trees were felled by the Great Storm which hit the south of England in 1987.",
              },
            ],
          },
        ],
      },
      {
        word: "peril",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c9795741eb833642eeb094a5f51a86c322ace7c1_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈperəl/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1)[C, usu. pl.] (lit. or fml.)  a danger or problem in a particular activity or situation （某活动或情况的）危险，凶险",
                example:
                  "These birds are able to survive the perils of the Arctic winter.",
              },
              {
                explanation:
                  "2)[U] (lit. or fml.) great danger, esp. of being harmed or killed 巨大的危险（尤指受损或被杀）",
                example:
                  "This was the second time that he had put his life in peril to rescue someone at risk of drowning.",
              },
            ],
          },
        ],
      },
      {
        word: "climatic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/bca8de07fc468de3b2c904721fb3e113f2c68550_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/klaɪˈmætɪk/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "relating to the weather in a particular area 气候的",
                example:
                  "It should be noted that some parts of the world seem to be experiencing climatic changes.",
              },
            ],
          },
        ],
      },
      {
        word: "traverse",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/006e729d8d90f3d7bd9a3abc3f5c5ec8acff37e7_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/trəˈvɜːs/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml.) move across, over, or through sth., esp. an area of land or water 跨过；穿过；横越；横穿",
                example:
                  "They crossed the bridge and traversed the road out into the open country.",
              },
            ],
          },
        ],
      },
      {
        word: "hostile",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f329a5f42609e2f6b2eef55c32468680ed73580f_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈhɒstaɪl/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "1) belonging to an enemy 敌人的；敌方的",
                example:
                  "They warned us that the northern half of the island was controlled by hostile forces.",
              },
              {
                explanation:
                  "2) angry and deliberately unfriendly toward sb. and ready to argue with them 怀有敌意的；敌对的；不好的",
                example:
                  "Rebecca was very hostile toward us and made it clear she didn't want our help.",
              },
            ],
          },
        ],
      },
      {
        word: "territory",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/52ea97b5a4a8221d735431c861f89bff09e116fc_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈterətri/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C,U] land that is owned or controlled by a particular country, ruler, or military force 领土；版图；领地",
                example:
                  "The new oil contracts will amount to a half billion dollars' worth of foreign investment in their territory.",
              },
            ],
          },
        ],
      },
      {
        word: "persist",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d04fb578e1ee9b72aba7e244375a1f3a176059f2_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/pəˈsɪst/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "continue to do sth., although this is difficult, or other people oppose it 坚持；执意",
                example:
                  "He urged the United States to persist with its efforts to bring about peace.",
              },
            ],
          },
        ],
      },
      {
        word: "thirst",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c4219888258c0adcb191e49598704237bbebd123_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/θɜːst/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[sing.] the feeling of wanting or needing a drink 渴；口渴",
                example:
                  "After walking five miles, they had worked up a great thirst and decided to stop for water.",
              },
            ],
          },
        ],
      },
      {
        word: "ideology",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d06a7588d48fd7f10f5a627d9bc29daabdb7f807_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌaɪdiˈɒlədʒi/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C,U] a set of beliefs on which a political or economic system is based, or which strongly influence the way people behave 思想（体系）；思想意识",
                example:
                  "To put it another way, the analysis lacks both a sense of humanism and a theory of ideology.",
              },
            ],
          },
        ],
      },
      {
        word: "allure",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/cdbba3d9a40aafa8612fea7599519505f16bc2eb_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈlʊə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U, sing.] a mysterious, exciting, or desirable quality 诱惑；魅力；吸引力",
                example:
                  'There will always be "lost in translation" moments, but that\'s part of the allure of foreign travel.',
              },
            ],
          },
        ],
      },
      {
        word: "intrinsic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6d64cb6516d6804bd33d477548fc33bade786f39_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈtrɪnsɪk/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "being part of the nature or character of sb. / sth. 本质的；内在的；固有的",
                example:
                  "The intrinsic value of a coin is the value of the metal it is made of.",
              },
            ],
          },
        ],
      },
      {
        word: "romance",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/fbd8a0078bec5460f8c1109b322b007a3828c39b_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/rəʊˈmæns/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) [U] the feeling of excitement and adventure that is related to a particular place, activity, etc. 传奇色彩；浪漫情调",
                example:
                  "There are plenty of ways to see the country this summer, but few can beat the romance of traveling on a steam train.",
              },
              {
                explanation:
                  "2) [C] an exciting and often short relationship between two people who love each other 罗曼史；风流韵事",
                example:
                  "Hemingway's romance with his nurse inspired him to write A Farewell to Arms.",
              },
            ],
          },
        ],
      },
      {
        word: "interpret",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/cf7cf90a5a6799364e0f1679c2cc6688201c6a4e_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈtɜːprɪt/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) believe that sth. sb. does or sth. that happens has a particular meaning理解（解释）为",
                example:
                  "His refusal to work late was interpreted as a lack of commitment to the company.",
              },
              {
                explanation:
                  "2) translate spoken words from one language into another 口译",
                example:
                  "She couldn't speak much English so her children had to interpret for her while traveling in the UK.",
              },
            ],
          },
        ],
      },
      {
        word: "durable",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1d2dd34d9dc511c9b648dbcf169f02063eea0c93_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈdjʊərəbl/ 【a.】",
            explanations_and_examples: [
              {
                explanation: " 1) continuing for a long time 持久的",
                example:
                  "The feelings that arise in that condition are simpler, more understandable, and more durable.",
              },
              {
                explanation:
                  "2) staying in good condition for a long time, even if used a lot 耐用的",
                example:
                  "Fine bone china is very practical due to the fact that it is strong and durable.",
              },
            ],
          },
        ],
      },
      {
        word: "testament",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9ba7ff9fa5ca950d2312be24369a7ff7e207c15f_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈtestəmənt/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " prove or show very clearly that sth. exists or is true 是...的证据；是...的证明",
                example:
                  "The new model is a testament to the skill and dedication of the workforce.",
              },
            ],
          },
        ],
      },
      {
        word: "dazzle",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/99b73950cf14653ad70d946ed74c81c10d7324b3_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈdæzl/ 【vt.】",
            explanations_and_examples: [
              {
                explanation: "1) make sb. feel strong admiration 使...倾倒",
                example:
                  "As children, we were dazzled by my uncle's good looks and charm.",
              },
              {
                explanation:
                  "2) makes sb. unable to see properly for a short time （因强光、闪烁等）使...目眩；使...眼花缭乱",
                example:
                  "Drivers are supposed to slow down or pull over when they are dazzled by bright sunlight.",
              },
            ],
          },
        ],
      },
      {
        word: "retrace",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/5c06ea0cb78190e512ce4e4cf656127460331ab3_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/rɪˈtreɪs/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  " 1) repeat exactly the same journey that sb. else has made 重走（别人走过的路程）",
                example:
                  "They are hoping to retrace the epic voyage of Christopher Columbus.",
              },
              {
                explanation:
                  "2) go back exactly the way you have come 顺原路返回；折返",
                example:
                  "By trailing a thread behind them spiders are able to drop from any height to the ground and to retrace their steps with certainty to a particular spot.",
              },
            ],
          },
        ],
      },
      {
        word: "Buddhist",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6a65a7b9b8ecdc9c1867baae3cafd70f9210aab2_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈbʊdɪst/",
            explanations_and_examples: [
              {
                explanation: "[a.] relating or referring to Buddhism 佛教的",
                example:
                  "Lingyin Temple is a famous Buddhist temple situated in the northwest of Hangzhou.",
              },
              {
                explanation: "[n.][C] sb. who believes in Buddhism 佛教徒"
            }
            ],
          },
        ],
      },
      {
        word: "grotto",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d222461b8718f286100b3a4b3a70acaf57131e3f_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈgrɒtəʊ/",
            explanations_and_examples: [
              {
                explanation: " a small attractive cave 小洞穴",
                example:
                  "This grotto houses the most exquisite stone sculptures from the Tang Dynasty.",
              },
            ],
          },
        ],
      },
      {
        word: "drift",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c596fe4b66420e7fa89248ab39a1171413a71b52_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/drɪft/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) move or go somewhere slowly 缓缓移动；缓慢行走",
                example:
                  "The crowd drifted away from the scene of the accident.",
              },
              {
                explanation: "2) move slowly on water or in the air 漂流；漂移",
                example:
                  "As our boat drifted down the river, many children ran along the shore waving at us.",
              },
            ],
          },
        ],
      },
      {
        word: "scenic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/60e677a823ce0250554d6a1c1c027e7fb054998f_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈsiːnɪk/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "surrounded by beautiful views of nature 景色优美的",
                example:
                  " Yosemite National Park is an area of outstanding scenic beauty and great wilderness value.",
              },
            ],
          },
        ],
      },
      {
        word: "formation",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f314593ac0cafbc3514b07add2d4bf614d762a38_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/fɔːˈmeɪʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) [C, U] rock or cloud that is formed in a particular shape, or the shape in which it is formed （岩石或云朵的）形成物；形状",
                example:
                  "Enormous cloud formations dominate the landscape on a hot, humid summer's day.",
              },
              {
                explanation:
                  "2) [U] the process of starting a new organization or group 构成；组成",
                example:
                  "An agreement on the formation of a new government was reached on June 6",
              },
            ],
          },
        ],
      },
      {
        word: "oasis",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2b2ce548acba61edd228209c9cdeacd8635a6569_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əʊˈeɪsɪs/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] (pl. oases) (沙漠中的）绿洲",
              },
            ],
          },
        ],
      },
      {
        word: "dune",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/54afcdf0a0eae446918e753b68f79dab04509480_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/djuːn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C]（海边或沙漠中的）沙丘",
              },
            ],
          },
        ],
      },
      {
        word: "ridge",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d2476d571244309b6b53ef62a7a7cbffb9d97220_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/rɪdʒ/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a long narrow raised part of a surface, esp. a high edge along a mountain 山脊",
              },
            ],
          },
        ],
      },
      {
        word: "superhighway",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/95c5738286316a73334ba8570f4cce58098f029c_96k.mp3#duration=1.7&t=.mp3,",
        pee: [
          {
            partOfSpeech: "/ˌsuːpəˈhaɪweɪ/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] (AmE) (超级）高速公路",
              },
            ],
          },
        ],
      },
      {
        word: "stretch",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/fc74b3f291b56e81c87b748d0114f5de36323896_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/stretʃ/",
            explanations_and_examples: [
              {
                explanation:
                  "[vi.] spread out or cover a large area of land 延伸；绵延",
                example:
                  " The beach stretches for more than two miles, backed by grassy dunes and sweet-smelling pine forest.",
              },
              {
                explanation:
                  "[v.] make sth. bigger or looser by pulling it, or become bigger or looser as a result of being pulled （使）变大；（使）变松；拉长",
                example:
                  "Once stretched, the elastic band will not return to its original length.",
              },
            ],
          },
        ],
      },
      {
        word: "catapult",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/06752b9861584a33dd297a55bdf577c089b11057_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkætəˌpʌlt/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "push or throw sth. very hard so that it moves through the air very quickly 把...弹（射）出去",
                example:
                  "A loose dog is at the risk of falling or being catapulted out of the truck bed.",
              },
            ],
          },
        ],
      },
      {
        word: "awe",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2e52e0af6fa2e209627b99f7d55e451dc01d95bb_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɔː/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U]  a feeling of great respect and liking for sb. / sth. 崇敬；赞叹",
                example:
                  " You might gaze at the Grand Canyon with awe, marveling at its beauty and fearing its depth.",
              },
            ],
          },
        ],
      },
      {
        word: "sorrow",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2abf89d6b244db8bc0741fb8e7ca55f729361a9a_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈsɒrəʊ/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) [C] an event or situation that makes you feel great sadness 令人悲伤的事；不幸",
                example:
                  "We cannot cure the world of sorrows, but we can choose to live in joy.",
              },
              {
                explanation: "2) [U] a feeling of great sadness, usu. because sth. very bad has happened 悲伤；悲痛",
                example: "The president expressed his deep sorrow over the bombing deaths."
              }
            ],
          },
        ],
      },
      {
        word: "hazardous",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2abf89d6b244db8bc0741fb8e7ca55f729361a9a_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈhæzədəs/【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "involving risk or danger, esp. to sb's health or safety 危险的；有害的",
                example:
                  " The report calls for a ban on the import of hazardous waste.",
              },
            ],
          },
        ],
      },
      {
        word: "bleak",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c1c980288d772469d53a759a32c94a549bfb4d4b_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/bliːk/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "exposed, empty, or with no pleasant features 无遮掩的；荒凉的；索然无味的",
                example:
                  " That's probably the most bare, bleak, and inhospitable island I've ever seen.",
              },
            ],
          },
        ],
      },
      {
        word: "formidable",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4d91b23012635d37b4d5fee29f51c208b016d5eb_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/fəˈmɪdəbl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "very impressive or powerful, and often frightening 令人敬畏的；可怕的",
                example:
                  " They had to overcome formidable obstacles during their journey.",
              },
            ],
          },
        ],
      },
      {
        word: "harsh",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3725e572e4cfe670a52807f4b6e8800cb3cc8199_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/hɑːʃ/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) (of weather or living conditions) very difficult and unpleasant to live in 恶劣的；艰苦的；严峻的",
                example:
                  "Penguins employ cooperative behaviors in order to deal with an incredibly harsh environment.",
              },
              {
                explanation: "2) unpleasantly bright 刺眼的；耀眼的",
                example:
                  "The solar cooker looks impressive, with mirrors designed to catch the harsh sunlight, focusing their power to create intense heat.",
              },
            ],
          },
        ],
      },
      {
        word: "starvation",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/be0da021a627d0695fb81eec03373b12768930fd_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/stɑːˈveɪʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] the state of suffering and death caused by having no food 饥饿；挨饿；饿死",
                example:
                  " Millions of people in that region are threatened with starvation as a result of drought and poor harvests.",
              },
            ],
          },
        ],
      },
      {
        word: "civilization",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a79b72b2cb6460b7f3bb175e2f0be76c603abbb4_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌsɪvəlaɪˈzeɪʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C,U] a society that is well organized and developed, used esp. about a particular society in a particular place or at a particular time 文明（社会）",
                example:
                  "The ancient civilizations of Central and Latin America were founded upon corn.",
              },
            ],
          },
        ],
      },
      {
        word: "precede",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/5058a19a02ac6a45d48985b9517d6908a9c08f41_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/prɪˈsiːd/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml.) happen before sth. or come before sb. / sth. in order 先于（发生或出现）",
                example:
                  "It would be helpful if you were to precede the report with an introduction.",
              },
            ],
          },
        ],
      },
      {
        word: "endurance",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d9ffe46fab2180fe7e569d6cea32cb7371f1b06b_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈdjʊərəns/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] the ability to continue doing sth. difficult or painful over a long period of time （忍）耐力",
                example:
                  "Running a marathon is seen by many people as the ultimate test of human endurance.",
              },
            ],
          },
        ],
      },
      {
        word: "tuck",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7fe38cdb4f5700c08b9becd8fe9f86c789be5b0c_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/tʌk/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "put sth. into a small space, esp. in order to protect, hide, carry, or hold it 把...放起来",
                example:
                  "He picked up a letter that he had carefully tucked under a pile of letters on the desk.",
              },
            ],
          },
        ],
      },
      {
        word: "aviator",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e71ded27b15378e5562ad4a008ba123da26a4320_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈeɪviˌeɪtə/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] a pilot 飞机驾驶员；飞行员",
                example:
                  "Amy Johnson was a pioneering aviator who made record-breaking flights to Australia and South Africa in the 1930s.",
              },
            ],
          },
        ],
      },
      {
        word: "aircraft",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c7c2e94326697f8d3b6f70cbfb9edd2cf09ff393_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈeəˌkrɑːft/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a plane or other vehicle that can fly 飞机；航空器；飞行器",
                example:
                  "Commercial airlines often find it cheaper to park their aircraft at a storage facility than at an airport.",
              },
            ],
          },
        ],
      },
      {
        word: "fashionable",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c99bedc4c1b015da5c44345dbbd460a6f953e795_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfæʃnəbl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "popular, esp. for a short period of time （尤指短期内）时髦的，流行的",
                example:
                  "Reading has become the fashionable educational activity for summer months with schools and libraries running reading challenges.",
              },
            ],
          },
        ],
      },
      {
        word: "meaningless",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c30ce842daa70f6c25da4dd4f77d5c0471b5e738_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmiːnɪŋləs/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "having no purpose or importance and therefore not worth doing or having 无目的的；无意义的；无价值的；不重要的",
                example:
                  "He said a few meaningless words to his hostess and looked around the room.",
              },
            ],
          },
        ],
      },
      {
        word: "functional",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e83bb2e4da44354c27f6f554c16d597252451557_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfʌŋkʃnəl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "designed to be useful rather than beautiful or attractive 实用的",
                example:
                  "Their tips provide guidance to anyone looking to set up a smart and functional workspace at home.",
              },
            ],
          },
        ],
      },
      {
        word: "accessory",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/77e2088e61f8b82bf9b16a11a30dbdf3147333e6_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əkˈsesəri/ 【n.[C]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) [usu. pl.] sth. such as a bag, belt, or jewelry that you wear or carry because it is attractive 装饰物，小配件（如手袋、皮带、珠宝等）",
                example:
                  "This store offers a wide range of clothing, shoes, and accessories for men, women, and children.",
              },
              {
                explanation:
                  "2) [usu. pl.] sth. such as a piece of equipment or a decoration that is not necessary, but that makes a machine, car, room, etc. more useful or more attractive 附件；配件；附属品",
                example:
                  "Accessories such as a carrying case and a battery recharger are free with the purchase of a cell phone.",
              },
            ],
          },
        ],
      },
      {
        word: "apparel",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b8b87f96e9c7ffa2bd01896b790e66ddcdf78900_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈpærəl/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[U] (fml.) clothes 衣服",
                example:
                  "They specialize in the supply of sports apparel such as sweatshirts and baseball caps to retail markets.",
              },
            ],
          },
        ],
      },
      {
        word: "unremarked",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4957675ffc14c6dc3dbca61889c64a79d09fa295_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌʌnrɪˈmɑːkt/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "(fml.) not noticed 不受注意的；未被注意的",
                example:
                  "There are many brave and admirable social workers doing unremarked work across the nation.",
              },
            ],
          },
        ],
      },
      {
        word: "populate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/acff903cd5c08c14a18b614e2b17583ae072a01a_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈpɒpjʊˌleɪt/ 【vt.】",
            explanations_and_examples: [
              {
                explanation: "(usu. passive) live in an area 居住于",
                example:
                  "The world's largest iceberg would possibly crash into an island populated by penguins and seals.",
              },
            ],
          },
        ],
      },
      {
        word: "inclusion",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/51953fe6ca3db93dae9d1009134470c57aa7d8bd_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈkluːʒn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] the act of including sb. / sth. in a larger group or set, or the fact of being included in one 包含；包括",
                example:
                  "Evidence is needed to prove that the word has been used in a variety of different sources before it can be considered for inclusion in one of the dictionaries.",
              },
            ],
          },
        ],
      },
      {
        word: "distinctly",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2efbd83db59d0c83f86652b68e7b96d2f9c06ce3_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪˈstɪŋktli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation: "1) very 十分",
                example:
                  "She is planning to travel to distinctly different destinations in pursuit of happiness and vision.",
              },
              {
                explanation: "2) clearly 清楚地；明显地",
                example:
                  "I distinctly remember asking him not to tell her about the new sales figures.",
              },
            ],
          },
        ],
      },
      {
        word: "catalogue",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8c1cb56271a2be4d18a168345e9799f2a8f5b88f_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkætəˌlɒg/",
            explanations_and_examples: [
              {
                explanation:
                  "(AmE <strong>catalog)[vt.]  1) make a complete list of all the things in a group 为...编目录；把...列入目录中",
                example:
                  "The works came to light during the 1950s, when they were catalogued in the museum's collection.",
              },
              {
                explanation:
                  "(AmE <strong>catalog)[n.][C.] 2) a complete list of things that you can look at, buy, or use, for example in a library or at an art show 目录",
                example:
                  "She uses an online catalogue to search for items by price or country, instead of the hard copies traditionally taken to auctions",
              },
            ],
          },
        ],
      },
      {
        word: "curate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/97e29511d74d74c1d13457ce501181d06d1884af_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌkjʊˈreɪt/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "choose and organize the art, music, objects, etc. for an exhibition, show, concert, etc. 策划组织（展览、表演、音乐会等",
                example:
                  "Focused on artwork inspired by nature, this exhibition is curated by four high school students.",
              },
            ],
          },
        ],
      },
      {
        word: "devoid",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1766da81049f76ba3e0f370bff10cdaedb786bc2_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪˈvɔɪd/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml.) (be ~ of sth.)  completely lacking in sth. 毫无某物；完全没有某物",
                example:
                  "Milly is the most serious person I know — her stories are always completely devoid of humor.",
              },
            ],
          },
        ],
      },
      {
        word: "affective",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e5fafca94207bcdfcd0270d5281ee83b715f19d4_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈfektɪv/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "relating to or having an effect on the emotions 情感的",
                example:
                  "Studies in this area investigate how objects or messages can arouse affective reactions.",
              },
            ],
          },
        ],
      },
      {
        word: "inscribe",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/865ad63d607405c9abca8db8e5e0378362bedb11_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈskraɪb/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "carefully cut, print, or write words on sth., esp. on the surface of a stone or coin （尤指在石头或硬币表面）雕刻，印制，题写",
                example:
                  'She signed the book and inscribed the words "with grateful thanks" on it.',
              },
            ],
          },
        ],
      },
      {
        word: "tangible",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/01e3525287e28f31a4963f59df15cf9959097195_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈtændʒəbl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "clear enough or definite enough to be easily seen or noticed 确凿的；明显的；实在的",
                example:
                  "These fragments provide tangible evidence for how the city has changed since the 18th century.",
              },
            ],
          },
        ],
      },
      {
        word: "coalesce",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d0e14ba80321f36f52c2be5bc7db6dd8f0bae3db_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌkəʊəˈles/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml.) combine and form one single group, substance, etc. 联合；合并",
                example:
                  "His sporting and literary interests coalesced admirably in his writing about climbing.",
              },
            ],
          },
        ],
      },
      {
        word: "fibre",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a93d04f8eafc3450d384c07c78983f4f123bfd01_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfaɪbə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1)（用来做绳子、布等的）纤维,（植物的）纤维，食物纤维",
                example:"",
              },
              {
                explanation: "2) [U] （植物的）纤维，食物纤维",
                example: "",
            }
            ],
          },
        ],
      },
      {
        word: "stitch",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7586eb2a14ee76f94d9280c5744dff3827338a60_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/stɪtʃ/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a short piece of thread that has been sewn into a piece of cloth, or the action of the thread going into and out of the cloth （缝纫中的）一针；缝",
                example:
                  "You'd better put a stitch in the corner of the pocket to keep it in place.",
              },
            ],
          },
        ],
      },
      {
        word: "connectedness",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d1064b0836e0e1ad870b2e9a102099d2ec04fea7_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kəˈnektɪdnəs/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] the feeling people have that they are members of a group in society and that they share particular qualities with other members of that group 相互联系；社会关系",
                example:
                  "Human beings have a need for both independence and connectedness.",
              },
            ],
          },
        ],
      },
      {
        word: "priceless",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ef2af9c24f5236659d3bb362841271b0d87d4545_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈpraɪsləs/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "extremely valuable or important 极其贵重的；极其重要的",
                example:
                  "Her knowledge and experience would make her a priceless asset to the team.",
              },
            ],
          },
        ],
      },
      {
        word: "conservation",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/22468afd93ad9141452d130dea0dd97f5a17bb73_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌkɒnsəˈveɪʃn/ 【n. [U]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) the act of preventing sth. from being lost, wasted, damaged or destroyed 保存；保护；节约",
                example:
                  "The project includes the conservation of 200 paintings, 15,000 books and quantities of furniture, ceramics and textiles.",
              },
              {
                explanation:
                  "2) the protection of natural things such as animals, plants, forests, etc., to prevent them from being spoiled or destroyed （动植物、森林等的）保护",
                example:
                  "China is one of the few places in the world where the elephant population is growing thanks to extensive conservation efforts",
              },
            ],
          },
        ],
      },
      {
        word: "accession",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ff6f97facae827b5bd56d77fe43df78b36ccf65c_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əkˈseʃn/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "record the addition of a new item to a library, museum, etc. 将（图书馆、博物馆等的新书、新展品）登记入册",
                example:
                  "Objects will be accepted and accessioned into the museum's collections when these conditions are met.",
              },
            ],
          },
        ],
      },
      {
        word: "incumbent",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/eda534a6d6cdadcef496d64bea997c1935eb0bd5_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈkʌmbənt/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml.) (~ upon / on sb. )  necessary as part of sb's duty 有责任的；有义务的；必须履行的",
                example:
                  "It is incumbent upon parents to control what their children watch on TV.",
              },
            ],
          },
        ],
      },
      {
        word: "guardian",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/414f6990469a503b4aaaa652bead4b73f75af5be_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈgɑːdiən/ 【n. [C]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) (fml.) sb. who guards or protects sth. 维护者；保卫者",
                example:
                  "These oral historians were the guardians of traditional values and the teachers of lessons about the natural world.",
              },
              {
                explanation:
                  "2) sb. who is legally responsible for looking after sb. else's child, esp. after the child's parents have died 监护人",
                example:
                  "The girl's parents or guardians must give their consent before she has the operation.",
              },
            ],
          },
        ],
      },
      {
        word: "album",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/57e149c5aea55ef8579bf23a953d886231068b09_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈælbəm/ 【n. [C]】",
            explanations_and_examples: [
              {
                explanation:
                  " 1) a book that you put photographs, stamps, etc. in （收存照片、邮票等的）簿，册",
                example:
                  "We've put the best wedding photos into an album — do you want to see them?",
              },
              {
                explanation:
                  "2) a group of songs or pieces of music on a CD, tape, etc. （歌曲或音乐的）专辑",
                example:
                  "The singer talked about the inspiration behind the creation of each track from his newly released album.",
              },
            ],
          },
        ],
      },
      {
        word: "organically",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1da24b8a28a938e1a9266b9020fe6a1129675bbd_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɔːˈgænɪkli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) in a way of happening or developing in a natural and continuous process 自然地；持续地",
                example:
                  "The company has been growing organically over the past few years.",
              },
              {
                explanation:
                  "2) in a way of growing food without using artificial chemicals 不使用化肥地；有机地；绿色地",
                example:
                  "There is firm evidence that organically grown crops are healthier to eat than conventional ones.",
              },
            ],
          },
        ],
      },
      {
        word: "scattered",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b81ae4ed21406bb99428acd3581395e9d1cf6d0c_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈskætəd/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "spread over a wide area or over a long period of time 分散的；稀疏的",
                example:
                  "The higher cost of providing full services to a scattered community cannot be ignored.",
              },
            ],
          },
        ],
      },
      {
        word: "cabinet",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7b7c4792da15411c8231b38d7fefd9cce82aec77_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkæbɪnət/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a piece of furniture with doors and shelves or drawers, used for storing or showing things （有拉门、搁板或抽屉的）储藏柜，陈列柜",
                example:"",
                },
            ],
          },
        ],
      },
      {
        word: "festivity",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/05541bc031ec3165c56c5b73196f1fbdc4538f37_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/feˈstɪvəti/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "(festivities) [pl.] things such as drinking, eating, or dancing that are done to celebrate a special occasion 庆祝活动；庆典",
                example:
                  "This year's festivities included fireworks, light shows and a live concert in King International Stadium.",
              },
            ],
          },
        ],
      },
      {
        word: "uniqueness",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/05541bc031ec3165c56c5b73196f1fbdc4538f37_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/juːˈniːknəs/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] the quality of being unusually good, special or the only one of its kind 不同寻常；独特；独一无二",
                example:
                  "It is the uniqueness of her painting style for which she has been remembered over the past decades.",
              },
            ],
          },
        ],
      },
      {
        word: "thread",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/40ba6230a0b3d1bb53805bd13a71207b8c304795_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/θred/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C, U] a long thin string of cotton, silk, etc. used to sew or weave cloth （缝衣服的）线",
                example:"",
                },
            ],
          },
        ],
      },
      {
        word: "iteration",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/0add72d7abf691de572aa812f6c24b840179d929_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌɪtəˈreɪʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C,U] the act or process of repeating 重复",
                example:
                  "Companies should focus on customer experiences and strive to improve those experiences through constant iteration.",
              },
            ],
          },
        ],
      },
      {
        word: "purposefully",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/003dd537b5bc1977b17e3a7762e22084a24704a3_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈpɜːpəsfli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  " with a clear aim or purpose, determinedly 有目的地；有决心地；果断地",
                example:
                  "Upon hearing these words, she began walking slowly but purposefully toward the bridge.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Phrases and expressions",
    children: [
      {
        word: "trick sb. into sth. / doing sth",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b710f38ea997d5b254fe6c16444d8ac55d188224_96k.mp3#duration=7.7&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "cause sb. to do sth. by means of a trick 用计诱使某人做某事",
                example:
                  "Dean tricked the old lady into giving him 800 pounds, claiming that he would invest it for her.",
              },
            ],
          },
        ],
      },
      {
        word: "set sail (from / to / for )",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9b32fddb3cb2f410e93f45e85863ee872b793907_96k.mp3#duration=8.3&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "begin a journey by boat or ship 起航",
                example:
                  "When Captain Cook set sail for the Pacific, he was heading to parts of the world that were little-known.",
              },
            ],
          },
        ],
      },
      {
        word: "during / in / throughout / over the course of sth.",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/dc0b4fad6bb50ddc9da184fc94783abed2f466b1_96k.mp3#duration=13.4&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "during sth...期间",
                example:
                  "We struck up a conversation, in the course of which it emerged that he was a sailing man.",
              },
            ],
          },
        ],
      },
      {
        word: "contend with",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e353022478068277e9c6065f8d22740aa04508d4_96k.mp3#duration=2.2&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "have to deal with a problem or difficult situation （不得不）处理问题，对付困境",
                example:
                  "The rescue team also had bad weather conditions to contend with.",
              },
            ],
          },
        ],
      },
      {
        word: "tuck away",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7d47229b079f5dc6e07202a9eebd2ea62baa1bcb_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "store or hide sth. 将某物存起来或藏起来",
                example:
                  "Every member of the family can now tuck away either £9 or £18 a month in one of these savings plans.",
              },
            ],
          },
        ],
      },
      {
        word: "in existence",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9b4c51b1c55510ab3c646b62fe086617d38640a8_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "in the state of existing 存在",
                example:
                  "That's why there are tens of thousands of start-ups in existence today.",
              },
            ],
          },
        ],
      },
      {
        word: "it is incumbent upon / on sb. to do sth.",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8962010336ab0359d255dfeac9bcea13cf395622_96k.mp3#duration=8.5&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "it is sb's duty or responsibility to do sth. 做某事是某人的职务（责任）",
                example:
                  "It is incumbent upon all users of this equipment to familiarize themselves with the safety procedure.",
              },
            ],
          },
        ],
      },
      {
        word: "pass away",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/075e3b1f72ae5b2d1d54113c9d6315529b1b91c1_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  'die — use this when you want to avoid saying the word "die" 去世；离世',
                example:
                  "Stephen Hawking, who is known for his groundbreaking work with black holes and relativity, passed away at the age of 76.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Proper names",
    children: [
      {
        word: "Marco Polo",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/90f59bf538f0082f011f003cf495b79a097611b8_96k.mp3#duration=2.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌmɑːkəʊ ˈpəʊləʊ/",
            explanations_and_examples: [
              {
                explanation: "马可.波罗 （意大利旅行家）",
              },
            ],
          },
        ],
      },
      {
        word: "Common Era",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c12ba6f7eee13289eb3f02c27e4d547c5fe04826_96k.mp3#duration=2.4&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "公元",
              },
            ],
          },
        ],
      },
      {
        word: "Constantinople",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/20e59850624ecf9fb431aa011569d1c5e34bc7d6_96k.mp3#duration=2.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌkɒnstæntɪˈnəʊpl/",
            explanations_and_examples: [
              {
                explanation: "君士坦丁堡（伊斯坦布尔的旧称）",
              },
            ],
          },
        ],
      },
      {
        word: "Mario Messina",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/5a20e98c43bd2cca41720f15e8b2a8855313d632_96k.mp3#duration=2.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌmɑːliəʊ meˈsiːnə/",
            explanations_and_examples: [
              {
                explanation: "马里奥...梅西纳（人名）",
              },
            ],
          },
        ],
      },
    ],
  },
];

book3[5] = [
  {
    name: "New words",
    children: [
      {
        word: "disclose",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8c18eafccb62337927ec8c2e435b6c87709ca021_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪsˈkləʊz/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml.) make sth. publicly known, esp. after it has been kept secret 透露；揭露；泄露",
                example:
                  "The spokesman of the company refused to disclose more details of their latest project to the press.",
              },
            ],
          },
        ],
      },
      {
        word: "codger",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d8065b5809bd9a57cbaba2b941050fa81d93f5e2_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkɒdʒə/ 【n.】",
            explanations_and_examples: [
              {
                explanation: " (old ~ ) (infml. not polite) an offensive word for an old man 老家伙；老东西",
              },
            ],
          },
        ],
      },
      {
        word: "commonplace",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a2312e11c75123e6404085e052b8ed1fca40549c_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkɒmənˌpleɪs/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "happening or existing in many places, and therefore not special or unusual 常见的；屡见不鲜的",
                example:
                  " With the improvement of the people's living standard, foreign travels have become commonplace.",
              },
            ],
          },
        ],
      },
      {
        word: "replacement",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/89a35dd4e920df81f7ab078ccaa562be106029a1_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/rɪˈpleɪsmənt/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a thing that replaces sth, esp. because the first thing is old, broken, etc. 替代品；替换物",
                example:
                  "Just two months ago, he underwent hip replacement surgery that cost $120,000.",
              },
            ],
          },
        ],
      },
      {
        word: "abolish",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/57119861f10467e68bffb13f5e8b8c9cfbfcd073_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈbɒlɪʃ/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "officially get rid of a law, system, practice, etc. 废止；废除；取消",
                example:
                  "It was only at the very end of the 19th century that this practice was abolished.",
              },
            ],
          },
        ],
      },
      {
        word: "suspend",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b0dda162af924a5b74ba0eac16f3929a2a9e0f38_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/səˈspend/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "stop sth. from being active, either temporarily or permanently 暂停 ; 中止",
                example:
                  "We have decided to suspend all production at the factory until safety checks can be carried out.",
              },
            ],
          },
        ],
      },
      {
        word: "optimist",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b0dda162af924a5b74ba0eac16f3929a2a9e0f38_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɒptɪmɪst/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] sb. who believes that good things will happen 乐观者；乐观主义者",
                example:
                  "He's an eternal optimist. He always expects good things to happen or things to be successful.",
              },
            ],
          },
        ],
      },
      {
        word: "longevity",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/fa5aeda258c86b045c1ef7f40d4fdb025fff2422_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/lɒnˈdʒevəti/ 【n.[U]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) long life or the long time that sth. lasts 长寿",
                example:
                  "He attributes his longevity to a simple diet and a glass of wine every day.",
              },
              {
                explanation: "2) the amount of time that sb. / sth. lives 寿命",
                example:
                  "For the first time it seemed possible to measure the body like a machine to test its longevity.",
              },
            ],
          },
        ],
      },
      {
        word: "prolong",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1d06ce3290e408152c44776b03a1e116c0dfc119_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/prəˈlɒŋ/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "deliberately make sth. such as a feeling or an activity last longer 延长，拉长，拖长（感觉或活动）",
                example:
                  "Doctors say these new drugs can reduce pain and prolong life for two or three years.",
              },
            ],
          },
        ],
      },
      {
        word: "immediate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/83934005b3065d23a62c6102648fead01f79ab30_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪˈmiːdiət/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) (only before noun) existing now, and needing to be dealt with quickly 目前的；当下的；紧迫的",
                example:
                  "Let's try and solve the most immediate problems before they get worse.",
              },
              {
                explanation:
                  "2) happening or done at once and without delay 立刻的；即刻的",
                example:
                  "If the eyes are affected by the drug, you must seek immediate medical attention.",
              },
            ],
          },
        ],
      },
      {
        word: "inaccessible",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4162c23f9f1b7383270363abf2d4e0cd5186e0d1_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌɪnəkˈsesəbl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) difficult or impossible to afford or understand 得不到的；难懂的",
                example:
                  "The language of teenagers is often completely inaccessible to the elderly.",
              },
              {
                explanation:
                  "2) difficult or impossible to reach 难到达的 ; 不可及的",
                example:
                  "A long flight of stairs made the center of the museum inaccessible to disabled visitors.",
              },
            ],
          },
        ],
      },
      {
        word: "discriminate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3c752ee990fb3f535071874ea76f5ffe0f17a733_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪˈskrɪmɪˌneɪt/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "treat a person or group differently from another in an unfair way （不公正地）区别对待，歧视",
                example:
                  "Caulfield claimed the company had discriminated against him because of his nationality.",
              },
            ],
          },
        ],
      },
      {
        word: "whip",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d7090762b81da4b6a5477ea7e1db1170586f201e_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/wɪp/ 【n.】",
            explanations_and_examples: [
              {
                explanation: " 鞭子",
                example: "",
              },
            ],
          },
        ],
      },
      {
        word: "youthfully",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7c2024e039597b389802e985406a5b18fb6f2565_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈjuːθfli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "in a way that is similar to, typical of, or relates to young people 年轻地；像年轻人地；具有年轻人特点地",
                example:
                  "Melania believes that dressing youthfully is about keeping up with trends.",
              },
            ],
          },
        ],
      },
      {
        word: "vigorous",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/54ec05ed4977679fa3bdf7fc6989cf30b42e549c_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈvɪɡ(ə)rəs/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "1) strong and healthy 强健的；精力旺盛的",
                example:
                  "Cutting the bush back in the autumn will help promote vigorous growth in the spring.",
              },
              {
                explanation:
                  "2) using a lot of energy and strength or determination 强度大的；积极的",
                example:
                  "According to a recent survey, a quarter of people over 12 get no vigorous exercise at all.",
              },
            ],
          },
        ],
      },
      {
        word: "hidebound",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/071fc1babf928750ee3b9ba1e1500216f972936f_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈhaɪdˌbaʊnd/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "having old-fashioned attitudes and ideas — used to show disapproval 古板的，守旧的（含贬义）",
                example:
                  "Tim was rude, unable to bear criticism, and more and more hidebound in his views as he got older. ",
              },
            ],
          },
        ],
      },
      {
        word: "recapture",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/45aac2ab4a92b98f0783f400625974e355f4e8b2_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/riːˈkæptʃə/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "bring back the same feelings or qualities that you experienced in the past 使重温；使再次经历",
                example:
                  "I would say the film successfully recaptures the joyful style of those days.",
              },
            ],
          },
        ],
      },
      {
        word: "portfolio career",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7d43763460a34bf5e7f94f30f2a70ff992c8b10d_96k.mp3#duration=2.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/pɔːtˈfəʊliəʊ kəˌrɪə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a working life in which you have several different jobs at one time, or a series of different kinds of job 组合型职业",
                example:
                  "There is a trend toward more temporary employment and portfolio careers.",
              },
            ],
          },
        ],
      },
      {
        word: "accordingly",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/35bc06ced6bd38727b49ad7950c4246044326800_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈkɔːdɪŋli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "in a way that is suitable for a particular situation or that is based on what sb. has done or said 相应地",
                example:
                  "It is said that the new employee has broken the rule and will be punished accordingly.",
              },
            ],
          },
        ],
      },
      {
        word: "laborer",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8f2d97a6e450480d0dafb295840719841797472b_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈleɪbərə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] (BrE labourer) sb. whose work needs physical strength, for example building work 体力劳动者；工人",
                example:
                  "Matthew has worked as a laborer in factories and on construction sites since he left his hometown.",
              },
            ],
          },
        ],
      },
      {
        word: "accountant",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7139e764542b5231cdafadef59ddb5d3b350033c_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈkaʊntənt/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] sb. whose job is to keep and check financial accounts, calculate taxes, etc. 会计师；会计",
                example:
                  "People setting up business on their own really need to employ an accountant.",
              },
            ],
          },
        ],
      },
      {
        word: "speculation",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d79e783e03516a128c4d92db9ba3deb5cc4894c7_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌspekjʊˈleɪʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C,U] the act of guessing about the possible causes or effects of sth. without knowing all the facts, or the guesses that you make 猜测；推测",
                example:
                  "There has been a great deal of speculation about what will happen after the president resigns.",
              },
            ],
          },
        ],
      },
      {
        word: "trap",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1e72d3e70eff9fa533562b903899900db97662db_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/træp/ 【n.[C]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) an unpleasant or difficult situation that is difficult to escape from 牢笼；困境",
                example:
                  "Don't fall into the trap of investing all your money in one place. ",
              },
              {
                explanation: "2) （捕捉动物的）夹子，罗网，陷阱",
                example: "",
              },
            ],
          },
        ],
      },
      {
        word: "eternal",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c304eaac2b62fd3948a0bc9e76b5bcef19fa64a4_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪˈtɜːnl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "continuing forever and having no end 永远的；永恒的",
                example:
                  "Three teenage girls took a vow (誓言) of eternal friendship during the summer of 1985.",
              },
            ],
          },
        ],
      },
      {
        word: "wither",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a421413896651dac8aaa50ebe8b1092c9c0861db_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈwɪðə/ 【v.】",
            explanations_and_examples: [
              {
                explanation: "(cause to) dry and die 枯萎；干枯",
                example:
                  "It is a pity that the spring flowers were already beginning to wither.",
              },
            ],
          },
        ],
      },
      {
        word: "cicada",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c541368c3c2d20224d828ef1fe0cf990598f9c60_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/sɪˈkɑːdə/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C]蝉",
                example: "",
              },
            ],
          },
        ],
      },
      {
        word: "caution",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/426b942b57965c814aa41733e9f1f0d817fb8d0e_96k.mp3#duration=1.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkɔːʃn/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "warn sb. that sth. might be dangerous, difficult, etc. 警告；告诫；提醒",
                example:
                  "he business report released on Wednesday cautioned investors against over-optimistic expectations.",
              },
            ],
          },
        ],
      },
      {
        word: "terrific",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/933eb9a45d9c5ed848d75150792e47aab7cb3733_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/təˈrɪfɪk/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "(infml.)  very good, esp. in a way that makes you feel happy and excited 极好的；极棒的",
                example:
                  "The actress who played the fashion designer in the movie was absolutely terrific!",
              },
            ],
          },
        ],
      },
      {
        word: "cram",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/385411cb31ee05b6997a31eb0613d0d7dfd1baf3_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kræm/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "force sth. into a small space 塞进（小空间）；硬塞",
                example:
                  "You have to be realistic — it's difficult to cram everything into a tight schedule.",
              },
            ],
          },
        ],
      },
      {
        word: "cope",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7f3bddba45476914119d12636cef3097b090cd0a_96k.mp3#duration=1.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kəʊp/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "succeed in dealing with a difficult problem or situation （成功地）应付，对付",
                example:
                  "Some young mothers feel that they have got to the stage where they aren't able to cope on their own.",
              },
            ],
          },
        ],
      },
      {
        word: "mortal",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2fe6555b5366cb2c69489d5a1748820539c7784a_96k.mp3#duration=1.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmɔːtl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "not able to live forever 不会长生不死的；终有一死的",
                example:
                  "Her father's death reminded her that she was mortal, and it made her very sad.",
              },
            ],
          },
        ],
      },
      {
        word: "immortality",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e3e160c43b021274a9a2d6c6727f487587d9c88d_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌɪmɔːˈtæləti/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] the state of living forever or being remembered forever 永生；长存；永恒",
                example:
                  "Some people want to achieve immortality through their works.",
              },
            ],
          },
        ],
      },
      {
        word: "fantasist",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/265614d22b7394ac66cdb86f04dd42a9c869f6b0_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfæntəsɪst/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] sb. who often has fantasies, or who confuses fantasy and what is real 幻想家；空想家；不切实际者",
                example:
                  "He is neither a liar nor a fantasist, and he is careful about what he says.",
              },
            ],
          },
        ],
      },
      {
        word: "bucket list",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/21457851aa89d5a371c1515f674267fe18e60232_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈbʌkɪt lɪst/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "a list of things that you want to do before you die 人生心愿清单",
                example:
                  "Traveling to the Potala Palace in Tibet has been on my bucket list for years.",
              },
            ],
          },
        ],
      },
      {
        word: "derive",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b90863f60d252d2c263682116a4e39dc0e3d4d64_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪˈraɪv/ 【v.】",
            explanations_and_examples: [
              {
                explanation: "develop or come from sth. else 源自；源于",
                example: " This word is derived from Latin, meaning .",
              },
              {
                explanation:
                  "【vt.】 get sth., esp. an advantage or a pleasant feeling, from sth. 得到，获得（优势或愉快的感受）",
                example:
                  "Medically, we will derive great benefit from the application of this technique.",
              },
            ],
          },
        ],
      },
      {
        word: "arouse",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/5806dfeb197b90a6dd669a3a554ff243341d04b6_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈraʊz/ 【vt.】",
            explanations_and_examples: [
              {
                explanation: "1) make sb. feel sexually excited 激起....的性欲",
                example:"",
              },
              {
                explanation:
                  "2) make sb. have a particular feeling or attitude 激起（感情、态度）",
                example:
                  "His strange behavior at the meeting yesterday aroused my suspicion.",
              },
            ],
          },
        ],
      },
      {
        word: "cellular",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/56f12363fd9f6af98e762ed0a9c5b281abf960a0_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈseljʊlə/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "consisting of or relating to the cells of plants or animals 由细胞组成的；细胞的",
                example:
                  " Researchers have been observing the course of the disease at the cellular level.",
              },
            ],
          },
        ],
      },
      {
        word: "prompt",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/17b97d67d66f607a6e17903e92ff6b288b5434aa_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/prɒmpt/ ",
            explanations_and_examples: [
              {
                explanation:
                  "[n.]（计算机屏幕上显示准备接受指令的）提示， 提示符 make people say or do sth. as a reaction 引起，激起（某人说或做某事）",
                example:
                  "",
              },
              {
                explanation: "[vt.] make people say or do sth. as a reaction 引起，激起（某人说或做某事）",
                example: "The computer program will prompt the user to enter data where it is required."
            }
            ],
          },
        ],
      },
      {
        word: "command",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/90fe5988df5ce2cb32ca1c3c344003ed0982f69d_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kəˈmɑːnd/ 【n.[C]】",
            explanations_and_examples: [
              {
                explanation: "1) an instruction to a computer to do sth. 指令",
                example:
                  " Check that the computer has executed the commands that you typed in.",
              },
              {
                explanation: "2) an order that should be obeyed 命令；指示",
                example:
                  "An officer stood on one of the tanks and began shouting commands through a loudspeaker.",
              },
            ],
          },
        ],
      },
      {
        word: "circulation",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f880abf300a21a1c38bb32e30583443ccc8bdcc1_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌsɜːkjʊˈleɪʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[U, sing.] the movement of blood around your body 血液循环",
                example:
                  "Stretching is a good way to relax muscles and to increase blood circulation during long-time air travel.",
              },
            ],
          },
        ],
      },
      {
        word: "insulin",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7729a18c7552ed0625d6f597ac67e34abd7667eb_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɪnsjʊlɪn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[U] 胰岛素",
              },
            ],
          },
        ],
      },
      {
        word: "glucose",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/53691a1473d5d328b54c22a890ab8bb8d73a79dd_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈgluːkəʊz/ 【n.】",
            explanations_and_examples: [
              {
                explanation: " 葡萄糖",
              },
            ],
          },
        ],
      },
      {
        word: "testosterone",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/au",
        pee: [
          {
            partOfSpeech: "/teˈstɒstəˌrəʊn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[U] 睾酮",
              },
            ],
          },
        ],
      },
      {
        word: "leptin",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7fd360e0d28c7127dd2a94b77a514faad5459a97_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈleptɪn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[U]瘦蛋白",
              },
            ],
          },
        ],
      },
      {
        word: "overeat",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3467e312678456969bca768140dbf160bdcdc682_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌəʊvərˈiːt/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "eat too much, or eat more than is healthy 吃得过多； 暴食",
                example:
                  "A woman who overeats during pregnancy can cause health problems for her child.",
              },
            ],
          },
        ],
      },
      {
        word: "diffusely",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1aedcb01fb19844611377a1f5fcfbef5ba02ce1b_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪˈfjuːzli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation: "over a wide area 弥漫地；扩散地；漫射地",
                example:
                  "One weakness of the essay is that the information is given diffusely instead of in a certain section, thereby reducing effective communication of ideas.",
              },
            ],
          },
        ],
      },
      {
        word: "thyroid",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/0461c28ae3585692e1395f6bcdcc5ab78d610708_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈθaɪrɔɪd/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] 甲状腺",
              },
            ],
          },
        ],
      },
      {
        word: "sluggish",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6d02ee572adb34d9f0827a980dbd88f8228c0043_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈslʌgɪʃ/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "moving, reacting or working more slowly than normal and in a way that seems lazy 缓慢的；迟缓的；懒洋洋的",
                example:
                  "The company has been rather sluggish in responding to the rapid changes in technology.",
              },
            ],
          },
        ],
      },
      {
        word: "oblivious",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9ebe807c6d7afb5206c4263f34cd1fe9885e5a4d_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈblɪviəs/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "(not before noun) not knowing about or not noticing sth. that is happening around you 不知道的；未察觉到的",
                example:
                  " He went on and on about how successful he was, oblivious to the fact that he had hurt her.",
              },
            ],
          },
        ],
      },
      {
        word: "boost",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8b85c93cfea5ddc693a6e7a0e7b2784535505ba3_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/buːst/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "increase or improve sth. and make it more successful 促进；推动；使兴旺",
                example:
                  "They won the semi-final and this boosted the morale (士气) of the team.",
              },
            ],
          },
        ],
      },
      {
        word: "adrenaline",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3f29b9cc90afbceccd0d35c530f0d04cd4388284_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈdrenəlɪn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "(also adrenalin)[U]肾上腺素",
              },
            ],
          },
        ],
      },
      {
        word: "digit",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a3b25c570f5aecb0d991648bfe309d208b3426ce_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈdɪdʒɪt/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] （从0到9的任何一个）数字",
              },
            ],
          },
        ],
      },
      {
        word: "ephemeral",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ddf7bd9c86c91aa42f32e6c8d486ff3cf658b5cb_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪˈfemərəl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "existing or popular for only a short time 短暂的；只流行一时的",
                example:
                  "Many words appearing during that period were quite ephemeral and have passed into history. ",
              },
            ],
          },
        ],
      },
      {
        word: "inactivate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ca7ce2e3d5aecdafe2a58e8488a21e981c425672_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈæktɪˌveɪt/ 【vt.】",
            explanations_and_examples: [
              {
                explanation: "make inactive 使不活动；使不活跃",
                example:
                  "Researchers have identified antibodies (抗体) that inactivate the virus before it has the chance to change itself.",
              },
            ],
          },
        ],
      },
      {
        word: "kidney",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c52f520589280724563c2458af0bc7a5d37df0f9_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkɪdni/ 【n.】",
            explanations_and_examples: [
              {
                explanation: " [C] 肾；肾脏",
              },
            ],
          },
        ],
      },
      {
        word: "exception",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8dac241be22069f89c47853d2bf9d7d3f1887c2c_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪkˈsepʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C,U] sb. / sth. that is not included in a general statement or does not follow a rule or pattern 例外；除外",
                example:
                  "Few guitarists can sing as well as they can play; Freddie, however, is an exception.",
              },
            ],
          },
        ],
      },
      {
        word: "linger",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/dcef02c1fa4640e353908dfbe95e467df1f06e8c_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈlɪŋgə/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "continue to exist, be noticeable, etc. for longer than is usual or desirable 继续留存（较惯常或理想的时间长）",
                example:
                  "The faint smell of her perfume lingered on in the room long after she had left.",
              },
            ],
          },
        ],
      },
      {
        word: "predictive",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/db5380658d92f0f593285c3d84c15a230e601541_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/prɪˈdɪkətɪv/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "relating to the ability to show what is going to happen in the future 预测的； 预言的；前瞻的",
                example:
                  "Newton's physical theories are a good example of how a scientific theory may be predictive as well as explanatory.",
              },
            ],
          },
        ],
      },
      {
        word: "midway",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/bc65921db93a45a711fef22b172c7cafc0b5f1f6_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌmɪdˈweɪ/ 【a.&ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) when half a period of time has passed （一段时间）在中间的；到一半（的",
                example:
                  "She was interrupted by the chairperson when she was midway through her presentation.",
              },
              {
                explanation:
                  "2) between two places, and the same distance from each of them 在中途（的）；在半路（的）；在中间（的）",
                example:
                  "We are coming close to the midway point between Los Angeles and San Francisco.",
              },
            ],
          },
        ],
      },
      {
        word: "anticipation",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8aa3387fec72449c40756997cd8ea236e2112838_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ænˌtɪsɪˈpeɪʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] a feeling of excitement about sth. enjoyable that is going to happen in the near future 期望；盼望",
                example:
                  "There was a sense of anticipation in the audience as the curtain went up for the play.",
              },
            ],
          },
        ],
      },
      {
        word: "gastrin",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e65bfa4ad0e6e3dfb443a7f6ab919e6849bde1bc_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɡæstrɪn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[U] 胃泌素；促胃液素",
              },
            ],
          },
        ],
      },
      {
        word: "trigger",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3220930a6862e0744cafa1ac0f44d4ef61423346_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈtrɪgə/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  " make sth. happen very quickly, esp. a series of events 引发，激发（尤指一系列事件）",
                example:
                  "There must be specific events which triggered the aggressive displays in your dog.",
              },
            ],
          },
        ],
      },
      {
        word: "acid",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d8e81791f9105a99e1acb1067fdddd273c791da8_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈæsɪd/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C, U] 酸（一种化学物质）",
              },
            ],
          },
        ],
      },
      {
        word: "digestion",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/85644840f5481afead32ea147afc06fd2c327385_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/daɪˈdʒestʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[U] the process of digesting food 消化（过程）",
                example:
                  "Digestion is the organic process by which food is converted into substances that can be absorbed into the body.",
              },
            ],
          },
        ],
      },
      {
        word: "mistakenly",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/df9d4a9e1bce96f17939e09d3f6351816eafee62_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/mɪˈsteɪkənli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation: "wrongly or by mistake 错误地",
                example:
                  "She mistakenly believed that she could get away without paying her taxes. ",
              },
            ],
          },
        ],
      },
      {
        word: "gland",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2fe058de6870c025449983561407fcba7a7aa98d_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/glænd/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] 腺",
                example:"",
              },
            ],
          },
        ],
      },
      {
        word: "tumour",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7d270112027292dc4c6f439509d6879029bdd21b_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈtjuːmə/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] (AmE tumor) 肿瘤；肿块；瘤",
              },
            ],
          },
        ],
      },
      {
        word: "hyperthyroidism",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/488c6b6044452b9f31f610c65dec05819aaae607_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌhaɪpəˈθaɪrɔɪˌdɪzəm/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[U] 甲状腺功能亢进",
              },
            ],
          },
        ],
      },
      {
        word: "stature",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b3016e886cf1e7a5e853237a4da68d6ef8b4e2fa_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈstætʃə/ 【n.[U]】",
            explanations_and_examples: [
              {
                explanation: "1) sb.'s height or size 身高；身材",
                example:
                  " I was by no means short in stature, but next to this man I felt like a dwarf",
              },
              {
                explanation:
                  "2) the degree to which sb. is admired or regarded as important 名声；声望",
                example:
                  "At that time there were no other universities in England equal in stature to Oxford and Cambridge.",
              },
            ],
          },
        ],
      },
      {
        word: "surge",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/12b53b65b038fb2d1947430946e3ccb100f9acc7_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/sɜːdʒ/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) if a large amount of a liquid, electricity, chemical, etc. surges, it moves very quickly and suddenly （大量液体）汹涌；（电流）浪涌；（化学物等）突然涌动",
                example: " Adrenaline surged through her veins.",
              },
              {
                explanation:
                  "2) suddenly move very quickly in a particular direction 迅速涌动；蜂拥向前",
                example:
                  "After the gates of the theater opened, the crowd surged forward and police had to intervene.",
              },
            ],
          },
        ],
      },
      {
        word: "meanwhile",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/89fa8fabdf0f1574c4a4385e61db6ef56918c41d_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmiːnˌwaɪl/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) used for emphasizing the difference between two situations 而（用于强调两种情况之间的差异)",
                example:
                  "Stress can be extremely damaging to your health. Exercise, meanwhile, can reduce its effects.",
              },
              {
                explanation: "2) while sth. else is happening 与此同时",
                example:
                  "The hurricane will reach the island this evening. Meanwhile, residents are being evacuated",
              },
            ],
          },
        ],
      },
      {
        word: "suppress",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ed54439ce202e1bc3a1af5e236d16b0cceffa114_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/səˈpres/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) prevent sth. from growing or developing, or from working effectively 抑制（生长、发展、起作用等）",
                example:
                  "It is probable that the medication will suppress the symptom without treating the condition.",
              },
              {
                explanation:
                  "2) stop opposition or protest using military force or strict laws （凭借武力或严格的法律）平定，制止，镇压",
                example:
                  "Illegal cross-border transactions are very active in this area despite international attempts to suppress them.",
              },
            ],
          },
        ],
      },
      {
        word: "urine",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d76c74cfdbd35229bec1e52f968cdd7738a15cb9_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈjʊərɪn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[U] 尿",
                example:""
              },
            ],
          },
        ],
      },
      {
        word: "pee",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/90a5838cc59ded75f3d34e510af1f0eb341180a5_96k.mp3#duration=1.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/piː/ 【vi.】",
            explanations_and_examples: [
              {
                explanation: "(infml.) pass liquid waste from your body 撒尿",
                example:
                  " need to pee before I leave. It's going to be a long journey.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Phrases and expressions",
    children: [
      {
        word: "cheat death / fate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7b4cbac6269aec2de2cb5a9d8603af5013732a69_96k.mp3#duration=3.9&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "lmanage to avoid death or a very bad situation even though it seemed that you would not be able to 死里逃生；逃脱厄运等",
                example:
                  "Could you explain to us how you cheated death at every stage of the journey?",
              },
            ],
          },
        ],
      },
      {
        word: "over the hill",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ddf9584d5c7a6669e9853a44a41d38e0b19e7297_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "no longer young, and therefore no longer attractive or good at doing things 不再年轻；人老珠黄",
                example:
                  "Kathleen thinks she's over the hill, but she's only 32.",
              },
            ],
          },
        ],
      },
      {
        word: "on offer",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f0263d86065ed9d3295514f5f585bafd4e5d42cf_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "available to be bought, chosen, or used 可买到的； 供使用的；提供的",
                example:
                  "Activities on offer at the beach include sailing, rowing, canoeing and camping. ",
              },
            ],
          },
        ],
      },
      {
        word: "on the / your / its way",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8edb343a2eb40e3e41253aa7507161447f3aa95b_96k.mp3#duration=5.3&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "earriving or happening soon 即将到达（发生）",
                example:
                  "Economists agree that the economic situation is good and recovery is on the way. ",
              },
            ],
          },
        ],
      },
      {
        word: "be on the cards ",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6f5c22b6c64a8c319a8c874bf1d98b3eb7da7385_96k.mp3#duration=4.3&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "seem likely to happen 很可能发生",
                example:
                  "So you think they'll get married next year? - I think it's on the cards.",
              },
            ],
          },
        ],
      },
      {
        word: "wear out ",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/33836ab8914a7f3885a7bb6cab7feaf0854e0678_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "become damaged and useless, or make sth. like this, by using it a lot or for a long time 用坏 ;（使）磨损",
                example:
                  "I bought the pair of boots three years ago and they are beginning to wear out.",
              },
            ],
          },
        ],
      },
      {
        word: "set up shop",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6753d9d741cd455d3a1156486131c2fbfde3e8cc_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "start a business 开业",
                example:
                  "Dr. Rosen closed his downtown practice and set up shop in a suburban neighborhood.",
              },
            ],
          },
        ],
      },
      {
        word: "run in the family",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/18657c83fe6129d62898727772d003c3deeded6a_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "if sth. such as a quality, disease, or skill runs in the family, many people in that family have it （某种品质、疾病、技能等）在家族中遗传，是家族特征",
                example:
                  "All the three kids of the Thompsons are good musicians. The musical talent seems to run in the family.",
              },
            ],
          },
        ],
      },
      {
        word: "the whip hand",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/5589afbd3dfb5d2d08f66275335733c48ed0adcd_96k.mp3#duration=1.9&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "sb. who has the whip hand is in a good position because they can make other people do what they want 支配权；控制权",
                example:
                  "During the last decade, the right wing of the party has held the whip hand over the country.",
              },
            ],
          },
        ],
      },
      {
        word: "round out",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ce8ca8f3a848dc7512db1c268c5ff670d1c5a85c_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "make sth. more complete, esp. by adding another feature （尤指通过增加另一特点而）使更加完美，彻底完成",
                example:
                  "The feedback is that more research and solid evidence are needed to round out the article.",
              },
            ],
          },
        ],
      },
      {
        word: "draw up",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8763f7ae2a7ca5a479a68e4566d96ddeba238fed_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "prepare a written document, such as a list or contract 起草，拟定（名单、合同等）",
                example:
                  "Local authorities have drawn up guidelines on waste treatment and disposal.",
              },
            ],
          },
        ],
      },
      {
        word: "act on / upon",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c8335f23e7e67df607915ae252d08eac3d15a44a_96k.mp3#duration=2.4&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "do sth. because of another person's advice or order, or because you have received information or had an idea 根据...行事",
                example:
                  "A patient will usually listen to the doctor's advice and act on it. ",
              },
            ],
          },
        ],
      },
      {
        word: "top up",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f733d506710331d59d7d3222923dc2fc58bc796d_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "increase the level of sth. slightly so as to bring it back to the level you want 补足；将...增加到所需之量",
                example:
                  "He had to do extra jobs on the weekend to top up his income and support the family.",
              },
            ],
          },
        ],
      },
      {
        word: "sign off",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a445cd1dec0e7b1833e2cae9319c148a813f183c_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "write your final message at the end of an informal letter （写非正式信件时）收笔",
                example:
                  "It's getting late, so she wrote a few more lines and signed off with ",
              },
            ],
          },
        ],
      },
    ],
  },

  {
    name: "Proper names",
    children: [
      {
        word: "Ernest Starling",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8a3107a5886e7872a4a9aba41f7b8c451e9bf869_96k.mp3#duration=2.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌɜːnɪst ˈstɑːlɪŋ/",
            explanations_and_examples: [
              {
                explanation: "欧内斯特 斯塔林（英国生理学家）",
              },
            ],
          },
        ],
      },
      {
        word: "the Royal College of Physician",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2c96084dd2f9fe340e46c9c2e7ea6be338c8db60_96k.mp3#duration=3.2&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "（英国）皇家内科医师学会",
              },
            ],
          },
        ],
      },
      {
        word: "Vodafone",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/5ef38890781c09da426c527bd1ea8d7a39d9effb_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈvəʊdəˌfəʊn/",
            explanations_and_examples: [
              {
                explanation: "沃达丰（世界著名的跨国移动通讯网络公司）",
              },
            ],
          },
        ],
      },
    ],
  },
];

book3[6] = [
  {
    name: "New words",
    children: [
      {
        word: "sphere",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/57e8aeac5efb8039694fcb4d2e33fb4adc5cea65_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/sfɪə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a particular area of activity, work, knowledge, etc. （活动、工作、知识等的）范围，领域",
                example:
                  "Women have been taking more important positions of power in the public sphere.",
              },
            ],
          },
        ],
      },
      {
        word: "foremost",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c160357566dac7bf84570a7fdceb8e86830e673e_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfɔːməʊst/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "the best or most important 最好的；最重要的",
                example:
                  "He is one of the country's foremost authorities on criminal law.",
              },
            ],
          },
        ],
      },
      {
        word: "autobiography",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ce13b65195f8bf450795081b98d7ddc42406708e_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌɔːtəʊbaɪˈɒgrəfi/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C,U] a book in which sb. writes about their own life 自传",
                example:
                  " He gives a vivid description of his childhood in his autobiography.",
              },
            ],
          },
        ],
      },
      {
        word: "prominent",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/45e9a55e0a77c8cb2af63a0caab619d2cdea464e_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈprɒmɪnənt/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "important 重要的；著名的；卓越的；杰出的",
                example:
                  "He played a prominent role in promoting public health awareness in developing countries.",
              },
            ],
          },
        ],
      },
      {
        word: "complement",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4eb30d39eb1b374997034ff1828e34f0953a9457_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkɒmplɪˌment/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "make a good combination with sb. / sth. else 补充；使相配；使完美",
                example:
                  "For the show, the museum is borrowing 20 paintings that complement its own collection.",
              },
            ],
          },
        ],
      },
      {
        word: "complementary",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c2a04844591d87b623132d0378e755bf97e62bf4_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌkɒmplɪˈment(ə)ri/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "complementary things go well together, although they are usually different 互为补充的；互补的",
                example:
                  "The computer and the human mind have different but complementary abilities.",
              },
            ],
          },
        ],
      },
      {
        word: "forefront",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3d0c3fc7b8fe1554fdae9a2cd05aaf5d323f6a5d_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfɔːˌfrʌnt/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "(the ~) a leading or important position 最前线；最前列；最重要的位置",
                example:
                  "The company has always been at the forefront of science and technology.",
              },
            ],
          },
        ],
      },
      {
        word: "criticism",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/63fdab58837b080c223868e6a5b3fb59bd7e278c_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkrɪtɪˌsɪz(ə)m/ 【n.[C, U]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) writing which expresses judgments about the good or bad qualities of books, films, music, etc. （对书、电影、音乐等的）评论",
                example:
                  "Art criticism is about how we evaluate and interpret art.",
              },
              {
                explanation:
                  "2) remarks that say what you think is bad about sb. / sth. 批评；批判",
                example:
                  "My main criticism of the scheme is that it does nothing to help families on low incomes.",
              },
            ],
          },
        ],
      },
      {
        word: "costume",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ebbba4acc9dbda9d27e264c7d4899166ff2862ab_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkɒstjuːm/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) [C, U] clothes that are typical of a particular place or period of time in the past （代表某一特定地方或历史时期的）服装，装束",
                example:
                  "The dancers were in national costume to celebrate the National Day.",
              },
              {
                explannation:
                  "2) [C] a set of clothes worn by an actor or by sb. to make them look like sth., such as an animal, famous person, etc. 戏装；演出服",
                example:
                  "Maybe you should take off that wolf costume and show him how it's done.",
              },
            ],
          },
        ],
      },
      {
        word: "iconic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/59b9aaa68e0e8d694b5962ed5a88751aa181bf70_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/aɪˈkɒnɪk/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "very famous or popular, esp. being considered to represent particular opinions or a particular time （尤指能代表某种观点或某一时代）非常出名的，受欢迎的",
                example:
                  "The Phantom of the Opera must be the most iconic Broadway musical ever, and it's for a good reason — it's so incredible.",
              },
            ],
          },
        ],
      },
      {
        word: "masterpiece",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/de5910f7b54bce2020a37a0214d7b55fa02dc6d8_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmɑːstəˌpiːs/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a work of art, a piece of writing or music, etc. that is of very high quality or that is the best that a particular artist, writer, etc. has produced 杰作；名作；代表作",
                example:
                  "Mary Shelley was just 21 when she published her masterpiece ",
              },
            ],
          },
        ],
      },
      {
        word: "critic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4cc144a4a2fcf579f38dfdd7ee9ff6175562ca86_96k.mp3#duration=0.9&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkrɪtɪk/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] sb. whose job is to make judgments about the good and bad qualities of art, music, films, etc. （艺术、音乐、电影等的）评论家，批评家",
                example:
                  "Have you read the review written by the theater critic of The Sunday Times",
              },
            ],
          },
        ],
      },
      {
        word: "elevate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7d60d6672c719fe599a3004a30a15a7637daacd6_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈeləˌveɪt/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml) move sb. / sth. to a more important level or rank, or make them better than before 提拔；晋升；提升",
                example:
                  "A well-chosen handbag can really elevate a woman's level of fashion.",
              },
            ],
          },
        ],
      },
      {
        word: "utility",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/0eb1bd2e07b5c1431102345a27c4cec0bbb9bb41_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/juːˈtɪləti/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) [U] (fml.) the quality of being useful, or the degree to which sth. is useful 有用；实用性",
                example:
                  "I have severe doubts about the utility of examinations on subjects learned this way.",
              },
              {
                explanation:
                  "2) [C, usu. pl.] a service such as gas or electricity provided for people to use 公用事业（如煤气、电力等）",
                example:
                  "Officials said water supplies and other public utilities in the capital were badly affected.",
              },
            ],
          },
        ],
      },
      {
        word: "temporality",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7b98b4a03cc4436f51d35ce6dc7bb76bf9c62a2a_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌtempəˈræləti/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "the quality of relating to or limited by time 时效性；短暂性",
                example:
                  "He argues that temporality cannot be identified with ordinary clock time.",
              },
            ],
          },
        ],
      },
      {
        word: "constrain",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/bfeb8575cd55bd7c646fd686c15f6fa178459e8e_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kənˈstreɪn/ 【vt.】",
            explanations_and_examples: [
              {
                explanation: "1) limit sth. 限制；束缚",
                example:
                  "Poor soil has constrained the level of crop production in this area.",
              },
              {
                explanation:
                  "2) stop sb. from doing what they want to do 阻止；妨碍",
                example:
                  "Financial factors should not constrain doctors from prescribing the best treatment for patients.",
              },
            ],
          },
        ],
      },
      {
        word: "contour",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/817ba5c484d80d9239af2337040b71c6a21288a5_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkɒntʊə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] the shape of the outer edges of sth. such as an area of land or sb.'s body 外形；轮廓",
                example:
                  "Maybe you can try this seat — it can be adjusted to fit the contours of your back.",
              },
            ],
          },
        ],
      },
      {
        word: "avant-garde",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/030379ff4b7c1d7db3a83aaa0032ab9338bc1815_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌævɒŋ ˈgɑːd/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "avant-garde music, literature, etc. is extremely modern and often seems strange or slightly shocking （音乐、文学作品等）前卫的，先锋派的",
                example:
                  "His paintings are rather too avant-garde for my taste",
              },
            ],
          },
        ],
      },
      {
        word: "distinction",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3f2354ad776894d1bc67b3c7898e935ec2393513_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪˈstɪŋkʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C,U] a clear difference or separation between two similar things 差别；区别；差异",
                example:
                  "We need to draw a distinction between the two events, even though they are both related to financial issues.",
              },
            ],
          },
        ],
      },
      {
        word: "clear-cut",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/fc4a95edabd219d07ce1959090173b7b97c0276f_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌklɪəˈkʌt/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "sharply defined; easy to understand 明确的；易懂的",
                example:
                  "While there are a number of arguments in favor of school uniforms, the issue of whether or not they should be required is not a clear-cut matter.",
              },
            ],
          },
        ],
      },
      {
        word: "blur",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3b91edacc8da6b741552e89923d6e4946c8c5532_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/blɜː/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  " 1) become or make sth. become difficult to distinguish clearly （使）难以区分",
                example:
                  "The design of this museum is meant to blur the distinction between the house and the garden.",
              },
              {
                explanation:
                  " 2) become difficult to see, or make sth. difficult to see, because the edges are not clear （使）（某物）模糊不清",
                example: "The words blurred and danced before his eyes.",
              },
            ],
          },
        ],
      },
      {
        word: "rebel",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7af5bf7b0689fe814cce516132db09680e51821b_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/rɪˈbel/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "oppose or fight against sb. in authority or against an idea or situation which you do not agree with 造反；反抗；反叛",
                example:
                  "A vast majority of the voters rebelled against the high property taxes.",
              },
            ],
          },
        ],
      },
      {
        word: "retrospective",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ce2790acfcfdb36d75f030f0caf70d0d0ef4ff02_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌretrəʊˈspektɪv/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a show of the work of an artist, actor, film-maker, etc. that includes examples of all the kinds of work they have done （画家、演员、电影制作人等作品的）回顾展",
                example:
                  "We timed the release of the film to coincide with a big retrospective of Bosch's paintings at Rotterdam.",
              },
            ],
          },
        ],
      },
      {
        word: "auction",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/69a4ae0d1211930479e7f88898709a6b497bdd37_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɔːkʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C,U] a public meeting where land, buildings, paintings, etc. are sold to the person who offers the most money for them 拍卖（会）",
                example:
                  "If he did not come back in time, his whole property would be sold by auction.",
              },
            ],
          },
        ],
      },
      {
        word: "vintage",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c55aba212a509218e47fd4ded51436b12540673e_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈvɪntɪdʒ/ 【a. (only before noun)】",
            explanations_and_examples: [
              {
                explanation:
                  "1) old, but of high quality 旧式的，老式的（但品质优良)",
                example:
                  "It looks like a vintage cell phone of the last century and weighs about 13 ounces.",
              },
              {
                explanation:
                  "2) vintage wine is good quality wine made in a particular year （某特定年份酿制的葡萄酒）佳酿的，上等的，优质的",
                example:
                  "They served lobster, accompanied by a bottle of vintage champagne.",
              },
            ],
          },
        ],
      },
      {
        word: "couture",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4c655443f6fc50f84737e1ca5b68c228e44ffbe3_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kuːˈtjʊə/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] the design and production of expensive and fashionable clothes, or the clothes themselves 昂贵时装的设计制作；昂贵时装",
                example:
                  "Around 25 designers will show their couture collections during the international fashion week.",
              },
            ],
          },
        ],
      },
      {
        word: "velvet",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/700082d51abd4d91d5476a0149ea10b5fca84f81_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈvelvɪt/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "天鹅绒；丝绒",
                example: "",
              },
            ],
          },
        ],
      },
      {
        word: "framework",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f2285aeb32bdd4abe02d4021b7b58e46a8b5b990_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfreɪmwɜːk/ 【n.[C]】",
            explanations_and_examples: [
              {
                explanation:
                  " 1) ( social / legal / political, etc. framework ) the structure of a society, a legal or political system, etc. 社会 / 法律 / 政治等的框架",
                example:
                  "There is no escaping the fact that we have to act within the existing legal framework.",
              },
              {
                explanation:
                  "2) [usu. sing.] a set of ideas, rules, or beliefs from which sth. is developed, or on which decisions are based 体系；体制；框架；准则",
                example:
                  "This paper provides a useful conceptual framework for future research.",
              },
            ],
          },
        ],
      },
      {
        word: "inescapable",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b06e858d9c8688a4f33034be9699ba95b42831fa_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌɪnɪˈskeɪpəbl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "an inescapable fact or situation is one that you cannot avoid or ignore 不可避免的；不容忽视的",
                example:
                  "She didn't want to confront the inescapable fact that she would have to sell the house.",
              },
            ],
          },
        ],
      },
      {
        word: "constraint",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9b6529cd6419233f8ddbb589209879c5c7959f67_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kənˈstreɪnt/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] sth. that limits your freedom to do what you want 限制；束缚；约束",
                example:
                  "Constraints on spending have forced the company to rethink its plans.",
              },
            ],
          },
        ],
      },
      {
        word: "byproduct",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7b2ff00b19fd60789c88df1318fc79b11633c6bd_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈbaɪˌprɒdʌkt/ 【n.[C]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) an unplanned additional result of sth. that you do 意外附带结果",
                example:
                  "You have to admit that job losses are an unfortunate byproduct of the economic recession.",
              },
              {
                explanation:
                  "2) sth. additional that is produced during a natural or industrial process 副产物；副产品",
                example:
                  "Sugar and its byproduct are the basis of the island's economy.",
              },
            ],
          },
        ],
      },
      {
        word: "aesthetic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e9d6b4c00d6dc110b339ac850066f69466be41ec_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/iːsˈθetɪk/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "connected with beauty and the study of beauty 美学的",
                example:
                  "From an aesthetic point of view, this piece of furniture is a nice design.",
              },
            ],
          },
        ],
      },
      {
        word: "commodity",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/eb648a6725ee1496778eaa0da9e7cc6f3d157dd8_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kəˈmɒdəti/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] a product that is bought and sold 商品",
                example:
                  "Commodity prices can be a useful indicator of inflation, he claimed.",
              },
            ],
          },
        ],
      },
      {
        word: "leverage",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8a410fc9a193d8ff9e1303ec7da7869f4037ee82_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈliːvərɪdʒ/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "use sth. that you already have in order to achieve sth. new or better 借助已有的...实现新（或更好）的目标",
                example:
                  "We can gain a market advantage by leveraging our network of partners.",
              },
            ],
          },
        ],
      },
      {
        word: "collaborate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/33887d4e00c516bb6e7f856a61ab8523b549a36b_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kəˈlæbəˌreɪt/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "work together with a person or group in order to achieve sth., esp. in science or art （尤指在科学或艺术方面）合作，协作",
                example:
                  " Educators and employers need to collaborate in preparing the next generation for employment.",
              },
            ],
          },
        ],
      },
      {
        word: "collaboration",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ebe68be258fd127cf0685602551a5e50e7f9bf19_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kəˌlæbəˈreɪʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C,U] work together with a person or group in order to achieve sth., esp. in science or art （尤指在科学或艺术方面）合作，协作",
                example:
                  "The company is building the center in collaboration with an engineering institute.",
              },
            ],
          },
        ],
      },
      {
        word: "profusion",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7f80540b2cc343478acb4f03f2dd37cdfb024e45_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/prəˈfjuːʒn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[U, sing.] (fml.) a very large amount of sth. 大量；丰富；充沛",
                example:
                  " It is a delightful river with a profusion of wild flowers along its banks.",
              },
            ],
          },
        ],
      },
      {
        word: "nonexistent",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/858a0873d0ad7454d4a60491c998901d12b94fe2_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌnɒnɪgˈzɪst(ə)nt/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "sth. that is nonexistent does not exist at all, or is not present in a particular place 不存在的",
                example:
                  "Her friends never missed a chance to tease her about her nonexistent relationship with Brandon.",
              },
            ],
          },
        ],
      },
      {
        word: "symbiotic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/bb061a30253346819a4b89f0dae3ba5a7f599f23_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌsɪmbaɪˈɒtɪk/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml.) a symbiotic relationship is one in which the people, organizations, or living things involved depend on each other （人、组织或生物）互相依赖的，共生的",
                example:
                  "Do some viruses develop a symbiotic relationship with their host?",
              },
            ],
          },
        ],
      },
      {
        word: "interchange",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e39991176262d8553ff087964ce28e1fc1f888e3_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɪntəˌtʃeɪndʒ/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C,U] an exchange, esp. of ideas or thoughts （尤指观点或思想的）交流",
                example:
                  "What made the meeting exciting was the interchange of ideas from different disciplines.",
              },
            ],
          },
        ],
      },
      {
        word: "rightful",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1d19a77ce772edf6379da93b8179aa0d3235e53c_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈraɪtfl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml.) (only before noun)  according to what is correct or what should be done legally or morally 正确的；合法的；正义的",
                example:
                  "George sat at the head of the table, in his rightful place as their leader.",
              },
            ],
          },
        ],
      },
      {
        word: "elaborate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a97da1524b4a7767810e85afffafc38cf30e3397_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪˈlæb(ə)rət/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "very complicated and detailed; carefully prepared and organized 复杂的；详尽的；精心制作的",
                example:
                  " You need a plain blouse to go with that skirt — nothing too elaborate.",
              },
            ],
          },
        ],
      },
      {
        word: "conceptual",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4ee4f895c499222906346278d0e99cd18960c2f3_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kənˈseptʃuəl/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "(fml.) dealing with ideas, or based on them 概念的",
                example:
                  "Some of us learn experientially, while others are more attracted to logical or conceptual learning.",
              },
            ],
          },
        ],
      },
      {
        word: "spiritual",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/778dfd9e76fe87e5e56c756d655272777417d83f_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/prəˈfjuːʒn/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "relating to your spirit rather than to your body or mind 精神的；心灵的",
                example:
                  "While improving material well-being, we should also enrich our spiritual life.",
              },
            ],
          },
        ],
      },
      {
        word: "computational",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e292a9239084b3d299531c434f7cebe64cfc5866_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌkɒmpjʊˈteɪʃnəl/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "using computers 使用计算机的",
                example:
                  "Students may pursue research in any aspect of computational linguistics based on their own interest.",
              },
            ],
          },
        ],
      },
      {
        word: "emergence",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/45f5bae0905c499f150689b60009b87bb3bace0f_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪˈmɜːdʒ(ə)ns/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] when sth. begins to be known or noticed 出现；显现",
                example:
                  "Future research should look at the behavior and ecology of these worms to understand what caused the emergence of new species.",
              },
            ],
          },
        ],
      },
      {
        word: "consciousness",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2a7fba6259d7148c49fe48c779de9605f26c751c_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkɒnʃəsnəs/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "1) [C, U] mind and thoughts 思想；意识",
                example:
                  "The flow of everyday life provides a context in which individual human consciousness operates.",
              },
              {
                explanation:
                  "2) [U] the condition of being awake and able to understand what is happening around you 神志清醒",
                example:
                  "When the man finally regains consciousness and walks to a mirror, he is unsure of who he is.",
              },
            ],
          },
        ],
      },
      {
        word: "subjective",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1ea65e19d4be2e251e11242bce90177403f9a8f5_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/səbˈdʒektɪv/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "based on or influenced by personal feelings, tastes or opinions rather than facts 主观的",
                example:
                  "We know that taste in art is a subjective matter and differs from person to person.",
              },
            ],
          },
        ],
      },
      {
        word: "quirk",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/564ca1f287fc4277da1b429a7d2c8062350bc606_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kwɜːk/ 【n.[C]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) a strange habit or feature of sb.'s character, or a strange feature of sth. 怪癖；古怪",
                example:
                  " She took pride in her children's quirks and individuality, and made no effort to try to change them.",
              },
              {
                explanation:
                  "2) sth. strange that happens by chance （偶然发生的）奇事，巧合",
                example:
                  "Years later, by a strange quirk of fate, she found herself sitting next to him on a plane.",
              },
            ],
          },
        ],
      },
      {
        word: "time-scale",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/27cb7e9df66ddd027a6ecc2debd435f13ad971ac_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈtaɪmˌskeɪl/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] (esp. BrE) the period of time it takes for sth. to happen or be completed （做某事所需要的）时间，时段",
                example:
                  "The time-scale for completing the work would be fairly tight and we have to work hard.",
              },
            ],
          },
        ],
      },
      {
        word: "empathise",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9a20ec6973b1b5756e8eff5a8275efbe16b33352_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈempəˌθaɪz/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "(AmE empathize)  be able to understand sb. else's feelings, problems, etc., esp. because you have had similar experiences 同情；有同感；产生共鸣",
                example:
                  "My mother died last year so I can really empathise with what he's going through.",
              },
            ],
          },
        ],
      },
      {
        word: "conceive",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/93feb10f6de227d2558937338084445d9feeb85f_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kənˈsiːv/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "think of a new idea, plan, etc. and develop it in your mind 构思，设想，想出（新的主意、计划等）",
                example:
                  "Scientists first conceived the idea of the atomic bomb in the 1930s.",
              },
              {
                explanation:
                  "[v.] (fml.) imagine a particular situation or think about sth. in a particular way 想象；构想；设想",
                example:
                  "Language may be conceived of as a process which arises from social interaction.",
              },
            ],
          },
        ],
      },
      {
        word: "artefact",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/84ed522dab3eb239e985c2b6c77808a948e65ac9_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɑːtɪˌfækt/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] an object such as a tool, weapon, etc. that was made in the past and is historically important 人工制品，手工艺品（有史学价值的工具、武器等）",
                example:
                  "The museum is well-known for having many artefacts dating back to prehistoric times",
              },
            ],
          },
        ],
      },
      {
        word: "coherent",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/66504998a7fad9bc7eb12df77650ee546990f5d3_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kəʊˈhɪərənt/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "if a piece of writing, set of ideas, etc. is coherent, it is easy to understand because it is clear and reasonable （文章、观点等）连贯的，有条理的，一致的",
                example:
                  "It makes me crazy that the board seems to have no coherent plan for saving the company.",
              },
            ],
          },
        ],
      },
      {
        word: "implausibly",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/734146a3fbfd54b122550045cbef343baf413fd7_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪmˈplɔːzəbli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "in a way that is difficult to believe and therefore unlikely to be true 难以置信的；不可能真实的",
                example:
                  "He argued, somewhat implausibly, that the accident could not have been prevented.",
              },
            ],
          },
        ],
      },
      {
        word: "misinterpretation",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f05cc290437f59b04e6c69e27eb79ff281dfc2c6_96k.mp3#duration=2.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌmɪsɪntɜːprɪˈteɪʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C,U] the act of forming a wrong understanding of sth. that is said or done, or an example of a wrong understanding 误解",
                example:
                  "It appears that this universally promoted idea was based on a misinterpretation of the test results.",
              },
            ],
          },
        ],
      },
      {
        word: "authentically",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/af42db87e31ed16fefc2e6dd41ab638a25c214c2_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɔːˈθentɪkli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "in the traditional or original way 正宗地；原汁原味地",
                example:
                  "Consumers are increasingly interested in the authentically prepared food.",
              },
            ],
          },
        ],
      },
      {
        word: "orchestra",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ebadb47ef61462c2d9ae9325ee4692cced1b33f6_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɔːkɪstrə/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C]（大型的）管弦乐队",
              },
            ],
          },
        ],
      },
      {
        word: "symphony",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/73179c405d036d8f38ca7a2ab04b5234d390e83a_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈsɪmfəni/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] 交响乐；交响曲",
                example:"",
              },
            ],
          },
        ],
      },
      {
        word: "considerably",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/55530cfb4dbbf763552bb16ca696451209038023_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kənˈsɪd(ə)rəbli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation: "much; a lot 很；非常；相当大（多）地",
                example:
                  "Housing conditions in this area have improved considerably over the past few years.",
              },
            ],
          },
        ],
      },
      {
        word: "acoustics",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7c3d883efd5726f68c7bf86b778533d1f1e5eccb_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈkuːstɪks/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) [pl.] the shape and size of a room, which affect the way sound is heard in it （房间的）传声效果，音响效果",
                example:
                  "The auditorium has comfortable seating and modern acoustics.",
              },
              {
                explanation: "2) [U] the scientific study of sound 声学",
                example: "",
            }
            ],
          },
        ],
      },
      {
        word: "formalise",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f62f3016ec454d80c72efcf524a3cd2dbd8d8427_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfɔːməˌlaɪz/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "(esp. BrE) (AmE formalize) make a plan, decision, or idea official, esp. by deciding and clearly describing all the details 使（计划、决定或想法）正式化；使定形；使具体化",
                example:
                  "Final arrangements for the takeover of the company have yet to be formalised. ",
              },
            ],
          },
        ],
      },
      {
        word: "contextual",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/12bb7cbefb4ff6ba0066c208002083fa63592051_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kənˈtekstʃuəl/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "(usu. before noun) relating to a particular context 与上下文有关的",
                example:
                  "We need now to examine the role of contextual factors directly and in more detail.",
              },
            ],
          },
        ],
      },
      {
        word: "execute",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/10982e7f1346212be8241d0f8c0ae4506eaa0fa7_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈeksɪˌkjuːt/ 【vt.(fml.)】",
            explanations_and_examples: [
              {
                explanation:
                  "1) do sth. that has been carefully planned 实行；执行",
                example:
                  "The job involves drawing up and executing a plan of nursing care.",
              },
              {
                explanation:
                  "2) kill sb., esp. legally as a punishment （尤指依法）将.处死",
                example:
                  "Anyone caught trying to escape from that prison would be executed.",
              },
            ],
          },
        ],
      },
      {
        word: "formula",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/33580a753d0b540daff59e4788d8ac14f485edb6_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfɔːmjələ/【n.[C] (pl.formulas or formulae)】",
            explanations_and_examples: [
              {
                explanation:
                  " 1) a list of the exact amounts of the ingredients that are used for making sth. 配方",
                example:
                  "The formulas for these drinks are closely guarded secrets of the company.",
              },
              {
                explanation:
                  " 2) a series of numbers or letters that represent a mathematical or scientific rule 公式；方程式；分子式",
                example:
                  "He developed a mathematical formula describing the distances of the planets from the Sun.",
              },
            ],
          },
        ],
      },
      {
        word: "artistic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3dd16fe258166a4348225fe355f9898712e819df_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɑːˈtɪstɪk/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "1) relating to art or culture 美术的；艺术的",
                example:
                  "According to a famous art critic, opinion about the artistic merit of his paintings has been mixed.",
              },
              {
                explanation:
                  "2) good at painting, drawing, or producing beautiful things 艺术精湛的；有艺术才华的",
                example:
                  "His friends are all artistic — they're painters, musicians, dancers, and writers.",
              },
            ],
          },
        ],
      },
      {
        word: "volition",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/642fe0e2b668427f847dce6ded9d922beebe8a6a_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/vəˈlɪʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] (of one's own ~) (fml.)if you do sth. of your own volition, you do it because you want to, not because you are forced to 出于自愿",
                example:
                  "To everyone's astonishment, Helena left the company of her own volition.",
              },
            ],
          },
        ],
      },
      {
        word: "procedural",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/026de1530af28e405bdec8d94a35b3d6877782a2_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/prəˈsiːdʒ(ə)rəl/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "(only before noun) (fml.) connected with a procedure 程序性的；手续上的",
                example:
                  "The business of the committee was delayed by procedural difficulties.",
              },
            ],
          },
        ],
      },
      {
        word: "autonomous",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f1f37cba07bbd17c53c41406742cbaac90223554_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɔːˈtɒnəməs/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) (fml.) having the ability to work and make decisions by yourself without any help from anyone else 有自主能力的；自主的",
                example:
                  "It is teachers' responsibility to help children become autonomous learners.",
              },
              {
                explanation:
                  "2) an autonomous place or organization is free to govern or control itself （地方或机构）自治的",
                example:
                  "Five provinces are to become autonomous regions in the new federal system of government.",
              },
            ],
          },
        ],
      },
      {
        word: "interact",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e68e6bd77149492aff3582305539b7f86113382b_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌɪntərˈækt/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "if people interact with each other, they talk to each other, work together, etc. 交流；交往；互相来往",
                example:
                  "The little girl's teacher told her mom that she interacted well with the other children.",
              },
            ],
          },
        ],
      },
      {
        word: "interactive",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e144fdac19a457739b98987b169b5c6d5049f370_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌɪntərˈæktɪv/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) an interactive computer program, television system, etc. allows you to communicate directly with it, and does things in reaction to your actions （计算机程序、电视系统等）交互的，互动的",
                example:
                  "This is an interactive museum where children can actively manipulate the exhibits.",
              },
              {
                explanation:
                  "2) involving talking and working together 合作的； 相互交流的",
                example:
                  "Our school encourages interactive teaching methods, such as role playing.",
              },
            ],
          },
        ],
      },
      {
        word: "impose",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4fdf4dadb987220309287b645e17d37bd8a5dd7a_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪmˈpəʊz/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  " 1) force sb. to have the same ideas, beliefs, etc. as you 将（想法、信仰等）强加于（某人）",
                example:
                  "I can't understand why she always tries to impose her own ideas on the rest of the team.",
              },
              {
                explanation:
                  "2) if sb. in authority imposes a rule, punishment, tax, etc., they force people to accept it 强制推行；强制实行",
                example:
                  "The court has the power to impose an unlimited fine for this offence.",
              },
            ],
          },
        ],
      },
      {
        word: "eagerness",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ce0140b41ec1300bd631f63fa2421144bd8dd5b3_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈiːgərnəs/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] the state of wanting to do or have sth. very much, esp. sth. interesting or enjoyable 渴望",
                example:
                  "People were pushing each other out of the way in their eagerness to get to the front.",
              },
            ],
          },
        ],
      },
      {
        word: "comprehension",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8e1b42dfe5bcb4192cd31bd3a8663856fa10b343_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌkɒmprɪˈhenʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[U] the ability to understand sth. 理解（力）",
                example:
                  "It's annoying that they don't have the least comprehension of what I'm trying to do.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Phrases and expressions",
    children: [
      {
        word: "first and foremost",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d19bcabdd1fed6f09a6dc7acfbe1fff7f370387c_96k.mp3#duration=2.1&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "used to emphasize the most important quality, purpose, reason, etc. 首先，首要的是（用于强调）",
                example:
                  "What children need first and foremost from their parents is a sense of security.",
              },
            ],
          },
        ],
      },
      {
        word: "as such",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/dda919b4b5209a77e8439b293b9f185b00ea4676_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "in the true or exact meaning of the word or phrase 从字面意义来看；严格地说",
                example:
                  "There wasn't much vegetarian food as such, although there were several types of salads.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Proper names",
    children: [
      {
        word: "Elsa Schiaparelli",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/eb7cacad12916adafc516919f475dae388f37e45_96k.mp3#duration=2.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌelzə skjɑːpəˈrelliː/",
            explanations_and_examples: [
              {
                explanation: "艾尔莎.夏帕瑞丽（意大利时装设计师）",
              },
            ],
          },
        ],
      },
      {
        word: "RMiuccia Prada",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f0d76157939c923ae63a928bbd5e47bbbbe93368_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌmjuːtʃə ˈprɑːdɑ/",
            explanations_and_examples: [
              {
                explanation: "缪西娅.普拉达（意大利时装设计师））",
              },
            ],
          },
        ],
      },
      {
        word: "Karl Lagerfeld",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/64a76fb2a9190efbf201827c964efbf994ac0c22_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈlɑːgəfeld/",
            explanations_and_examples: [
              {
                explanation: "卡尔.拉格斐（德国时装设计师）",
              },
            ],
          },
        ],
      },
      {
        word: "Yves Saint Laurent",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b00f97db0c2e965bebcf31a23362e48f9b09d7ec_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌiːv sæn ˈləʊrɔːn/",
            explanations_and_examples: [
              {
                explanation: "伊夫.罗兰（法国时装设计师）",
              },
            ],
          },
        ],
      },
      {
        word: "Picasso",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1a1122ed2e706efc0150d1321e2425c812bc1939_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/pɪˈkɑːsəʊ/",
            explanations_and_examples: [
              {
                explanation: " 巴勃罗.毕加索（西班牙画家、雕塑家）",
              },
            ],
          },
        ],
      },
      {
        word: "Monet",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d096e898541c84280df2e938300b8a9fe3e8d47b_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/məʊˈneɪ/",
            explanations_and_examples: [
              {
                explanation: "克劳德.莫奈（法国印象派画家）",
              },
            ],
          },
        ],
      },
    ],
  },
];

book3[7] = [
  {
    name: "New words",
    children: [
      {
        word: "afflict",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/1cfdbb4fbd8cfca365db294137f14f3e67f75f9a_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈflɪkt/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml.) affect sb. / sth. in an unpleasant way, and make them suffer 折磨；使痛苦",
                example:
                  "I understand the burdens that afflict your family, and I pledge to you my efforts to help overcome them.",
              },
            ],
          },
        ],
      },
      {
        word: "veiled",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/18bb327542fb0a4ed52a745742511da8a781b930_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/veɪld/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "(threat, attack, or warning) not direct but is easily understood （威胁、攻击或警告）隐含的，不明言的",
                example:
                  " They launched a thinly veiled attack on his ability as a leader.",
              },
            ],
          },
        ],
      },
      {
        word: "conceal",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d35268c33f6ef9a4cf036f639744ae713b70e9f7_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kənˈsiːl/ 【vt.】",
            explanations_and_examples: [
              {
                explanation: "prevent from being seen or discovered 隐瞒；掩盖",
                example: " Why did you decide to conceal your true identity?",
              },
            ],
          },
        ],
      },
      {
        word: "hasten",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c2cc2f97d6b8272af05340f2240fdfeac9ac96e3_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈheɪsn/ ",
            explanations_and_examples: [
              {
                explanation:
                  "[vi] do or say sth. quickly or without delay 赶紧做（或说）",
                example:
                  "I hastened to assure her that there was no danger of falling down from the bridge.",
              },
              {
                explanation: "[vt.]make sth. happen faster or sooner 加速；加紧",
                example:
                  "There are, in theory, many ways to hasten economic recovery after a financial crisis.",
              },
            ],
          },
        ],
      },
      {
        word: "forestall",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/0e2bdd96323a9bfcb8cae60fa6de3439e5455dba_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/fɔːˈstɔːl/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "prevent sth. from happening or prevent sb. from doing sth. by doing sth. first 预先阻止；在（他人）之前行动 ; 先发制人",
                example:
                  "My mother tells me that to forestall is better than to amend and prevention is better than cure.",
              },
            ],
          },
        ],
      },
      {
        word: "tender",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ccd2c7327b367ab42d7b1df436e88d7a2a1d27c7_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈtendə/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) gentle and careful in a way that shows love 温柔的；体贴入微的",
                example:
                  "He was a rebel, but a strong part of him was sensitive and tender, just as his sister.",
              },
              {
                explanation:
                  "2) (food) easily cut and eat, esp. because it has been well cooked （食物）软的，嫩的，易咀嚼的",
                example:
                  "Cook for a minimum of two hours, or until the meat is tender.",
              },
            ],
          },
        ],
      },
      {
        word: "weep",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/453c82d1412f755f4e0e030f6e66c61af7fa8867_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/wiːp/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "(wept, wept) cry because you feel unhappy or have some other strong emotion 哭泣；流泪",
                example:
                  "Wonderfully melodic and tuneful, his songs have made the audience weep.",
              },
            ],
          },
        ],
      },
      {
        word: "abandon",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2024348b4f230aeab83eba7c7545011a202518c5_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈbændən/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "1)(~ yourself to sth.) feel an emotion so strongly that you let it control you completely 陷入（某种感情",
                example:
                  "We are scared to abandon ourselves to our feelings in case we seem weak or out of control.",
              },
              {
                explanation:
                  "2) leave sb. when you should stay with them and look after them 抛弃；遗弃",
                example:
                  "He can never forgive his mother because she abandoned him when he was five years old.",
              },
            ],
          },
        ],
      },
      {
        word: "abandonment",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a627ae7c5d42683e225f07cffc38c48e774bf864_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈbændənmənt/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[U] a complete surrender of inhibitions 放任；放纵",
                example:
                  'In some poetry, sensitivity, she suggests, "has led to a dangerous abandonment to sensation.',
              },
            ],
          },
        ],
      },
      {
        word: "armchair",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d87b5dc0b3e2f07440535c809de2ccbdbd691650_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɑːmˌtʃeə/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C]  扶手椅",
              },
            ],
          },
        ],
      },
      {
        word: "exhaustion",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c717ef744522250eec23fc36cefe1032fa269f3b_96k.mp3#duration=1.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪgˈzɔːstʃ(ə)n/ [C] ",
            explanations_and_examples: [
              {
                explanation:
                  "[U] a feeling of being extremely tired and without energy 筋疲力尽；疲惫不堪",
                example:
                  "Weak with exhaustion, the climbers were finally rescued by a helicopter after being trapped in heavy snow.",
              },
            ],
          },
        ],
      },
      {
        word: "haunt",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/5b66d66f336512f92955aa57fc954703142c92a5_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/hɔːnt/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) continue to cause problems for a person or organization for a long time 缠扰；纠缠",
                example:
                  "The shame of being a bankrupt is likely to haunt Mr. Lucas for the rest of his life.",
              },
              {
                explanation:
                  "2) if the soul of a dead person haunts a place, it appears there often （鬼魂）经常出没于",
                example:
                  "hey say the prison is haunted by the ghosts of the men who died there",
              },
            ],
          },
        ],
      },
      {
        word: "wares",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b762baf038cf445a74a2456e8a7d7624cfe47b52_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/weəz/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[pl.]  things that are for sale, usu. not in a shop （一般不在商店内出售的）商品，货物",
                example:
                  "The major off-line brands aren't promoting their wares on the Internet as much as expected",
              },
            ],
          },
        ],
      },
      {
        word: "faintly",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/338b7fa0f71388efab0fd9717109fdc7c9bf0a33_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfeɪntli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "in a way that is difficult to see, hear, smell, etc. 不清楚地；模糊地",
                example:
                  "When the piano fell silent, the sound of the traffic echoed faintly in the room. ",
              },
            ],
          },
        ],
      },
      {
        word: "sparrow",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/0b03f47dc2c8a27763c25f1b3004bf4a71cea06e_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈspærəʊ/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C]麻雀",
                example:"",
              },
            ],
          },
        ],
      },
      {
        word: "twitter",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/eea4bc2cc76b841a0634c79aaaf4b7483095f3bc_96k.mp3#duration=1.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈtwɪtə/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "(of birds) make a lot of short high sounds （鸟）鸣啭",
                example:"",
              },
            ],
          },
        ],
      },
      {
        word: "eaves",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/79884d1db6c32369f3d03ca715efde1b253433a2_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/iːvz/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[pl.] 屋檐",
              },
            ],
          },
        ],
      },
      {
        word: "patch",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/677e5bffef2a6ca6176e4f397c0f731db52f8d8a_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/pætʃ/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a small area of sth. that is different from the area around it （与周围部分不同的）小片，小块",
                example:
                  "Belinda watched a patch of sunlight move slowly across the wall.",
              },
            ],
          },
        ],
      },
      {
        word: "cushion",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/38cccb382e03ee75d19b70d20c80a9e13abfc47a_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkʊʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] 垫子；靠垫；坐垫",
              },
            ],
          },
        ],
      },
      {
        word: "sob",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/dfb3942d0771a1b496fc359507e0919dc5cb4251_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/sɒb/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] an act or sound of sobbing 抽噎（声）；啜泣（声）；呜咽（声）",
                example:
                  "After a while, she began to sob again, burying her face in the pillow.",
              },
              {
                explanation: "【vi.】cry noisily while taking short breaths 抽噎；啜泣",
                example: "After a while, she began to sob again, burying her face in the pillow."
            }
            ],
          },
        ],
      },
      {
        word: "bespeak",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9f32dbc158e197244b07248fd2e899ebe73d2d62_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/bɪˈspiːk/ 【vt.】",
            explanations_and_examples: [
              {
                explanation: "(bespoke, bespoken) show or suggest sth. 显示；表示",
                example:
                  "Her house, her clothes, her style of living, all bespeak an exceedingly good income.",
              },
            ],
          },
        ],
      },
      {
        word: "repress",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4adfff6a585ffbc8df055c46a8d9467a666c3917_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/rɪˈpres/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "stop yourself from doing sth. you want to do 忍住；克制",
                example:
                  "She could not repress a smile at this, but she answered only by nodding her head slightly.",
              },
            ],
          },
        ],
      },
      {
        word: "repression",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/01c1d5272cdb3d5da058c53613a6003e0f1c3647_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/rɪˈpreʃn/ 【n. 】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] the behavior of sb. who refuses to show or admit strong feelings that they have （对感情的）抑制，压抑",
                example:
                  "He told her that emotional repression was preventing her from understanding her own behavior.",
              },
            ],
          },
        ],
      },
      {
        word: "gaze",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f535abf636c4d1dd755f8d1b89284087bc832d39_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/geɪz/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[sing.] a long steady look 凝视；注视",
                example: "She felt embarrassed under his steady gaze.",
              },
            ],
          },
        ],
      },
      {
        word: "yonder",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/843fb48ee67705d95ff5895ee99c0359feda00ee_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈjɒndə/ 【ad. & det.】",
            explanations_and_examples: [
              {
                explanation: "over there 在那边（的）；在远处（的）",
                example:
                  "Now look yonder, just beyond the wooden post —— there's a white cottage under the hill.",
              },
            ],
          },
        ],
      },
      {
        word: "suspension",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/dcc92283d8a43f9d7c6df872b897a21770559c79_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/səˈspenʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] when sth. is officially stopped for a period of time 暂停；中止",
                example:
                  "Anyway, we have to admit that both sides are now working toward a suspension of hostility.",
              },
            ],
          },
        ],
      },
      {
        word: "subtle",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/61d358a165c6dd1e1ccf9591c718ac6f28cccca1_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈsʌtl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "not obvious, and therefore difficult to notice 细微的；微妙的；难以察觉的",
                example: "I sensed a subtle change in his attitude toward us.",
              },
            ],
          },
        ],
      },
      {
        word: "elusive",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/bc6af3d12e80640f1627ec0be8cddeab171fa387_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪˈluːsɪv/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  " difficult to find or not often seen 难找的；不常见到的",
                example:
                  "Who can tell me how to catch the elusive charm of the original version in translation?",
              },
            ],
          },
        ],
      },
      {
        word: "creep",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/aebbe640d703c6016e8e0f5468dea5d5d18b9d8c_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kriːp/ 【vi.】",
            explanations_and_examples: [
              {
                explanation: "(crept, crept) move slowly and quietly 轻声地缓慢行进",
                example:
                  "When cats are preparing to pounce on (猛扑) the mouse, they creep over the ground very slowly.",
              },
            ],
          },
        ],
      },
      {
        word: "scent",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c1ebdf835735ab5b5511439c2de90aaf5f7ed9ef_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/sent/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a particular smell, esp. a pleasant one 气味；（尤指）香味",
                example:
                  "Flowers are chosen by customers for their scent as well as their look.",
              },
            ],
          },
        ],
      },
      {
        word: "bosom",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/71599df90dd1e03941516b3518f354701046b311_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈbʊz(ə)m/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C, usu. sing.] （女人的）胸部",
                example:"",
              },
            ],
          },
        ],
      },
      {
        word: "tumultuously",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/497b653a10e9082f2a5a3b1d4eb03a7f41c34863_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/tjuːˈmʌltʃʊəsli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "in a way that involves a lot of noise, excitement, activity, or violence 骚乱地；骚动地；混乱地；激动地",
                example:
                  "They gathered tumultuously about him and demanded to know how he had accomplished it. ",
              },
            ],
          },
        ],
      },
      {
        word: "slender",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/fc9ee7b5fc2d343dda8c02dbfe237adfd2d72200_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈslendə/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "tall or long and thin in an attractive way 苗条的；修长的；纤细的",
                example:
                  "The dress is for my daughter who's about my height but more slender.",
              },
            ],
          },
        ],
      },
      {
        word: "vacant",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/67ad364457c81fd5e06e1b212b4486fa374eaf23_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈveɪkənt/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) looking as if you do not understand or are not paying attention 茫然的；失神的",
                example:
                  "The maid's vacant expression was replaced momentarily by one of greedy expectation, shortly followed by disappointment.",
              },
              {
                explanation:
                  "2) (seat, room, etc.) empty and available for sb. to use （座位、房间）空的，未被占用的",
                example:
                  "All three sets of houses are vacant, and she's making no attempt to rent them out.",
              },
            ],
          },
        ],
      },
      {
        word: "terror",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/02e321f7b11c04ff8dde1f9f47aabb316d027352_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈterə/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[U] a feeling of extreme fear 恐惧；惊恐",
                example:
                  "She shook with terror whenever she was about to fly in a plane by herself.",
              },
            ],
          },
        ],
      },
      {
        word: "pulse",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/85c7e8ebefd2ca2c441daa2a0ea156b6b9a110bc_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/pʌls/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C, usu. sing.] the regular movement of blood as the heart pumps it round the body 脉搏",
                example:
                  "The doctor said he was in danger — his breathing was shallow and his pulse was weak.",
              },
            ],
          },
        ],
      },
      {
        word: "monstrous",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ffa9634ac7cfdf25d569772b9cc6f2c35e54338a_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmɒnstrəs/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "very wrong, immoral, or unfair 极端错误的；道德败坏的；极不公正的",
                example:
                  "I'd like to make a complaint — it's monstrous to charge that much for a hotel room.",
              },
            ],
          },
        ],
      },
      {
        word: "exalted",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/54635baedf85ac9fbbaa29e291ed345ebd7febc3_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪgˈzɔːltɪd/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) extremely happy and proud 兴高采烈的；得意洋洋的",
                example:
                  " We were absolutely exalted when we learned of your daughter's success in career.",
              },
              {
                explanation:
                  "2) having a very high rank; highly respected 显贵的；高贵的",
                example:
                  "Leith doubted that she would ever meet a man in such a highly exalted position.",
              },
            ],
          },
        ],
      },
      {
        word: "dismiss",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/69d72541655577d13829d36e787e43189c37851e_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪsˈmɪs/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "refuse to consider sb.'s idea, opinion, etc. because you think it is not serious, true or important 拒绝考虑；不理会",
                example:
                  "The government has dismissed criticism that the country's health policy is a mess.",
              },
            ],
          },
        ],
      },
      {
        word: "procession",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/5c1f88cee6b5f605b7537ac6bb0d91ba189d3f32_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/prəˈseʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] a series of people or things 一连串的人（或物）",
                example:
                  "We've had an endless procession of new secretaries in the office since Amy left.",
              },
            ],
          },
        ],
      },
      {
        word: "persistence",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/856ae694b2a23a94deba29f66826413003fbddbb_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/pəˈsɪstəns/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] determination to do sth. even though it is difficult or other people oppose it 坚持；执着；执意",
                example:
                  "The teacher kept saying that skill comes only with practice, patience and persistence.",
              },
            ],
          },
        ],
      },
      {
        word: "illumination",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d10a5f8807a2948582bb0d2345a48893d36f616e_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪˌluːmɪˈneɪʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1)[C, U] (fml.) a clear explanation or understanding of a particular subject （对某一主题的）阐明，理解",
                example:
                  "In that flash of illumination, he realized where he had gone wrong in his decision-making.",
              },
              {
                explanation:
                  "2)[U] lighting provided by a lamp, light, etc. 光亮；照明",
                example:
                  "The only illumination came from a small window high in the opposite wall.",
              },
            ],
          },
        ],
      },
      {
        word: "kneel",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a3f6b8a7d4384c1f1ec5d17dd725d640c0eec9eb_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/niːl/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "(knelt, knelt; kneeled, kneeled) be in or move into a position where your body is resting on your knees 跪着；跪下",
                example:
                  "She knelt on the floor and put more wood on the fire so that the room would be warmer. ",
              },
            ],
          },
        ],
      },
      {
        word: "elixir",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/cd6468189a0c3851529cf3c098835df5459df739_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪˈlɪksə/【n.】 ",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a magical liquid that is supposed to cure people of illness, make them younger, etc. 灵丹妙药；不老药",
                example:
                  "You fool, it's yet another health product claiming to be the elixir of youth. ",
              },
            ],
          },
        ],
      },
      {
        word: "riot",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c7ec441d464c3e183f5e50bffae74862148f3901_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈraɪət/【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C,U] a violent protest by a crowd of people 暴乱；骚乱",
                example:
                  "The police were able to take preventive action and avoid a possible riot.",
              },
            ],
          },
        ],
      },
      {
        word: "shudder",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d5415e036e25db0779c4d868004718d1f9af60b8_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈʃʌdə/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] a quick uncontrolled shaking movement 战栗；颤抖",
                example:
                  "As she turned away from the house into the lane, she gave a shudder of relief.",
              },
            ],
          },
        ],
      },
      {
        word: "importunity",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/89f06e2d9d448ba8d69121ad6009ef55ccaa413a_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌɪmpəˈtʃuːnəti/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C, U] the act of asking sb. for sth. continuously in an annoying or unreasonable way 强求",
                example:
                  "Unable to withstand my importunity, he would make out drafts for me to copy. ",
              },
            ],
          },
        ],
      },
      {
        word: "feverish",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/262770cdb59dd20662fb8da28df0fdd08c7314b4_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfiːvərɪʃ/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "1) extremely excited 特别激动的；极度兴奋的",
                example:
                  "He will be attending next week's Grammy Awards in feverish anticipation.",
              },
              {
                explanation: "2) suffering from a fever 发烧的；发热的",
                example:
                  "You ought to be careful about this kind of feverish cold — it often kicks back.",
              },
            ],
          },
        ],
      },
      {
        word: "triumph",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7b87633ae13a42184800aab1268c45f1d84b434f_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈtraɪʌmf/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) [U] the proud or excited feeling you get when you have won sth. or been successful 成功的满足感；胜利的喜悦之情",
                example:
                  "My father returned in triumph from the annual sales of the department store with a half-price TV.",
              },
              {
                explanation:
                  "2) [C] an important victory or success after a difficult struggle 胜利；成功；成就",
                example:
                  "If confirmed by longer and larger clinical trials, this will rightly be hailed as a scientific triumph.",
              },
            ],
          },
        ],
      },
      {
        word: "unwittingly",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/98113c90d71ab85545c9ba856b4bb996b0eed949_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ʌnˈwɪtɪŋli/ 【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "in a way that is not conscious or deliberate 不知不觉地；非故意地",
                example:
                  "Many parents unwittingly place their children in danger by not making sure they wear seat belts.",
              },
            ],
          },
        ],
      },
      {
        word: "clasp",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7d433e315f1e8c5481e6a105be6ba5a549bac0d4_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/klɑːsp/【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "hold sb. / sth. tightly with your hands 握紧；抱紧",
                example:
                  "She would often clasp her hands behind her head and muse when she could have a house of her own. ",
              },
            ],
          },
        ],
      },
      {
        word: "descend",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/866e2309ec860e5d8c5a9b3844510a9e42f73076_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪˈsend/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml.) move from a higher level to a lower one 从...下来；下降",
                example:
                  "I heard his footsteps descending the stairs , he must have finished his work.",
              },
            ],
          },
        ],
      },
      {
        word: "latchkey",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e744bebd7900d4c1cc3781a6c904ea33007ac4f4_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈlætʃˌkiː/【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] （房子或公寓大门的）碰锁钥匙",
              },
            ],
          },
        ],
      },
      {
        word: "composedly",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/0c9aaa7cf7f97c1afa03b575719fe1b57cdec314_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kəmˈpəʊzdli/【ad.】",
            explanations_and_examples: [
              {
                explanation:
                  "in a way that seems calm and in control of your feelings 镇静地",
                example:
                  "It is difficult to think composedly when you are being attacked by mosquitoes.",
              },
            ],
          },
        ],
      },
      {
        word: "pierce",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/add750a6e04633274f01edbb905a4598d250595a_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/pɪəs/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "make a small hole in or through sth., using an object with a sharp point 刺入；刺穿；刺破",
                example:
                  "The chef taught him to steam the corn until it can easily be pierced with a fork.",
              },
            ],
          },
        ],
      },
      {
        word: "piercing",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/28caee2575b51455b7350077ab988bd0b4c6f098_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈpɪəsɪŋ/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) (sound) high, sharp and unpleasant 尖锐的；刺耳的",
                example:
                  "Maggie let out a piercing scream as she saw the truck speeding toward her. ",
              },
              {
                explanation:
                  "2) sb. with piercing eyes is looking at you and seems to know what you are thinking 敏锐的；有洞察力的",
                example:
                  "Cloudy and unfocused for a moment, his eyes quickly regained their normal piercing clarity.",
              },
            ],
          },
        ],
      },
      {
        word: "needful",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8f36557efb9d927153f26656fa3893fdc0257bcd_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈniːdfl/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "necessary 必要的；需要的",
                example:
                  "He could only think of how needful it was to take the train and get quietly away.",
              },
            ],
          },
        ],
      },
      {
        word: "confines",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2984a78242a4a4ff2d4251c9344dcecbf98f89df_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkɒnfaɪnz/",
            explanations_and_examples: [
              {
                explanation: "[pl.]limits or borders 界限；范围",
                example:
                  " We can't really discuss feminism within the confines of such a short novel.",
              },
            ],
          },
        ],
      },
      {
        word: "cramp",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/07aaf4d14efc3dd48a0804b2b1f7da7af46108b5_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kræmp/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "prevent the development of sb. / sth. 限制，束缚（某人或某事物的发展）",
                example:
                  "Some people are worried that stricter anti-pollution laws may cramp economic growth.",
              },
            ],
          },
        ],
      },
      {
        word: "noxious",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d4e5f941eb144dc9ba48cde88158baa523b114df_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "ˈnɒkʃəs/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "(fml.) harmful or poisonous 有害的；有毒的",
                example:
                  "Environmentalists warned that heavy industry pollutes our rivers with noxious chemicals. ",
              },
            ],
          },
        ],
      },
      {
        word: "medicinal",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/469f4039127218809d74b03b0bbb3e9c61971c58_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/məˈdɪsn(ə)l/【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "used for treating medical problems 有疗效的；有药效的",
                example:
                  "Her interest was rekindled when she saw herbs in everyday medicinal use there.",
              },
            ],
          },
        ],
      },
      {
        word: "restore",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/91e4ebc26dadb54c906240aabf0df3cbc5e86d7d_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/rɪˈstɔː/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "make sth. return to its former state or condition 使恢复；使回复",
                example:
                  "The government promises to restore the economy to its full strength by the end of the year.",
              },
            ],
          },
        ],
      },
      {
        word: "attorney",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3e4efaa93c64495ff19d230d52dbd9cd2e42a971_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈtɜːni/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] (AmE) a lawyer 律师",
                example:
                  "He decided to consult with an attorney about this particular case.",
              },
            ],
          },
        ],
      },
      {
        word: "din",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/fe73fcd806b5578745c3e9c214841804487000ea_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/dɪn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[sing] a loud unpleasant noise that continues for a long time （持久的）嘈杂声，喧闹声",
                example:
                  "They waved their arms and shouted, trying to make themselves heard over the din of the crowd. ",
              },
            ],
          },
        ],
      },
      {
        word: "craft",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8163109f7adc1a581e66432893638764b3d55ea5_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/krɑːft/【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "1) [U] ( fml.) skill in making people believe what you want them to believe 诡计；手腕",
                example:
                  "He knew how to win by craft and diplomacy what he could not gain by force.",
              },
              {
                explanation:
                  "2) [C] a traditional skill of making things by hand （传统）手（工）艺",
                example:
                  "It's lucky that all kinds of traditional craft industries are preserved here.",
              },
            ],
          },
        ],
      },
      {
        word: "horizon",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a04a45e3fe43478d2758e6cacc0d224b43a3cc35_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/həˈraɪzn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " the line far away where the land or sea seems to meet the sky 地平线",
                example:
                  "He backed away from the edge, looking all around at the flat horizon.",
              },
            ],
          },
        ],
      },
      {
        word: "corporeal",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/22fe024588efa757e4a78a2ff3054802deddb9e8_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kɔːˈpɔːriəl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml.) relating to the body, rather than to the mind, feelings, or spirit 身体的；肉体的",
                example:
                  "And then there is our own body, our own corporeal instrument, which we're awfully proud of",
              },
            ],
          },
        ],
      },
      {
        word: "spectacle",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/16414e06d47591163f4e86fc33872bd84c04f3bb_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈspektəkl/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C, U] an unusual, exciting, or impressive event or sight 壮观的景象；奇观",
                example:
                  "Watching a lion chasing its prey is one of nature's most exciting spectacles.",
              },
            ],
          },
        ],
      },
      {
        word: "float",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/666151e0c9db3b007311ec1c63bd19b9d82e26b5_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/fləʊt/ 【vi.】",
            explanations_and_examples: [
              {
                explanation: "move slowly on water or in the air 漂流；飘动",
                example: "I looked up at the clouds floating in the sky.",
              },
            ],
          },
        ],
      },
      {
        word: "crimson",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/12a9e7a25354cb4607196212ed3086ddc9b022d1_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkrɪmzn/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "dark purple-red in color 深红色的；绯红色的",
                example:
                  "They walked past fields with huge sprays of crimson, yellow and purple flowers.",
              },
            ],
          },
        ],
      },
      {
        word: "partake",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/388013bd25dc599bff2dbc9c8de27d02d2a7c753_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/pɑːˈteɪk/ 【vi.】",
            explanations_and_examples: [
              {
                explanation: "(partook, partaken) (fml.) take part in an activity or event 参加；参与",
                example:
                  "Retailers who partake in the campaign should place a sticker on their window.",
              },
            ],
          },
        ],
      },
      {
        word: "transformation",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f606352d6fffc7bfd2756602b5ec0e879fb1e69b_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌtræsfəˈmeɪʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "a complete change into sb. / sth. very different, or the process during which this happens 彻底改观；变化过程",
                example:
                  "After three weeks, we noticed a total transformation in his behavior and attitude.",
              },
            ],
          },
        ],
      },
      {
        word: "enchantment",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/0ff1c7a3b0ac91ca4889782b5a09ca4954e11e49_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ɪnˈtʃɑːntmənt/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U]the quality of being very pleasant or attractive 迷人；魅力",
                example:
                  "As the mountain path spirals up, the beauty of the scene fills each of us with enchantment.",
              },
            ],
          },
        ],
      },
      {
        word: "dilate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9ce0f8310a0708439727cd03e9d9ea71d00d97fb_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/daɪˈleɪt/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "become bigger and wider, or make sth. do this （使）膨胀；（使）扩大",
                example: "Red wine can help to dilate blood vessels.",
              },
            ],
          },
        ],
      },
      {
        word: "conspire",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2302a8dd3b1f65b8de42c93631d69134473d5525_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/kənˈspaɪə/ 【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "secretly plan with sb. to do sth. bad or illegal 搞阴谋；密谋",
                example:
                  "The company is accused of conspiring with three other local stores to fix prices.",
              },
            ],
          },
        ],
      },
      {
        word: "deify",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e28b022321ea7ee8dd49e386d64f2d886557e0c8_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈdiːɪfaɪ/ 【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "treat sb. / sth. with extreme respect and admiration 崇拜；把...神化；把...奉若神明",
                example:
                  "We are inclined to deify successful people, and in our time that certainly includes CEOs.",
              },
            ],
          },
        ],
      },
      {
        word: "pomp",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8c4fce8799709f53f64c5f37a5d8a284b55c92d6_96k.mp3#duration=1.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/pɒmp/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U] formal ceremony, esp. involving expensive clothes, special traditions, etc. 华典；盛典；盛况",
                example:
                  "She arrived at the airport without the pomp that usually accompanies important politicians.",
              },
            ],
          },
        ],
      },
      {
        word: "faerie",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d4bb8b7a47ea6ee6fd2d540b3485c248d223965b_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈfeɪəri/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] (also faery) a fairy 仙子；小精灵",
              },
            ],
          },
        ],
      },
      {
        word: "mystic",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c4046e126819c92cca186e8ff5fbd352947c3fb9_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmɪstɪk/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "(also mystical)involving religious, spiritual, or magical powers that people cannot understand 神奇的；神秘的",
                example:
                  "He has undergone a profound mystic experience over the past two months.",
              },
            ],
          },
        ],
      },
      {
        word: "susceptibility",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2972961294ce626018c4c038ec7844c97616fd69_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/səˌseptəˈbɪləti/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  " [U] the tendency to be easily affected or influenced by sth. 易受影响（或感染）的倾向；敏感性",
                example:
                  "One of the side effects of the drug is an increased susceptibility to infection.",
              },
            ],
          },
        ],
      },
      {
        word: "flake",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/867f77223de712049a25a5adc214e2792a710d00_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/fleɪk/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a small thin piece that breaks away easily from sth. else 小薄片",
                example:
                  "Toward the middle of the night, large flakes of snow began to fall swiftly. ",
              },
            ],
          },
        ],
      },
      {
        word: "modulate",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/e1dde0ac176b179760bdbd7de1d306427431985b_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmɒdjʊˌleɪt/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml.) change sth., esp. in order to achieve a particular effect 改变；调整",
                example:
                  "Teachers modulate the way they work in response to their students' needs.",
              },
            ],
          },
        ],
      },
      {
        word: "tint",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/28d7782eac7b439a3563f2a927e789c05062f7cf_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/tɪnt/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] a small amount of particular color 浅色；淡色调",
                example: "Green has many different shades and tints.",
              },
            ],
          },
        ],
      },
      {
        word: "repose",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/45b4f6b9a26a1a868c3e54f94d9a8abcfa0fb80a_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/rɪˈpəʊz/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[U]  a calm or relaxed state 安详；休息",
                example:
                  "The atmosphere in the hall is one of repose rather than excitement.",
              },
            ],
          },
        ],
      },
      {
        word: "mill",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/43cf75acb3c4eaf7469dc11040dafecb37363030_96k.mp3#duration=1.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/mɪl/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] 磨坊",
              },
            ],
          },
        ],
      },
      {
        word: "spire",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/32f7c4617a576c4223ec96883f1371c6a76f8609_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈspaɪə/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C]（教堂或其他建筑物的）尖顶",
                example:"",
              },
            ],
          },
        ],
      },
      {
        word: "calix",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/206dce2a62237a478f2eb4ad8eaec8deb685077d_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈkeɪlɪks/",
            explanations_and_examples: [
              {
                explanation: "(also calyx) (pl.calices) 花萼",
              },
            ],
          },
        ],
      },
      {
        word: "stubble",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c21af696b10d3d3c71cfbb7065ecb116a0af5ba3_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈstʌbl/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[U]（庄稼收割后遗留的）残株，茬",
                example: "",
              },
            ],
          },
        ],
      },
      {
        word: "rime",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6225444e551c4301670ea967ceee084e48358bf0_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/raɪm/ 【vt.】",
            explanations_and_examples: [
              {
                explanation: "cover sth. with frost 使...蒙上白霜",
                example:
                  "He does not brush away the frost that rimes his beard.",
              },
            ],
          },
        ],
      },
      {
        word: "mute",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f2204a7df1868ab4b30db17a950b556954c894fc_96k.mp3#duration=1.0&t=.mp3",
        pee: [
          {
            partOfSpeech: "/mjuːt/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "not speaking, or not willing to speak 缄默的；无声的",
                example:
                  "Marianna, the king's daughter, became mute after a shock.",
              },
            ],
          },
        ],
      },
      {
        word: "genial",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ccbf6da5a1c3394ef0c33e5c6bb2040c22280a4c_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈdʒiːniəl/ 【a.】",
            explanations_and_examples: [
              {
                explanation: "friendly and kind 友好的；善良的",
                example:
                  " He was a warm-hearted friend and genial host, liked by whoever meets him.",
              },
            ],
          },
        ],
      },
      {
        word: "behold",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8eb11025378644f22f55cbd7361f574fde996a9d_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/bɪˈhəʊld/",
            explanations_and_examples: [
              {
                explanation: "(beheld, beheld) see sth. 看；看见",
                example:
                  "He looked up and beheld a stranger sitting across the table, smiling a secret smile.",
              },
            ],
          },
        ],
      },
      {
        word: "glory",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/9c5bb86bcb76548488622a0f5de863bdf555847b_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈglɔːri/",
            explanations_and_examples: [
              {
                explanation: "1) great beauty 壮丽；灿烂 【n.[U]】",
                example:
                  "It will cost millions of pounds to restore the castle into its former glory.",
              },
              {
                explanation:
                  "2) admiration and praise that you get because you have done sth. impressive 荣誉；光荣",
                example:
                  "Walsham had his moment of glory when he won a 20 km race last week in London..",
              },
            ],
          },
        ],
      },
      {
        word: "gloom",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8e1397f2ad7098228508ddb469b9c7f2f71bd523_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/gluːm/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[U]  darkness in which it is difficult to see clearly 昏暗",
                example:
                  "She peered into the gloom, but she couldn't see where the noise was coming from. ",
              },
            ],
          },
        ],
      },
      {
        word: "alter",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6020ad3ca7f2b7996b0b86d3c50c8b36dc35949a_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɔːltə/ 【vt.】",
            explanations_and_examples: [
              {
                explanation: " make sb. / sth. different 使变样；改变",
                example:
                  "This doesn't alter the fact that what you did was wrong. You'd better call him and apologize.",
              },
            ],
          },
        ],
      },
      {
        word: "succession",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ec2ab82c403451b63d0fb29e3b36b2c2f305448e_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/səkˈseʃn/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[sing.] a series of people or things of the same type 一连串，一系列（同类型的人或物）",
                example:
                  "I can't understand why after graduation he took a succession of low-paid jobs.",
              },
            ],
          },
        ],
      },
      {
        word: "pasture",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b9944c9643d1fda60855253b5d55948478961338_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈpɑːstʃə/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C, U]牧场",
                example:"",
              },
            ],
          },
        ],
      },
      {
        word: "tribe",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/14bdd472b736c61ff7f2be27e994ca73e8a615ad_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/traɪb/【n.[C]】",
            explanations_and_examples: [
              {
                explanation:
                  "1) a group of related animals or plants （动植物的）族，群",
                example:
                  "They didn't quite expect that this tribe of cats could give them so much trouble.",
              },
              {
                explanation:
                  "2) a social group consisting of people of the same race who have the same beliefs, language, etc. and usually live in one particular area ruled by their leader 部落",
                example:
                  "The elders in the tribe want to protect their traditional way of life.",
              },
            ],
          },
        ],
      },
      {
        word: "punctual",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7dc8defef8c3fcc4aff84201cdddf67c89d0b2b6_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈpʌŋktʃuəl/ 【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "arriving or happening at the time agreed on 按时的；准时的",
                example:
                  "She's always very punctual for appointments and because of this she is highly respected.",
              },
            ],
          },
        ],
      },
      {
        word: "watercourse",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/df53f7dd13d2b98c0fcc8ba923d3eacd73912084_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈwɔːtəˌkɔːs/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C]  河道；溪流",
              },
            ],
          },
        ],
      },
      {
        word: "pontederia",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/caa36d49a5b4097bc5632e642e2f55af0afa201b_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˌpɒntəˈdɪrɪə/ 【n.】",
            explanations_and_examples: [
              {
                explanation: "[C, U] 梭鱼草",
              },
            ],
          },
        ],
      },
      {
        word: "pickerelweed",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/774244f205d321c4358815975906b7a61e26a1b7_96k.mp3#duration=1.8&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈpɪkərəlˌwiːd/【n.】",
            explanations_and_examples: [
              {
                explanation: "[C, U] 小狗鱼草",
              },
            ],
          },
        ],
      },
      {
        word: "bloom",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2d144a73234e2c889617f6e93cbb38a53b54f4af_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/bluːm/【vi.】",
            explanations_and_examples: [
              {
                explanation: " produce flower 开花",
                example:
                  "Most roses will begin to bloom from late May and the garden will be at its best.",
              },
            ],
          },
        ],
      },
      {
        word: "swarm",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ef1fbae6526f83c1c4975171d5557eb637ff1c19_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/swɔːm/【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "(of people, animals, etc.) move around in a large group （人、动物等）成群地来回移动",
                example:
                  " Every day tourists swarm through the narrow streets of the old city.",
              },
            ],
          },
        ],
      },
      {
        word: "perpetual",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/54b9ff6e9186a06a28d444fd63f9216e37ce706c_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/pəˈpetʃuəl/【a.】",
            explanations_and_examples: [
              {
                explanation: "continuing all the time 长期的；永恒的",
                example:
                  " I thought her perpetual complaints were going to prove too much for me.",
              },
            ],
          },
        ],
      },
      {
        word: "gala",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f53c4a7b79cb4133c4b1158b2ef9fdfad70988a8_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈgɑːlə/【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] a special performance or event to celebrate sth. 特别演出；欢庆活动；庆典",
                example:
                  " We ate dinner and watched the Spring Festival Gala together on New Year's Eve.",
              },
            ],
          },
        ],
      },
      {
        word: "ornament",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/702d4a123ca387139b8eafbbaacddf45c11fff52_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɔːnəmənt/【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C]a small attractive object used for decoration or for making sb. / sth. more beautiful 装饰品；点缀品",
                example:
                  "I guessed he was the chief because he wore more gold ornaments than the others.",
              },
            ],
          },
        ],
      },
      {
        word: "dewy",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d0f4eada0e102a75263940d871eeab4632597ef8_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈdjuːi/【a.】",
            explanations_and_examples: [
              {
                explanation: "wet with drops of dew 带露水的",
                example:
                  " The grass was dewy, the apples green and raw, but already fragrant",
              },
            ],
          },
        ],
      },
      {
        word: "orchard",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/c07ef83ea8b6498431be6be22d87c424cd3f9f52_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɔːtʃəd/【n.】",
            explanations_and_examples: [
              {
                explanation: "果园",
                example:"",
              },
            ],
          },
        ],
      },
      {
        word: "blossom",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/5471a8f43d4c11d028d57f7fff26c128da34ff4d_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈblɒs(ə)m/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C, U]a flower on a tree, or all the flowers on a tree （一棵树上的）花，全部花朵",
                example: " Rain begins to fall and peach trees are in blossom.",
              },
            ],
          },
        ],
      },
      {
        word: "mock",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3e16eb8afa5dec2756b1c58c93d166b3bf1b39fd_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/mɒk/ 【v.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml.) laugh at sb. / sth. in an unkind way, esp. by copying what they say or do 嘲弄；（通过模仿）取笑",
                example:
                  "The other children mocked the girl's French accent, laughing behind their hands.",
              },
            ],
          },
        ],
      },
      {
        word: "mere",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3e32a26cdb0e6b41cfcab59a70a7519abb161ce2_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/mɪə/【a.】",
            explanations_and_examples: [
              {
                explanation:
                  "used to emphasize how small or unimportant sb. / sth. is 仅仅的，只不过（用于强调小或微不足道）",
                example:
                  "We don't consider our customers to be mere consumers; we consider them to be our friends. ",
              },
            ],
          },
        ],
      },
      {
        word: "tinsel",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/ad8a1c31015fe417db5b991445ec3cb2a3662193_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈtɪnsl/【n.】",
            explanations_and_examples: [
              {
                explanation: "[U] （装饰用的）闪光纸",
              },
            ],
          },
        ],
      },
      {
        word: "shimmer",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/050b72e5bda7026fa62a54d16c24edc49670be54_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈʃɪmə/【vi.】",
            explanations_and_examples: [
              {
                explanation:
                  "shine with a soft light that looks as if it shakes slightly 发微光；闪闪发亮",
                example:
                  " My thoughts shimmer with the shimmering leaves and my heart sings with the touch of this sunlight.",
              },
            ],
          },
        ],
      },
      {
        word: "clutch",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/75a1ac249ce225a3f9021d98d11901e1f275cfaf_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/klʌtʃ/【vt.】",
            explanations_and_examples: [
              {
                explanation:
                  "hold sth. tightly because one does not want to lose it 紧握；紧抓",
                example:
                  "The young man stood in the doorway, his invitation clutched tightly in his hand.",
              },
            ],
          },
        ],
      },
      {
        word: "mirage",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/bffebb4c225ac05a0e2e0e56d132712531310ab4_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmɪrɑːʒ/ 【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "[C] an effect caused by hot air in deserts, at sea, or on roads which makes you think that you can see objects when they are not actually there 幻景；海市蜃楼",
                example:
                  "She thought at first it must be the edge of the sea, then realized it was a mirage. ",
              },
            ],
          },
        ],
      },
      {
        word: "diligence",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/f51bcb5b55270fbb3f2b41dbebfb9ccd42597cbd_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈdɪlɪdʒ(ə)ns/【n.】",
            explanations_and_examples: [
              {
                explanation:
                  "(fml.)the attitude or behavior of sb. who works very hard and very carefully 勤奋；用功",
                example:
                  " We should cultivate the good habits of diligence and frugality.",
              },
            ],
          },
        ],
      },
      {
        word: "herald",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/3b9fa37e6681b640eb8c3e5eb7d79ee822e24a9f_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈherəld/【n.】",
            explanations_and_examples: [
              {
                explanation: "[C] a sign that sth. is soon going to happen 预兆",
                example:
                  " If this first opera of the season is a herald of what is to come, we can expect great things. ",
              },
            ],
          },
        ],
      },
      {
        word: "inward",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/b2351267c6e5ef215affa84073fe11cc54d76812_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈɪnwəd/ 【a.(written)】",
            explanations_and_examples: [
              {
                explanation:
                  "1) felt or experienced in your own mind but not expressed to other people 内心的；精神的",
                example:
                  " She watched his expression, saw the relaxation of his features, and breathed an inward sigh of relief. ",
              },
              {
                explanation:
                  "2) toward the inside or center of sth. 向内的；向中心的",
                example:
                  "The car was not severely damaged — only the middle of the car door was bent inward.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Phrases and expressions",
    children: [
      {
        word: "take the time",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d06d68f7fd1b98c9d532f3642b7a58dfba20ccc6_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "make the effort to do sth. 花费力气（做某事）",
                example: "Take the time to stop and smell the flowers.",
              },
            ],
          },
        ],
      },
      {
        word: "count for",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/4b5e45342ee1ae3ff3affac36f9e59fb492713da_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "be important or valuable 有价值；有重要性",
                example:
                  "When I first came to college, I realized that brainpower didn't count for much.",
              },
            ],
          },
        ],
      },
      {
        word: "for heaven's sake",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/6e5e7b94ff56de1294337d9ce1183290a194acb0_96k.mp3#duration=1.7&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "used when sb. is telling sb. else how important it is to do sth. or not to do sth. 看在上帝份上（表示某事很重要）",
                example:
                  "For heaven's sake, don't be late. Otherwise, we won't be able to catch the plane.",
              },
            ],
          },
        ],
      },
      {
        word: "drink in",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/8b5204e968b902d1fc851099ab655baeed85b97b_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "look at, listen to, feel, or smell sth. in order to enjoy it 享受地看（听，感觉，嗅）；品味；欣赏）",
                example:
                  "She just sat there, drinking in the stunning view of sunset.",
              },
            ],
          },
        ],
      },
      {
        word: "run riot",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/d8226d0cf49619d6dbe78edce99dc6a5415cd174_96k.mp3#duration=1.6&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "go out of control （想象力）自由驰骋；（情感、思绪等）不受约束",
                example:
                  "They have let their imagination run riot to create new computer games.",
              },
            ],
          },
        ],
      },
      {
        word: "at length",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/fcef905543f95005038f2b7d53f84ac2986eeba1_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation: "after a long time 最后；终于",
                example:
                  'At length she became uneasy, and wakened the boy and asked, "Do you know where your dad is?',
              },
            ],
          },
        ],
      },
      {
        word: "so long as",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/da79aa123929eba4ca0f8f20491fe6f5e7080cd1_96k.mp3#duration=4.5&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  " used before saying the conditions that will make sth. else happen or be true 只要",
                example:
                  "So long as you try your best, it doesn't matter whether you win or not",
              },
            ],
          },
        ],
      },
      {
        word: "and the like",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/96289d6511e327b8044731421e005421fb96db88_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            explanations_and_examples: [
              {
                explanation:
                  "used for including other similar people or things in what you are saying 诸如此类；等等",
                example:
                  "Many words are compounds, such as blackboard, inkpot, bookstore, and the like.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Proper names",
    children: [
      {
        word: "Mallard",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/a02dda622447d0c5352ffa662639a9aca9106b17_96k.mp3#duration=1.1&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈmælərd/",
            explanations_and_examples: [
              {
                explanation: "马拉德（人名)",
              },
            ],
          },
        ],
      },
      {
        word: "Josephine",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/becb2666eeeb0ce6f83b0cb5e6778a54479d6ba2_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "ˈdʒəʊzəfiːn/",
            explanations_and_examples: [
              {
                explanation: "约瑟芬（人名）",
              },
            ],
          },
        ],
      },
      {
        word: "Richards",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/dd13fa0947c95f6023a31fdb8b1179091c1515f8_96k.mp3#duration=1.3&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈrɪtʃədz/",
            explanations_and_examples: [
              {
                explanation: "理查兹（人名)",
              },
            ],
          },
        ],
      },
      {
        word: "Assyria",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/2d51c698dfed786257b203a3fe1cb5c77c519a19_96k.mp3#duration=1.5&t=.mp3",
        pee: [
          {
            partOfSpeech: "/əˈsɪrɪə/",
            explanations_and_examples: [
              {
                explanation: "亚述（古代东方奴隶制国家）",
              },
            ],
          },
        ],
      },
      {
        word: "Paphos",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/56fbd7c00b450cf0bef8790064fbe65c9754c9c0_96k.mp3#duration=1.4&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈpeɪfɒs/",
            explanations_and_examples: [
              {
                explanation: "帕福斯（塞浦路斯西南部古城）",
              },
            ],
          },
        ],
      },
      {
        word: "Homer",
        audio:
          "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_3+20220218/resource/audio/7ffe36f625ba4da5efe457b0a8c221da7ea6af49_96k.mp3#duration=1.2&t=.mp3",
        pee: [
          {
            partOfSpeech: "/ˈhəʊmər/",
            explanations_and_examples: [
              {
                explanation: "荷马（古希腊诗人）",
              },
            ],
          },
        ],
      },
    ],
  },
];
export default book3;
